(function () {
  'use strict';

  angular.module('BlurAdmin.pages', [
    'ui.router',
    'BlurAdmin.pages.dashboard',
    'BlurAdmin.pages.realtime',
    'BlurAdmin.pages.administration',
    'BlurAdmin.pages.profile',
    'BlurAdmin.pages.content',
    'BlurAdmin.pages.player',
    'BlurAdmin.pages.login',
    'BlurAdmin.pages.changepass',
    'BlurAdmin.pages.dvr',
    'BlurAdmin.pages.scheduler',
    'BlurAdmin.pages.playlists',
    'environment',
    'satellizer',
    'angular-hmac-sha512',
    "ng",
    "ngAnimate",
    "ngAria",
    'ngMaterial'
  ])
   .config(routeConfig)
   .config(authConfig)
   .config(function($mdDateLocaleProvider) {
      $mdDateLocaleProvider.formatDate = function(date) {
         return moment(date).format('DD-MM-YYYY');
      }
    });

  function routeConfig($urlRouterProvider, $httpProvider, envServiceProvider) {   
      envServiceProvider.config({
          domains: {
              prod: ['*'],
          },
          vars: {
            development: {
                apiUploads: 'http://localhost:8000',
                apiUrl: 'https://testapi.vodgc.net',
                prefix: 'http://',
                socketServer: 'http://localhost:9666',
                S3ButcketThumbs: 'http://devgenoa-thumbs.s3-website-us-east-1.amazonaws.com',
                rtUrl: 'http://localhost:9444',
                clippingUrl: 'https://testclipping.vodgc.net'
                //apiUrl: 'http://api.vod.plus',
            },
            devRemote: {
                apiUploads: 'https://devuploads.vodgc.net',
                apiUrl: 'https://devapi.vodgc.net',
                prefix: 'https://',
                socketServer: 'https://devsocket.vodgc.net',
                S3ButcketThumbs: 'http://devgenoa-thumbs.s3-website-us-east-1.amazonaws.com',
                rtUrl: 'https://devrtbackend.vodgc.net',
                clippingUrl: 'https://testclipping.vodgc.net'
            },
            test: {
                apiUploads: 'https://testuploads.vodgc.net',
                apiUrl: 'https://testapi.vodgc.net',
                prefix: 'https://',
                socketServer: 'https://testsocket.vodgc.net',
                S3ButcketThumbs: 'http://devgenoa-thumbs.s3-website-us-east-1.amazonaws.com',
                rtUrl: 'https://testrtbackend.vodgc.net',
                clippingUrl: 'https://testclipping.vodgc.net'
            },
            prod: {
                apiUploads: 'https://uploads.vodgc.net',
                apiUrl: 'https://api.vodgc.net',
                prefix: 'https://',
                socketServer: 'https://socket.vodgc.net',
                S3ButcketThumbs: 'http://genoa-thumbs.s3-website-us-east-1.amazonaws.com',
                rtUrl: 'https://rtbackend.vodgc.net',
                clippingUrl: 'https://clipping.vodgc.net'
            }
          }
      });
      envServiceProvider.check();
     $urlRouterProvider.otherwise('/login');
  }
  function authConfig($authProvider, envServiceProvider, $crypthmacProvider) {   
      //Config auth
      var apiUrl = envServiceProvider.read('apiUrl');
      $authProvider.loginUrl = apiUrl + "/auth/login";
      $authProvider.tokenName = "token";
      $authProvider.tokenPrefix = "vodgc";
      $crypthmacProvider.setCryptoSecret('@#!_@');
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'textAngular',
      'BlurAdmin.theme.components'
  ]);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.changepass', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('change-password', {
          url: '/change-password',
          title: '',
          cache: false,
          templateUrl: 'app/pages/changepass/changepass.html'
        })        
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('administration', {
          url: '/administration',
           templateUrl: 'app/pages/administration/administration.html',
           abstract: true,
           cache: false,
          title: 'Administration',
          sidebarMeta: {
            icon: 'ion-gear-a',
            order: 500
          },
        })
        .state('administration.users', {
          url: '/users',
          templateUrl: 'app/pages/administration/users/users_list.html',
          cache: false,
          title: 'Users',
          sidebarMeta: {
            order: 200
          }
        })
        .state('edit', {
          url: '/administrator/user/edit',
          templateUrl: 'app/pages/administration/users/user.html',
          params: {user: null},
          cache: false,
          title: 'User Edit'
        })
        .state('create', {
          url: '/administrator/user/create',
          templateUrl: 'app/pages/administration/users/user.html',
          cache: false,
          title: 'New User'
        })       
        .state('administration.profiles', {
          url: '/profiles',
          templateUrl: 'app/pages/administration/profiles/profile_groups_list.html',
          title: 'Profiles',
          cache: false,
          sidebarMeta: {
            order: 300
          }
        })
        .state('profiles-edit', {
          url: '/administrator/profiles/edit',
          templateUrl: 'app/pages/administration/profiles/profileGroup.html',
          params: {group: null},
          cache: false,
          title: 'Profiles Group Edit'
        })
        .state('profiles-create', {
          url: '/administrator/profiles/create',
          templateUrl: 'app/pages/administration/profiles/profileGroup.html',
          cache: false,
          title: 'New Profile Group'
        })
        /*.state('administration.publishers', {
          url: '/publishers',
          templateUrl: 'app/pages/administration/publishers/publishers_list.html',
          title: 'GID & PID Manager',
          cache: false,
          sidebarMeta: {
            order: 100
          }
        })*/
        /*.state('administration.schemaList', {
          url: '/schemas',
          templateUrl: 'app/pages/administration/schema/schema-list.html',
          title: 'Schemas',
          cache: false,
          sidebarMeta: {
            order: 100
          }
        })
        .state('administration.schemasEdit', {
          url: '/schema/edit',
          templateUrl: 'app/pages/administration/schema/schema.html',
          title: 'Edit Schema',
          params: {schema: null, type: 'edit'},
          cache: false
        })
        .state('administration.schemasNew', {
          url: '/schema/create',
          templateUrl: 'app/pages/administration/schema/schema.html',
          title: 'New Schema',
          params: {schema: null, type: 'create'},
          cache: false
        })*/
        .state('administration.publishersAbm', {
          url: '/publishers/conf',
          templateUrl: 'app/pages/administration/publishers/abm_publishers_list.html',
          title: 'Publishers',
          cache: false,
          sidebarMeta: {
            order: 100
          }
        })
        .state('administration.credentials', {
          url: '/credentials',
          templateUrl: 'app/pages/administration/credentials/credentials.html',
          title: 'Credentials',
          cache: false,
          sidebarMeta: {
            order: 50
          }
        })
        .state('administration.transcoder', {
          url: '/transcoder-settings',
          templateUrl: 'app/pages/administration/transcoder/transcoder_options.html',
          cache: false,
          title: 'Transcoders',
          sidebarMeta: {
            order: 20
          }
        })        
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components', [
    'BlurAdmin.pages.components.mail',
    'BlurAdmin.pages.components.timeline',
    'BlurAdmin.pages.components.tree',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    // $stateProvider
    //     .state('components', {
    //       url: '/components',
    //       template : '<ui-view></ui-view>',
    //       abstract: true,
    //       title: 'Components',
    //       sidebarMeta: {
    //         icon: 'ion-gear-a',
    //         order: 100,
    //       },
    //     });
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.content', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('content', {
          url: '/content',
          templateUrl: 'app/pages/content/contentDummy.html',
          abstract: true,
          cache: false,
          title: 'Content',
          sidebarMeta: {
            icon: 'fa fa-file-video-o',
            order: 600,
          },
        })
        .state('content.media-content', {
          url: '/media-content',
          title: 'Media Content',
          templateUrl: 'app/pages/content/mediaContent/mediaContent.html',
          controller: 'ContentCtrl',
          cache: false,
          sidebarMeta: {
            order: 700
          }
        })
        .state('content.categories', {
          url: '/categories',
          title: 'Categories',
          templateUrl: 'app/pages/content/categories/categories.html',
          cache: false,
          sidebarMeta: {
            order: 800
          }
        })
        .state('content-edit', {
          url: '/media-content/:content_id',
          title: 'Content Edit',
          templateUrl: 'app/pages/content/mediaContent/contentEdit.html',
          cache: false,
          params: {content_id: null, name: null},
        })

        .state('content.media-content.category', {
          url: '/category?id&page',
          title: 'Media Content',
          cache: false
        });
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {    
    $stateProvider
        .state('dashboard', {
          url: '/dashboard',
          templateUrl: 'app/pages/dashboard/dashboard.html',
          title: 'Dashboard',
          cache: false,
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },
        });
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dvr', [])
      .config(routeConfig);

  function routeConfig($stateProvider) {
    /*$stateProvider
        .state('dvr', {
          url: '/dvr',
          title: 'DVR',
          templateUrl: 'app/pages/dvr/dvr.html',
          cache: false,
          sidebarMeta: {
            icon: 'ion-ios-videocam',
            order: 800
          }
        })
        .state('window', {
          url: '/frame',
          title: '',
          templateUrl: 'app/pages/dvr/dvrWindow.html',
          cache: false,
          params: {id: null, cid: null, pid: null},
        });
    */
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.login', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('login', {
          url: '/login',
          title: '',
          cache: false,
          templateUrl: 'app/pages/login/auth.html',
          params:{recoveryMode: false}
        })

        .state('recovery', {
          url: '/login',
          title: '',
          cache: false,
          templateUrl: 'app/pages/login/auth.html',
          params: {recoveryMode: true}
        })
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.player', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('player-list', {
          url: '/player-list',
          title: 'Players',
          templateUrl: 'app/pages/player/playerList.html',
          controller: 'PlayerListCtrl',
          cache: false,
          sidebarMeta: {
            icon: 'fa fa-youtube-play',
            order: 800
          }
        })
        .state('player-edit', {
          url: '/player-edit',
          title: 'Edit Player Settings',
          cache: false,
          templateUrl: 'app/pages/player/playerSettings.html',
          params: {type: null, player_id: null},
        })
        .state('player-new', {
          url: '/player-new',
          cache: false,
          title: 'Create a new custom player',
          templateUrl: 'app/pages/player/playerSettings.html',
          params: {type: null},
        })        
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.playlists', [])
      .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider
        .state('playlists', {
          url: '/playlists',
          title: 'Playlists',
          templateUrl: 'app/pages/playlists/playlists.html',
          cache: false,
          sidebarMeta: {
            icon: 'fa fa-headphones',
            order: 800
          }
        })
        .state('newPlaylist', {
          url: '/playlists/create',
          title: 'New Playlist',
          templateUrl: 'app/pages/playlists/playlistModify.html',
          cache: false,
        })
        .state('editPlaylist', {
          url: '/playlists/edit',
          title: 'Edit Playlist',
          templateUrl: 'app/pages/playlists/playlistModify.html',
          params: {id: null},
          cache: false,
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('profile', {
          url: '/profile',
          title: 'Profile',
          cache: false,
          templateUrl: 'app/pages/profile/profile.html'
        });
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.realtime', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {    
    $stateProvider
        .state('realtime', {
          url: '/realtime',
          templateUrl: 'app/pages/realtime/realtime.html',
          title: 'Realtime',
          cache: false,
          sidebarMeta: {
            icon: 'fa fa-line-chart',
            order: 500,
          },
        });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.scheduler', [])
      .config(routeConfig);

  function routeConfig($stateProvider) {
    /*$stateProvider
        .state('scheduler', {
          url: '/scheduler',
          title: 'Live Hub',
          templateUrl: 'app/pages/scheduler/scheduler.html',
          cache: false,
          sidebarMeta: {
            icon: 'ion ion-record',
            order: 900
          }
        })
    */
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('components.mail', {
          url: '/mail',
          abstract: true,
          templateUrl: 'app/pages/components/mail/mail.html',
          controller: "MailTabCtrl",
          controllerAs: "tabCtrl",
          title: 'Mail',
          sidebarMeta: {
            order: 0,
          },
        }).state('components.mail.label', {
          url: '/:label',
          templateUrl: 'app/pages/components/mail/list/mailList.html',
          title: 'Mail',
          controller: "MailListCtrl",
          controllerAs: "listCtrl"
        }).state('components.mail.detail', {
          url: '/:label/:id',
          templateUrl: 'app/pages/components/mail/detail/mailDetail.html',
          title: 'Mail',
          controller: "MailDetailCtrl",
          controllerAs: "detailCtrl"
        });
    $urlRouterProvider.when('/components/mail','/components/mail/inbox');
  }

})();

/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree', [])
    .config(routeConfig)
    .config(function(){
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components.tree', {
          url: '/tree',
          templateUrl: 'app/pages/components/tree/tree.html',
          title: 'Tree View',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 1/12/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('components.timeline', {
        url: '/timeline',
        templateUrl: 'app/pages/components/timeline/timeline.html',
          title: 'Timeline',
          sidebarMeta: {
            icon: 'ion-ios-pulse',
            order: 100,
          },
      });
  }
})();
'use strict';

angular.module('BlurAdmin', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',
  'BlurAdmin.theme',
  'BlurAdmin.pages',
  'environment',
  'color.picker',
  'ngMaterial'
]);
(function () {
  'use strict';

  angular.module('BlurAdmin.pages')
      .controller('LoginCtrl', LoginCtrl);

  /** @ngInject */
  function LoginCtrl($scope, $state, $rootScope, $auth, Auth, $http, $sce, $location, $crypthmac, $stateParams, toastr) {
  		var vm   		   = this;
		vm.error   	       = '';
		vm.errorUser       = '';
		vm.loading 	       = false;
		vm.user_logged     = '';
		vm.getCategories   = null;
		vm.template_login  = !$stateParams.recoveryMode;
		vm.recoveryMail    = '';
		vm.recoveryDisable = false;
		vm.recoveryMode    = $stateParams.recoveryMode;
		vm.pass1 		   = '';
		vm.pass2 	       = '';
		vm.apiUrl          = $rootScope.apiUrl;
		vm.groups          = [];
		vm.selected_group  = '';
		
		if($stateParams.recoveryMode){
			$rootScope.showContent = false;
		}
		
  		//Activo o desactivo pagetop sidebar, breadcrumb 		
		$scope.$watch($state.current.name, function() {
	  		if($state.current.name != 'login'){
	  			$rootScope.showContent = true;
	  		}else{
	  			$rootScope.showContent = false;
	  		}
     	});
		$scope.session  = JSON.parse(localStorage.getItem('session'));
     	vm.fetchGroups = function(){
      		var settings = {
			  "crossDomain": true,
			  "url": $rootScope.apiUrl + "/api/v1/groups/list/all?little=true",
			  "method": "GET"			  
			}

			$.ajax(settings).done(function (response) {
			  	vm.groups = response.map(function(group){
			  		if(group.id == $scope.session.group_id){
		        		vm.selected_group = group.id;
			  		}
		            return {"id" : group.id, "name" : group.name }
		        });
		        $scope.$apply();
			});
      	}
		if($scope.session != null){
			vm.fetchGroups();
			var now 	  = new Date();
			var exp_date  = new Date($scope.session.expiration);
			//Si no esta expirado puede continuar
			if(exp_date >= now){
				if($scope.session.cg_pass){
					$location.path('change-password');
				}else{
					$rootScope.showContent = true;
					//$location.path('dashboard');
				}
				Auth.socket();
			}else{
				localStorage.removeItem('session');
				localStorage.removeItem('categories');
				$location.path('login');
			}
		}      	
      	vm.changeAccount = function(){
      		$('#grupos_selection').prop('disabled', true);
      		if(vm.selected_group != ''){
	      		//Cambio grupo
	      		var form = new FormData();
				form.append("client_id", $scope.session.client_id);
				form.append("email", $scope.session.email);
				form.append("gid", vm.selected_group);

				var settings = {
				  "crossDomain": true,
				  "url": $rootScope.apiUrl + "/api/v1/groups/change",
				  "method": "POST",
				  "processData": false,
				  "contentType": false,
				  "mimeType": "multipart/form-data",
				  "data": form
				}

				$.ajax(settings).success(function (response) {
					toastr.success('Group changed', 'Request Group Change');
					$('#grupos_selection').prop('disabled', false);
				  	vm.logout();
				});
      		}
      	}
		vm.login = function(){
			localStorage.removeItem('session');
			localStorage.removeItem('categories');
			vm.encrypted_pass = $crypthmac.encrypt(vm.password,"");
			vm.loading = true;
			$auth.login({
            	email: vm.email,
            	password: vm.encrypted_pass
	        })
	        .then(function(response){
	        	vm.error    	   = '';
	        	vm.loading  	   = false;
	            var session 	   = response.data;
	            var now            = new Date();
	            session.expiration = new Date(now.setHours(now.getHours()+9));
	            localStorage.setItem('session', JSON.stringify(session));
	            $scope.session  = JSON.parse(localStorage.getItem('session'));
	            vm.user_logged  = $scope.session.name;
	            var settings = {
			        "async": true,
			        "crossDomain": true,
			        "url": $rootScope.apiUrl + "/api/v1/categories",
			        "data":{'client_id': $scope.session.client_id },
			        "method": "POST",
			        "headers": {
				  	  "cache-control": "no-cache",
				  	}
			    }
			    $.ajax(settings).done(function(response) {
			        localStorage.setItem('categories', JSON.stringify(response));
			    })
				if($scope.session.cg_pass){
					$location.path('change-password');
				}else{
					$rootScope.showContent = true;
					$location.path('dashboard');
				}	            
	        })
	        .catch(function(result){
	        	vm.loading = false;
	        	vm.error   = result.data.error;
	        });
		}		
		vm.logout = function(){
			$scope.session = JSON.parse(localStorage.getItem('session'));
	          var settings   = {
	            "async": true,
	            "crossDomain": true,
	            "url": $rootScope.apiUrl + '/auth/logout',
	            "data": {'client_id': $scope.session.client_id},
	            "method": "POST"
	          }
            $.ajax(settings).done(function(response) {
				$auth.removeToken();
	            localStorage.removeItem('session');
	            localStorage.removeItem('categories');
            	for (var i = 1; i < 99999; i++){
				    window.clearInterval(i);
				}
				$rootScope.showContent = false;
				$state.go('login', {}, {reload: true});
          	})
          	.error(function(error){
          		//console.log(error);
	        });		
		}
	    vm.showForgotpassword = function(){
	    	vm.template_login = false;
	    }
	    vm.cancel = function(){
	    	vm.template_login = true;
	    }
	    vm.requestChangePassword = function(){
	    	vm.loading = true;
	    	if(vm.recoveryMail != ''){
	    		var str2Hash = $crypthmac.encrypt(vm.randomString(10));
	    		var settings = {
				  "async": true,
				  "crossDomain": true,
				  "url": $rootScope.apiUrl + "/auth/passwordRecovery",
				  "data": { 
				  		"email": vm.recoveryMail,
				  		"hash": str2Hash
				  },
				  "method": "POST",
				  "headers": {
				    "cache-control": "no-cache",
				  }
				}

				$.ajax(settings)
				.success(function (response) {
					vm.errorUser = '';
					vm.recoveryDisable = true;
					vm.loading = false;
					$scope.$apply();
				   	alert("We sent to you a mail, please check and continue with the recovery steps!");
				})
				.error(function (response) {
				   	vm.loading = false;
				   	console.log(response);
				   	vm.errorUser = 'The mail requested is not registred like Genoa User, please check your mail and try again';
				   	$scope.$apply();
				});
	    	}else{
	    		alert("Please Insert a mail to send the recovery link!");
	    	}
	    }
	    vm.randomString = function(len){
		    var text = "";
		    var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
		    for( var i=0; i < len; i++ ){
		        text += charset.charAt(Math.floor(Math.random() * charset.length));
		    }
		    return text;
		}		
		vm.changePassword   = function(){
	      	if((typeof(vm.pass1) != 'undefined') && (typeof(vm.pass2) != 'undefined') && ($('#code').val() != '')){
	      		var validation = vm.validatePassword(vm.pass1,vm.pass2);
	      		if(!validation){
	      			vm.error = 'Password not matching with rules';
	      		}else{
					$scope.loading 	  = true;
	      			vm.error 		  = '';
		      		vm.encrypted_pass = $crypthmac.encrypt(vm.pass1,"");
				
					var settings   = {
			            "async": true,
			            "crossDomain": true,
			            "data": {
			            	"type": 'forgot_password',
			            	"validation": $('#code').val(), 
			            	"password": vm.encrypted_pass,			            	
			            },
			            "url": $rootScope.apiUrl + '/auth/changePassword',
			            "method": "POST"
		          	}

		            $.ajax(settings).done(function(response) {
		            	toastr.success(response.info, 'Password Security');
		            	$scope.loading 	 = false;
		            	localStorage.removeItem('session');
		            	vm.template_login = true;
						vm.recoveryMode   = false;
 						location.reload(); 
		          	})
		          	.error(function(error){
		          		toastr.error("code not valid", 'Error');
			            vm.error = "code not valid";
			            $scope.loading   = false;
			        });
					
	      		}
	      	}else{
	      		return false;	
	      	}
	    }
      	vm.validatePassword = function(pass1,pass2){
            var validator = ((pass1 == pass2) && (/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(pass1)));
	      	return validator;
      	}

  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages')
 	.factory('Auth', function($rootScope, $state, toastr){
		return{
		    isLoggedIn : function(){
		    	//Aca entro en cada ruta cuando chequeo session levantar permisos de rutas
				var session  = JSON.parse(localStorage.getItem('session'));
				if(session != null){					
					var now 	  = new Date();
					var exp_date  = new Date(session.expiration);
					//Si no esta expirado puede continuar
					if(exp_date >= now){
						var settings = {
						  "async": true,
						  "crossDomain": true,
						  "url": $rootScope.apiUrl + "/auth/checkSession",
						  "data": {
						  		'client_id': session.client_id
						   },
						  "method": "POST",
						  "headers": {
						    "cache-control": "no-cache",
						  }
						}

						$.ajax(settings).done(function (response) {
						  if(!response.logged_in){
						  	localStorage.removeItem('session');
				            localStorage.removeItem('categories');
							$rootScope.showContent = false;
							$state.go('login', {}, {reload: true});
						  }
						});
						$rootScope.showContent = true;
						return true;
					}
				}
				return false;
		    },
		    socket: function(){
				var socket  = io.connect($rootScope.socketServer);
				var session = JSON.parse(localStorage.getItem('session'));
			    socket.emit('session', session);
			    socket.on('updateCategory', function (data) {
			       	var settings = {
				        "async": true,
				        "crossDomain": true,
				        "url": $rootScope.apiUrl + "/api/v1/categories",
				        "data":{'client_id': session.client_id },
				        "method": "POST"
				    }
				    $.ajax(settings).done(function(response) {
				        localStorage.setItem('categories', JSON.stringify(response));
				        console.log("actualizo categorias..");
				        if(typeof($('#treeCategories')) != 'undefined'){
					        $('#treeCategories').jstree(true).settings.core.data = JSON.parse(localStorage.getItem('categories'));
					        $('#treeCategories').jstree("refresh");
				        }
				    })
			    });
			    socket.on('console', function (msg) {
			    	if(msg == 'quit'){
			    		$('#console').html($('#console').html() + "<br>" + moment().format('DD/MM/YYYY hh:mm-A') + ": <span style='color: green'>Finished!</span>");
			    		$("#console").animate({ scrollTop: $(document).height() }, "slow");
			    		toastr.success("The files is ready in Genoa!", 'Success');
			    		if(typeof($('#refresh-content')) != 'undefined'){
			    			$('#refresh-content').prop("disabled", false);
			    			$rootScope.$emit('refreshFeeds');
			    		}
			    	}else{
			    		var colorMsg = msg.replace("Task ended.", "<span style='color: green'>Task ended.</span>");
						colorMsg = colorMsg.replace("Transcoding", "<span style='color: orange'>Transcoding</span>");
						colorMsg = colorMsg.replace("COMPLETED", "<span style='color: green'>COMPLETED</span>");
						colorMsg = colorMsg.replace("PROGRESSING", "<span style='color: orange'>PROGRESSING</span>");
						colorMsg = colorMsg.replace("WARNING", "<span style='color: yellow'>WARNING</span>");
						colorMsg = colorMsg.replace("ERROR", "<span style='color: red'>ERROR</span>");
			    		console.log(colorMsg);
			    		$('#console').html($('#console').html() + "<br>" + moment().format('DD/MM/YYYY hh:mm-A') + ': ' + colorMsg);
			    		$("#console").animate({ scrollTop: $(document).height() }, "slow");
			    		if(msg == 'Task ended.' || msg.includes('COMPLETED')){
			    			$rootScope.$emit('refreshFeeds');
			    		}
			    	}
			    });
				return true;
		    }
	    }
	})
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages')
  .run(function($rootScope, envService, $location, Auth, $state) {
      	$rootScope.environment     = envService.get();
      	$rootScope.apiUrl          = envService.read('apiUrl');
        $rootScope.apiUploads      = envService.read('apiUploads');
        $rootScope.prefix          = envService.read('prefix');
        $rootScope.socketServer    = envService.read('socketServer');
        $rootScope.S3ButcketThumbs = envService.read('S3ButcketThumbs');
        $rootScope.rtUrl           = envService.read('rtUrl');
        $rootScope.clippingUrl     = envService.read('clippingUrl');
        $rootScope.session_change  = false;
		    $rootScope.$on('$stateChangeStart', function(){          
	        if(!Auth.isLoggedIn()) {
            $location.path('login');
	        }
	      });

  });

})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper) {
    baConfigProvider.changeTheme({blur: false});
    
    baConfigProvider.changeColors({
     default: '#ffffff',
     defaultText: '#ffffff',
     dashboard: {
       white: '#ffffff',
     },
    });
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.changepass')
       .controller('ChangePassCtrl', ChangePassCtrl);

  /** @ngInject */
  function ChangePassCtrl($rootScope,$scope,$crypthmac,$http, $sce,$state) {
	    var vm   				 = this;
	    vm.error 				 = '';
	    vm.pass1 				 = '';
	    vm.pass2 				 = '';
	    $rootScope.showContent   = false;
	    $scope.loading 		     = false;
	    $scope.session  		 = JSON.parse(localStorage.getItem('session'));

	    vm.changePassword   = function(){
	      	if((typeof(vm.pass1) != 'undefined') && (typeof(vm.pass2) != 'undefined')){
	      		var validation = vm.validatePassword(vm.pass1,vm.pass2);
	      		if(!validation){
	      			vm.error = 'Password not matching with rules';
	      		}else{
	      			$scope.loading 	  = true;
	      			vm.error 		  = '';
		      		vm.encrypted_pass = $crypthmac.encrypt(vm.pass1,"");
					var now  		  = new Date();
					var exp_date  	  = new Date($scope.session.expiration);
					//Si no esta expirado puede continuar
					if(exp_date >= now){
						var settings   = {
				            "async": true,
				            "crossDomain": true,
				            "data": {client_id: $scope.session.client_id, hash: vm.encrypted_pass},
				            "url": $rootScope.apiUrl + '/auth/changePassword',
				            "method": "POST"
			          	}

			            $.ajax(settings).done(function(response) {
			            	$scope.loading 	 = false;
			            	localStorage.removeItem('session');
			            	$state.go('login', {}, {reload: true});
			          	})
			          	.error(function(error){
				            vm.error = error.error;
				            $scope.loading   = false;
				        });
					}else{
						alert("sorry your session expired, please login again!");
						$location.path('login');
					}
	      		}
	      	}else{
	      		return false;	
	      	}
	    }
      	vm.validatePassword = function(pass1,pass2){
            var validator = ((pass1 == pass2) && (/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(pass1)));
	      	return validator;
      	}
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardCtrl', DashboardCtrl)
      .directive('trafficChart2', trafficChart2)
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function DashboardCtrl($scope, $timeout, baUtil, $rootScope, baConfig, colorHelper, $element, layoutPaths, $sce, $mdSidenav, toastr, $uibModal) {
    var vm = this;
    $scope.loading = false;
    $scope.select_publishers = "";
    $rootScope.showContent = true;
    $scope.publisher_topten = '';
    $scope.adsData = {};
    $scope.date = {
        startDate: moment().subtract(7, 'days'),
        endDate: moment()
    };
    $scope.analyticsType = 'vod_analytics';
    if(typeof(localStorage.getItem("pinned")) == 'undefined'){
      localStorage.setItem('pinned', false);
    }else{
      if(localStorage.getItem("pinned") == "true"){
        setTimeout(function() {
          $mdSidenav('right').toggle();
          $('#filter-pin').removeClass('unpined');
          $('#filter-pin').addClass('pin');
        }, 200);
      }else{
        $('#filter-pin').removeClass('pin');
        $('#filter-pin').addClass('unpined');
      }
    }

    $scope.publishers = '';
    $scope.trustSrc = function(src) {
      return $sce.trustAsResourceUrl(src);
    }
    $scope.loadPublishers  = function(){
      var client_id  = JSON.parse(localStorage.getItem('session')).client_id;
      var settings   = {
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/api/v1/publisher/restricted/" + client_id,
        "method": "GET"
      }

      $.ajax(settings).done(function(publishers) {
          $scope.publishers = publishers;
      });
    }
    $scope.reloadUserUploads = function(){
      var client_id  = encodeURIComponent(JSON.parse(localStorage.getItem('session')).client_id);
      var start = moment($scope.date.startDate);
      start.set({hour:0,minute:0,second:0});
      start = start.format("YYYY-MM-DD HH:mm:ss");
      var end   = moment($scope.date.endDate);
      end.set({hour:23,minute:59,second:59});
      end = end.format("YYYY-MM-DD HH:mm:ss");
      var settings = {
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/api/v1/graph/users/uploads?start="+ start + "&end=" + end + '&client_id=' + client_id + '&pub_ids=' + $('#select-publisher').val(),
        "method": "GET",
      }

      $.ajax(settings).done(function (response) {
          $scope.uploadByUsers = response.uploadByUsers;
          $scope.$apply();
      });
    }
    $scope.loadTrafficChart = function(analytics){
      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.uploadByCategory = analytics;
      $scope.total_upload = 0;
      $.each($scope.uploadByCategory,function(index,value){
          $scope.total_upload = $scope.total_upload + value.value;
      });
      // var ctx = document.getElementById('traffic-area2').getContext('2d');
      // var myPieChart = new Chart(ctx,{
      //     type: 'pie',
      //     data: $scope.uploadByCategory
      // });
      $scope.$apply();
    }
    $scope.loadAnalytics = function(){
      $scope.loading = true;
      var client_id  = encodeURIComponent(JSON.parse(localStorage.getItem('session')).client_id);
      var start = moment($scope.date.startDate);
      start.set({hour:0,minute:0,second:0});
      $scope.start = start.format("DD-MM-YYYY");
      start = start.format("YYYY-MM-DD HH:mm:ss");
      var end   = moment($scope.date.endDate);
      end.set({hour:23,minute:59,second:59});
      $scope.end = end.format("DD-MM-YYYY");
      end = end.format("YYYY-MM-DD HH:mm:ss");
      var settings = {
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/api/v1/analytics?start="+ start + "&end=" + end + '&client_id=' + client_id + '&pub_ids=' + JSON.parse(localStorage.getItem("session")).publishers_ids + '&group_id=' + JSON.parse(localStorage.getItem("session")).group_id + '&group_name=' + JSON.parse(localStorage.getItem("session")).group_name,
        "method": "GET"
      }

      $.ajax(settings).success(function (analytics) {
        $scope.$apply();
        $scope.renderCharts(analytics);
      })
      .error(function (error){
        //console.log(error);
        $scope.loading = false;
        $scope.$apply();
      });
    }
    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
    $scope.renderCharts = function(analytics){
      $scope.charts = [
        {
          description: 'Videos Uploads',
          stats: analytics.content_quantity,
          icon: 'file-video-o',
        },
        {
          description: 'Audios Uploads',
          stats: analytics.audio_quantity,
          icon: 'file-audio-o',
        },
        {
          description: 'Group Uploads',
          stats: analytics.group_quantity,
          icon: 'file-video-o',
        },
        {
          description: 'Group Plays',
          stats: analytics.playsGroup,
          icon: 'file-video-o',
        },
      ];
      $scope.genoa_usage_charts = [
        {
          description: 'Group Storage',
          stats: analytics.group_storage_total,
          icon: 'hdd-o',
        }
      ]

      $scope.genoa_usage_charts = $scope.genoa_usage_charts.concat(analytics.trasferredByPid);

      $scope.feed = analytics.moreWatched;
      if(analytics.uploadByCategory.length > 0){
        $scope.loadTrafficChart(analytics.uploadByCategory);
      }else{
        $scope.uploadByCategory = [];
      }

      $scope.playsPids = analytics.playsByPids;
      $timeout(function () {
        var layoutColors = baConfig.colors;
          $scope.playsByPidsChart = AmCharts.makeChart("playsByPidsChart", {
            type: 'serial',
            theme: 'blur',
            color: '#000',
            valueAxes: [
              {
                axisAlpha: 0,
                position: 'left',
                title: 'Plays',
                gridAlpha: 0.5,
                gridColor: layoutColors.border,
              }
            ],
            startDuration: 1,
            graphs: [
              {
                balloonText: '<b>[[publisher]]: [[value]]</b>',
                fillColorsField: 'color',
                fillAlphas: 0.7,
                lineAlpha: 0.2,
                type: 'column',
                valueField: 'plays'
              }
            ],
            chartCursor: {
              categoryBalloonEnabled: false,
              cursorAlpha: 0,
              zoomable: false
            },
            categoryField: 'publisher',
            categoryAxis: {
              gridPosition: 'start',
              labelRotation: 45,
              gridAlpha: 0.5,
              gridColor: layoutColors.border,
            },
            creditsPosition: 'top-right'
          });
          $scope.playsByPidsChart.dataProvider = $scope.playsPids;
          $scope.playsByPidsChart.validateData();
      }, 200);
      $scope.$apply();

      $scope.storageGraphCategories = analytics.storageGraph.categories;
      $scope.dailyPlays = analytics.dailyPlays.categories;
      $timeout(function () {
        Highcharts.chart('storageGraph', {
            chart: {
                type: 'area'
            },
            title: {
                text: 'Publishers Storage'
            },
            subtitle: {
                text: 'Storage used by publishers'
            },
            xAxis: {
                allowDecimals: false,
                categories: analytics.storageGraph.categories
            },
            yAxis: {
                allowDecimals: true,
                labels: {
                    formatter: function () {
                        return this.value  + 'GB';
                    }
                }
            },
            tooltip: {
                pointFormat: '{series.name} used <b>{point.y:,.0f}GB</b>'
            },
            plotOptions: {
                area: {
                    marker: {
                        enabled: false,
                        symbol: 'circle',
                        radius: 2,
                        states: {
                            hover: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            series: analytics.storageGraph.series
        });
        Highcharts.chart('dailyPlays', {
            chart: {
                type: 'line',
                zoomType: 'x'
            },
            title: {
                text: 'Daily Plays Per Publishers'
            },
            subtitle: {
                text: document.ontouchstart === undefined ?
                        'Click and drag in the plot area to zoom in' : 'Pinch the chart to zoom in'
            },
            xAxis: {
                categories: analytics.dailyPlays.categories
            },
            yAxis: {
                allowDecimals: false,
                title: {
                    text: ''
                }
            },
            legend: {
                enabled: true
            },
            plotOptions: {
                line: {
                    dataLabels: {
                        enabled: true
                    },
                    enableMouseTracking: false
                }
            },
            series: analytics.dailyPlays.series
        });
      }, 300);

      $scope.playsByContentGraph = analytics.playsByContentGraph.categories;
      $timeout(function () {
        Highcharts.chart('playsByContent', {
            chart: {
                type: 'area'
            },
            title: {
                text: 'Content Plays'
            },
            subtitle: {
                text: 'Plays by Content'
            },
            xAxis: {
                allowDecimals: false,
                categories: analytics.playsByContentGraph.categories
            },
            yAxis: {
                allowDecimals: false,
                labels: {
                    formatter: function () {
                        return this.value  + ' Plays';
                    }
                }
            },
            tooltip: {
                pointFormat: '{series.name} total plays: <b>{point.y:,.0f}</b>'
            },
            plotOptions: {
                area: {
                    marker: {
                        enabled: false,
                        symbol: 'circle',
                        radius: 2,
                        states: {
                            hover: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            series: analytics.playsByContentGraph.series
        });
      }, 300);

      $scope.dataTransferred = analytics.dataTransferred.categories;
      $timeout(function() {
        Highcharts.chart('dataTransferred', {
            chart: {
                type: 'area'
            },
            title: {
                text: 'Data transferred'
            },
            subtitle: {
                text: 'By publishers'
            },
            xAxis: {
                allowDecimals: false,
                categories: analytics.dataTransferred.categories
            },
            yAxis: {
              allowDecimals: true,
                title: {
                    text: 'Gigabits/s'
                },
                labels: {
                    formatter: function () {
                        return this.value + 'GB';
                    }
                }
            },
            plotOptions: {
                area: {
                    marker: {
                        enabled: false,
                        symbol: 'circle',
                        radius: 2,
                        states: {
                            hover: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            series: analytics.dataTransferred.series
        });
      }, 300);

      $scope.agentLabels = analytics.agents.labels;
      $scope.agentData   = analytics.agents.data;

      $scope.uploadByPidsLabels = analytics.uploadByPids.labels;
      $scope.uploadByPidsData   = analytics.uploadByPids.data;
      $scope.uploadByUsers      = analytics.uploadByUsers;
      $scope.topTenPlayed       = analytics.topTenPlayed;
      $scope.loadPublishers();

      function loadPieCharts() {
        $('.chart').each(function () {
          var chart = $(this);
          chart.easyPieChart();
        });
      }


      $timeout(function () {
        loadPieCharts();
      }, 1000);

      var fistPublisher = JSON.parse(localStorage.getItem('session')).publishers_ids.split(",")[0];
      $('#dailyAdsPlays').val(fistPublisher);
      $scope.select_publisherAds = fistPublisher;
      $scope.loadAdsByPids(fistPublisher);

      $scope.loading = false;
    }
    $scope.updateDate = function(){
      $scope.loadAnalytics();
    }
    $scope.toggleRight = buildToggler('right');
    $scope.updateAnalyticsType = function(type){
      $scope.analyticsType = type;
    }
    $scope.updateFilterDate = function(range){
      var ranges = {
          today: {
              start: moment(),
              end:   moment(),
          },
          yesterday:    {
              start: moment().subtract(1, 'days'),
              end:   moment(),
          },
          last_7:     {
              start: moment().subtract(7, 'days'),
              end:   moment(),
          },
          last_30:    {
              start: moment().subtract(30, 'days'),
              end:   moment(),
          },
          last_3m:    {
              start: moment().subtract(3, 'months'),
              end:   moment(),
          }
      };

      $scope.date = {
        startDate: ranges[range].start,
        endDate: ranges[range].end
      }

      $scope.loadAnalytics();
    }
    $scope.pinChange = function(){
      if($('#filter-pin').hasClass('unpined')){
        $('#filter-pin').removeClass('unpined');
        $('#filter-pin').addClass('pin');
        localStorage.setItem('pinned', true);
      }else{
        $('#filter-pin').removeClass('pin');
        $('#filter-pin').addClass('unpined');
        localStorage.setItem('pinned', false);
      }
    }
    $scope.exportPlaysPerPublishersCSV = function(){
      var settings = {
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/auth/temporal/token?" + Date.now(),
        "data": {
           "client_id"       : JSON.parse(localStorage.getItem("session")).client_id,
           "publishers_ids"  : JSON.parse(localStorage.getItem("session")).publishers_ids
        },
        "method": "POST",
      }

      $.ajax(settings).success(function (response) {
          var start = moment($scope.date.startDate);
          start.set({hour:0,minute:0,second:0});
          start = start.format("YYYY-MM-DD HH:mm:ss");
          var end   = moment($scope.date.endDate);
          end.set({hour:23,minute:59,second:59});
          end = end.format("YYYY-MM-DD HH:mm:ss");
          window.open($rootScope.apiUrl + "/api/v1/analytics/plays-by-pids?start=" + start + "&end=" + end + "&gs=" + response.token + "&id=" + JSON.parse(localStorage.getItem("session")).user_id, "_blank");

      })
      .error(function (error){
          toastr.error(error.responseJSON.error, 'Error');
      });
    }
    $scope.filterTable = function(table_name, filterBy, col){
        var filter, table, tr, td, i;
        var paint = true;
        filter = filterBy.toUpperCase();
        table = document.getElementById(table_name);
        tr = table.getElementsByTagName("tr");
        for (i = 0; i < tr.length; i++) {
          td = tr[i].getElementsByTagName("td")[col];
          if (td) {
            if (td.innerHTML.toUpperCase().indexOf(filter) > -1) {
              tr[i].style.display = "";
              console.log(paint)
              if(paint){
                tr[i].style.background = '#ddd';
                paint = false;
              }else{
                tr[i].style.background = '#fff';
                paint = true;
              }
            } else {
              tr[i].style.display = "none";
            }
          }
        }
    }
    $scope.openModalContentGraph = function(content_id){
       $scope.content_id = content_id;
       $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'app/pages/content/content-graphs/contentGraph.html',
        scope: $scope
      });
    }
    $scope.loadAdsByPids = function(pid) {
      var session = JSON.parse(localStorage.getItem("session"));
      var start = moment($scope.date.startDate);
      start.set({hour:0,minute:0,second:0});
      start = start.format("YYYY-MM-DD");

      var end = moment($scope.date.endDate);
      end.set({hour:0,minute:0,second:0});
      end = end.format("YYYY-MM-DD");

      var url = $rootScope.apiUrl + "/analytics/ads?start="+ start + "&end=" + end + '&client_id=' + encodeURIComponent(session.client_id) + '&pid=' + $('#selectPublisherAds').val();
      if(pid) {
        url = $rootScope.apiUrl + "/analytics/ads?start="+ start + "&end=" + end + '&client_id=' + encodeURIComponent(session.client_id) + '&pid=' + pid;
      }

      $.ajax({
        "crossDomain": true,
        "url": url,
        "method": "GET"
      }).success(function (data) {
        $scope.adsData = data;
        Highcharts.chart('dailyAdsPlays', {
            chart: {
                zoomType: 'x',
                type: 'line'
            },
            title: {
                text: 'Analytics'
            },
            subtitle: {
                text: document.ontouchstart === undefined ?
                        'Click and drag in the plot area to zoom in' : 'Pinch the chart to zoom in'
            },
            xAxis: {
                categories: data.dates
            },
            yAxis: {
                title: {
                    text: ''
                }
            },
            series: [
              {
                  name: 'Plays',
                  data: data.plays,
                  zIndex: 5
              },{
                  name: 'Impressions: ',
                  data: data.impressions,
                  visible: false,
                  zIndex: 4
              },{
                  name: 'Preroll',
                  data: data.preroll,
                  zIndex: 3
              },{
                  name: 'Midroll',
                  data: data.midroll,
                  zIndex: 2
              },{
                  name: 'Postroll',
                  data: data.postroll,
                  zIndex: 1
              }
            ],
            legend: {
                enabled: true
            },
            plotOptions: {
                line: {
                    dataLabels: {
                        enabled: true
                    },
                    enableMouseTracking: false
                }
            },
        });
        $scope.$apply();
        if(data.length != 0){
          $('.no-content').hide();
        }else{
          $('.no-content').show();
        }
      })
    }
    $scope.exportAdsCSV = function () {
      if($scope.adsData.length == 0) {
        console.log("Nothing to export.");
        return false;
      }
      var rows = "Date,Plays,Impressions,Preroll,Midroll,Posroll" + "\r\n";
      var len  = $scope.adsData.dates.length;
      for (var i = 0; i < len; i++) {
        rows += $scope.adsData.dates[i] + ",";
        rows += $scope.adsData.plays[i] + ",";
        rows += $scope.adsData.impressions[i] + ",";
        rows += $scope.adsData.preroll[i] + ",";
        rows += $scope.adsData.midroll[i] + ",";
        rows += $scope.adsData.postroll[i];
        rows += "\r\n";
      }

      var csvContent = "data:text/csv;charset=utf-8," + rows;
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "genoa_advertising_report_"+moment().format("DD_MM_YYYY_HH:mm")+".csv");
      document.body.appendChild(link);

      link.click();
    }

    function buildToggler(componentId) {
      return function() {
        if(localStorage.getItem("pinned") != "true"){
          $mdSidenav(componentId).toggle();
        }
      };
    }
    $('back-top').remove();
    $scope.loadAnalytics();
  }

  function trafficChart2() {
    return {
      restrict: 'E',
      controller: 'DashboardCtrl',
      templateUrl: 'app/pages/dashboard/dashboard.html'
    };
  }

  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'DashboardCtrl',
      templateUrl: 'app/pages/dashboard/dashboard.html'
    };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
    .directive('dashboard', dashboard)
    .directive('exportToCsv', exportCsv);

  /** @ngInject */
  function dashboard() {
    return {
      restrict: 'E',
      controller: 'DashboardCtrl.js',
      templateUrl: 'app/pages/dashboard/dashboard.html'
    };
  }

  function exportCsv() {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var el = element[0];
        element.bind('click', function (e) {
          var table = e.target.nextElementSibling;
          var csvString = '';
          for (var i = 0; i < table.rows.length; i++) {
            var rowData = table.rows[i].cells;
            for (var j = 0; j < rowData.length; j++) {
              csvString = csvString + rowData[j].textContent + ",";
            }
            csvString = csvString.substring(0, csvString.length - 1);
            csvString = csvString + "\n";
          }
          csvString = csvString.substring(0, csvString.length - 1);
          var a = $('<a/>', {
            style: 'display:none',
            href: 'data:application/octet-stream;base64,' + btoa(unescape(encodeURIComponent((csvString)))),
            download: 'genoa_analytic_report_' + Date.now() + '.csv'
          }).appendTo('body')
          a[0].click()
          a.remove();
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dvr')
    .controller('DvrCtrl', DvrCtrl);
  function DvrCtrl($scope, $rootScope, $state) {
	  	var vm        		  = this;
	  	vm.items      		  = [];
		vm.loading    		  = true;
		vm.publisher_selected = '';
		vm.category_selected  = '';
		vm.categories 		  = [];
		vm.publishers 		  = [];
 	  	
 	  			
 	  	vm.loadItems  = function(){
			var settings = {
			  "async": true,
			  "crossDomain": true,
			  "url": $rootScope.apiUrl + "/api/v1/dvr/list",
			  "method": "GET",
			  "headers": {
			    "cache-control": "no-cache"
			  }
			}

			$.ajax(settings).done(function(items) {
			  vm.items   = items;
			  vm.loading = false;
			  $scope.$apply();
			  	var reload_channels = setInterval(function(){ 
			  		if($state.current.name == 'dvr'){
			  			vm.loading = true;
			  			var items = $('.item-box');
						$.each(items,function(index,value){
						  var url = $rootScope.prefix + 'dvr.vodgc.com/'+$(value).attr("id")+'/preview.jpg?' + Date.now();
						  $(value).css("background-image","url("+url+")");
						});
						vm.loading = false;
			  		}else{
			  			clearInterval(reload_channels);
			  		}
			  	}, 10000);
			});
	  	}
 	  	vm.loadCategories  = function(){
			var settings  = {
			  "async": true,
			  "crossDomain": true,
			  "url": $rootScope.apiUrl + "/api/v1/category/" + $('#publisher-select').val(),
			  "method": "GET",
			  "headers": {
			    "cache-control": "no-cache"
			  }
			}

			$.ajax(settings).done(function(categories) {
				$('#category-select').html("");
			  	angular.forEach(categories, function(value, key) {
	  				$('#category-select').append('<option value="'+value.id+'">'+value.value+'</option>');
				});
	  			$(".chosen-select").trigger('chosen:updated');
			  	vm.categories = categories;
			  	$scope.$apply();
			});
	  	}
	  	vm.loadPublishers  = function(){
	  		var client_id  = JSON.parse(localStorage.getItem('session')).client_id;
			var settings   = {
			  "async": true,
			  "crossDomain": true,
			  "url": $rootScope.apiUrl + "/api/v1/publisher/" + client_id,
			  "method": "GET",
			  "headers": {
			    "cache-control": "no-cache"
			  }
			}

			$.ajax(settings).done(function(publishers) {
			  	vm.publishers = publishers;
		  		setTimeout(function(){		  			
		  			vm.publisher_selected = $('#publisher-select').val();
		  			angular.forEach(publishers, function(value, key) {
		  				$('#publisher-select').append('<option value="'+value.id+'">'+value.value+'</option>');
					});
		  			$(".chosen-select").trigger('chosen:updated');		  			
		  		}, 500);
			});
	  	}
		vm.validateSelection = function(channel){
			vm.publisher_selected  = $('#publisher-select').val();
			vm.category_selected   = $('#category-select').val();
			if(vm.publisher_selected == '? string: ?' && vm.category_selected == '' || typeof($('#category-select').val()) === 'object'){
				alert("Please fill publisher and category");
			}else{
				$state.go("window", {id: channel, cid: vm.category_selected, pid: vm.publisher_selected}); 
			}

		}
	  	if($state.current.name == 'dvr'){
			vm.loadItems();
		  	vm.loadPublishers();
	  	}
	  	jQuery.fn.shake = function(intShakes, intDistance, intDuration) {
		    this.each(function() {
		        $(this).css("position","relative"); 
		        for (var x=1; x<=intShakes; x++) {
		        $(this).animate({left:(intDistance*-1)}, (((intDuration/intShakes)/4)))
		    .animate({left:intDistance}, ((intDuration/intShakes)/2))
		    .animate({left:0}, (((intDuration/intShakes)/4)));
		    }
		  });
		return this;
		};

		$(".shake").shake(3,7,600);
		$(".chosen-select").chosen({no_results_text: "Oops, nothing found!"});
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dvr')
    .controller('DvrWinCtrl', DvrWinCtrl);
  	function DvrWinCtrl($scope, $rootScope, $state, $stateParams, $sce) {
		var vm = this;
		vm.id  = $stateParams.id;
		vm.cid = $stateParams.cid;
		vm.pid = $stateParams.pid;	
		$scope.source = $sce.trustAsResourceUrl($rootScope.prefix + 'dvr.vodgc.com/'+vm.id+'/embed.html?dvr=true&pid=' + vm.pid + '&cid=' + vm.cid + '&env=' + $rootScope.environment);
  	}
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.player')
       .controller('PlayerListCtrl', PlayerListCtrl);

  /** @ngInject */
  function PlayerListCtrl($scope, toastr, $rootScope, $state) {
      	$scope.loading 	   	= true;
      	$scope.players 	   	= [];
      	$scope.permissions 	= [];
      	var client_id  		= encodeURIComponent(JSON.parse(localStorage.getItem('session')).client_id);
		var settings = {
		  	"crossDomain": true,
		  	"url": $rootScope.apiUrl + "/api/v1/player/list?order=updated_at&client_id=" + client_id + "&publishers_ids=" + JSON.parse(localStorage.getItem('session')).publishers_ids,
		  	"method": "GET"
		}
		$.ajax(settings).success(function(players){
		 	$scope.players 		= players.players_list;
		 	$scope.permissions 	= players.permissions;
		  	$scope.loading 		= false;
		  	$scope.$apply();
		});	

		$scope.deletePlayer = function(player_id){
    		if (confirm('Are you sure you want to delete this player?')) {
				var settings = {
				  "crossDomain": true,
				  "url": $rootScope.apiUrl + "/api/v1/player?player_id="+player_id+"&client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem('session')).client_id),
				  "method": "DELETE",
				}

				$.ajax(settings)
					.success(function (response) {
					  toastr.success(response.success, 'Success');
					  $state.go($state.current, {}, {reload: true});
					})
					.error(function (response) {
					  toastr.error(JSON.parse(response.responseText).error, 'Error');
					});
		  	}
		}
		$scope.clonePlayer = function(player_id){
			var new_name = prompt("Please enter a new name for this player");
			if((new_name == null) || (new_name == '')){
				alert("You must insert a new name to clone this player!");
			}else{
				var settings = {
				  "crossDomain": true,
				  "url": $rootScope.apiUrl + "/api/v1/player/clone",
				  "data": {
				  		"client_id" : JSON.parse(localStorage.getItem('session')).client_id,
				  		"player_id" : player_id,
				  		"new_name"  : new_name
				  },
				  "method": "POST",
				}

				$.ajax(settings)
					.success(function (response) {
					  toastr.success("Your player was clone successfully!", 'Player Clone');
					  $state.go($state.current, {}, {reload: true});
					})
					.error(function (response) {
					  toastr.error(JSON.parse(response.responseText).error, 'Player Clone');
					});
				
			}
		}
		$scope.purgePlayer = function(hash,name){
			if(!$scope.loading){
				$scope.loading = true;
				var settings = {
				  "crossDomain": true,
				  "url": $rootScope.apiUrl + "/player/purge?hash="+hash+"&token=fc8588fea08a8f35086e066e5bf21592694120b5b80ba0e3fa9c05d932131b06",
				  "method": "DELETE"
				}

				$.ajax(settings)
					.success(function (response) {
				  		$scope.loading = false;
				  		console.log(response);
				  		toastr.success(response.info,'Player Purge');
					})
					.error(function (response) {
						$scope.loading = false;
					  	toastr.error(JSON.parse(response.responseText).error, 'Player Purge');
					});
			}
		}
  }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.player')
        .controller('PlayerSettingsCtrl', PlayerSettingsCtrl);

    /** @ngInject */
    function PlayerSettingsCtrl($scope, $stateParams, $state, $rootScope, Auth, toastr) {
        var vm = this;
        vm.options = {
            format: 'hex',
            swatchOnly: false,
            alpha: false,
            swatchBootstrap: false,
        };
        vm.type 				= $stateParams.type;
        vm.bgPanel 				= '';
        vm.bgSlider				= '';
        vm.bgControls 			= '';
        vm.bgMainButton 		= '';
        vm.bgMainButtonHover	= '';
        vm.peer_five         	= '';
        vm.playlists            = [];
        vm.playListFilter       = $('#playlist_select').val();
        vm.relation_type        = '';
        vm.related_select       = 'none';
        vm.relation             = $('input[name=relation_type]:checked').val();
        vm.wt_url               = '';
        vm.wt_destination       = '';
        vm.wt_opacity           = '';
        vm.wt_pos               = '';
        vm.wt_height            = '';
        vm.add_tag_url          = '';
        vm.publishers 			= [];
        vm.publisher_selected = 0;
        vm.ga_id = null;

        vm.changeRelation = function(type){
            vm.relation  = type;
            console.log(vm.relation);
        };
        vm.loadPublishers  = function(){
            var client_id  = JSON.parse(localStorage.getItem('session')).client_id;
            var settings   = {
                "crossDomain": true,
                "url": $rootScope.apiUrl + "/api/v1/publisher/restricted/" + client_id,
                "method": "GET"
            };

            $.ajax(settings).done(function(publishers) {
                vm.publishers = publishers.map(function(pub){
                    return {"id" : pub.id, "name" : pub.value }
                });
                $scope.$apply();
            });
        };

        vm.hidePublisherError = function(){
            $('#no_publisher_message').fadeOut(300);
        };
        if(vm.type == 'create'){
            vm.loadPublishers();
            vm.NewPlayer = function(action){
                Auth.isLoggedIn();
                vm.player_name       = $('#player-name').val();
                vm.logo_top          = $('#logo-top').val();
                vm.logo_panel        = $('#logo-panel').val();
                vm.logo_url          = $('#logo-url').val();
                vm.add_tag_url       = $('#add-tag-url').val();
                vm.bgPanel 		 	 = vm.bgPanel.replace("#", "%23");
                vm.bgSlider			 = vm.bgSlider.replace("#", "%23");
                vm.bgControls 		 = vm.bgControls.replace("#", "%23");
                vm.bgMainButton 	 = vm.bgMainButton.replace("#", "%23");
                vm.bgMainButtonHover = vm.bgMainButtonHover.replace("#", "%23");
                vm.peer_five         = $('#peer_five_id').val();
                vm.ga                = $('#ga').val();
                vm.comscore          = $('#comscore').val();
                vm.comscore_c3       = $('#comscore_c3').val();
                vm.vast_skip         = $('#vast-skip').val();
                vm.vast_ts_key       = $('#vast-ts-key').val();
                vm.autoplay          = $('#autoplay').prop("checked");
                vm.video360          = $('#video360').prop("checked");
                vm.vast_custom_text  = $('#vast-custom-text').val();
                vm.wt_pos            = $('#wt_pos').val();
                vm.wt_height         = $('#wt_height').val();
                vm.autoplay_relation = $('#autoplay_relation').prop("checked");
                vm.download_audio    = $('#download_audio').prop("checked");
                vm.cxense            = $('#cxense').val();
                vm.related_delay     = $('#related_delay').val();
                vm.show_title        = $('#show_title').prop("checked");
                vm.quality_picker	 = $('#quality_picker').val();
                vm.sharing_facebook  = $('#sharing_facebook').prop("checked");
                vm.sharing_twitter	 = $('#sharing_twitter').prop("checked");
                vm.sharing_gplus 	 = $('#sharing_gplus').prop("checked");
                vm.sharing_embedded  = $('#sharing_embedded').prop("checked");
                vm.twitter_text_input  = $('#twitter_text_input').val();
                vm.countdown_ads     = $('#countdown_ads').val();
                vm.ga_hostname       = $('#ga_hostname').val();
                vm.ga_play           = $('#ga_play').prop("checked");
                vm.ga_loaded         = $('#ga_loaded').prop("checked");
                vm.ga_percentsPlayed = $('#ga_percentsPlayed').prop("checked");
                vm.ga_start          = $('#ga_start').prop("checked");
                vm.ga_end            = $('#ga_end').prop("checked");
                vm.ga_seek           = $('#ga_seek').prop("checked");
                vm.ga_pause          = $('#ga_pause').prop("checked");
                vm.ga_resize         = $('#ga_resize').prop("checked");
                vm.ga_volumeChange   = $('#ga_volumeChange').prop("checked");
                vm.ga_error          = $('#ga_error').prop("checked");
                vm.ga_fullscreen     = $('#ga_fullscreen').prop("checked");

                if(action == 'preview'){

                    var preview_url = $rootScope.apiUrl + "/api/v1/player/preview?logo_top=" + vm.logo_top + '&logo_panel=' + vm.logo_panel + '&logo_url=' + vm.logo_url + '&add_tag_url=' + encodeURIComponent(vm.add_tag_url) + '&bgPanel=' + vm.bgPanel.replace("#", "%23") + '&bgSlider=' +vm.bgSlider.replace("#", "%23")+ '&bgControls= '+ vm.bgControls.replace("#", "%23") + '&bgMainButton=' + vm.bgMainButton.replace("#", "%23") + '&bgMainButtonHover=' + vm.bgMainButtonHover.replace("#", "%23") + '&autoplay=' + vm.autoplay + '&vast_custom_text=' + vm.vast_custom_text + '&playlist_id=' + $('#playlist_select').val() + '&relation=' + vm.relation + '&relation_selected=' + vm.related_select + '&video360=' + $('#video360').prop("checked") + "&wt_url=" + vm.wt_url + "&wt_destination=" + vm.wt_destination + "&wt_opacity=" + vm.wt_opacity + "&wt_pos=" + vm.wt_pos + "&wt_height=" + vm.wt_height + '&vast_skip=' + vm.vast_skip + '&vast_ts_key=' + vm.vast_ts_key + '&title=' + vm.show_title + '&quality_picker=' + vm.quality_picker + '&external_css=' + encodeURIComponent($('#external_css').val()) + '&sharing_facebook=' + vm.sharing_facebook + '&sharing_twitter=' + vm.sharing_twitter + '&sharing_gplus=' + vm.sharing_gplus  + '&sharing_embedded=' + vm.sharing_embedded + '&twitter_text_input=' + vm.twitter_text_input + '&autoplay_relation=' + vm.autoplay_relation + '&related_delay=' + vm.related_delay + '&countdown_ads=' + vm.countdown_ads;

                    $('#custom_player').html('<iframe src="'+preview_url+'" frameborder="0" allowfullscreen width="650" height="422" scrolling="no"></iframe>');
                }else{
                    if(vm.publisher_selected == ''){
                        $('#no_publisher_message').fadeIn(300);
                    }else{
                        $.each($('.btn-action'),function(index,value){
                            $(value).attr("disabled",true);
                        });
                        $('#no_publisher_message').hide();
                        if(vm.player_name){
                            $('#no_name_message').fadeOut(300);
                            vm.client_id = JSON.parse(localStorage.getItem('session')).client_id;
                            if(vm.relation == 'playlist'){
                                vm.playListFilter = $('#playlist_select').val();
                            }else{
                                vm.related_select = $('#related_select').val();
                            }
                            var json = {
                                'player_id'         : null,
                                'client_id'         : encodeURIComponent(vm.client_id),
                                'player_name'       : encodeURIComponent(vm.player_name),
                                'logo_top'			: encodeURIComponent(vm.logo_top),
                                'logo_panel'		: encodeURIComponent(vm.logo_panel),
                                'logo_url'			: encodeURIComponent(vm.logo_url),
                                'add_tag_url'		: encodeURIComponent(vm.add_tag_url),
                                'bgPanel'			: encodeURIComponent(vm.bgPanel),
                                'bgSlider'			: encodeURIComponent(vm.bgSlider),
                                'bgControls'		: encodeURIComponent(vm.bgControls),
                                'bgMainButton'		: encodeURIComponent(vm.bgMainButton),
                                'bgMainButtonHover'	: encodeURIComponent(vm.bgMainButtonHover),
                                'peer_five'         : encodeURIComponent(vm.peer_five),
                                'ga'				: encodeURIComponent(vm.ga),
                                'comscore'			: encodeURIComponent(vm.comscore),
                                'comscore_c3'		: encodeURIComponent(vm.comscore_c3),
                                'vast_skip' 		: encodeURIComponent(vm.vast_skip),
                                'vast_ts_key' 		: encodeURIComponent(vm.vast_ts_key),
                                'autoplay' 			: encodeURIComponent(vm.autoplay),
                                'vast_custom_text'  : encodeURIComponent(vm.vast_custom_text),
                                'playlist_id'       : encodeURIComponent($('#playlist_select').val()),
                                'relation'          : encodeURIComponent(vm.relation),
                                'relation_selected' : encodeURIComponent(vm.related_select),
                                'video360'          : encodeURIComponent(vm.video360),
                                'wt_url'			: encodeURIComponent(vm.wt_url),
                                'wt_destination'	: encodeURIComponent(vm.wt_destination),
                                'wt_opacity' 		: encodeURIComponent(vm.wt_opacity),
                                'wt_pos' 			: encodeURIComponent(vm.wt_pos),
                                'wt_height' 		: encodeURIComponent(vm.wt_height),
                                'autoplay_relation' : encodeURIComponent(vm.autoplay_relation),
                                'download_audio'    : encodeURIComponent(vm.download_audio),
                                'cxense'            : encodeURIComponent(vm.cxense),
                                'related_delay'     : encodeURIComponent(vm.related_delay),
                                'show_title'        : encodeURIComponent(vm.show_title),
                                'quality_picker'	: encodeURIComponent(vm.quality_picker),
                                'sharing_facebook' 	: encodeURIComponent(vm.sharing_facebook),
                                'sharing_twitter'	: encodeURIComponent(vm.sharing_twitter),
                                'sharing_gplus'		: encodeURIComponent(vm.sharing_gplus),
                                'sharing_embedded'	: encodeURIComponent(vm.sharing_embedded),
                                'twitter_text_input'	: encodeURIComponent(vm.twitter_text_input),
                                "pid"               : vm.publisher_selected,
                                'external_css'		: encodeURIComponent($('#external_css').val()),
                                'countdown_ads'     : vm.countdown_ads,
                                'ga_hostname'       : vm.ga_hostname,
                                'ga_play'           : vm.ga_play,
                                'ga_loaded'         : vm.ga_loaded,
                                'ga_percentsPlayed' : vm.ga_percentsPlayed,
                                'ga_start'          : vm.ga_start,
                                'ga_end'            : vm.ga_end,
                                'ga_seek'           : vm.ga_seek,
                                'ga_pause'          : vm.ga_pause,
                                'ga_resize'         : vm.ga_resize,
                                'ga_volumeChange'   : vm.ga_volumeChange,
                                'ga_error'          : vm.ga_error,
                                'ga_fullscreen'     : vm.ga_fullscreen
                            };
                            var data = JSON.stringify(json);
                            var settings = {
                                "crossDomain": true,
                                "url": $rootScope.apiUrl + "/api/v1/player",
                                "method": "POST",
                                "data": {
                                    "model" : data
                                }
                            };
                            $.ajax(settings).success(function(response) {
                                toastr.success(response.info, 'success');
                                $state.go('player-list', {}, {reload: true});
                            })
                                .error(function(error) {
                                    toastr.error(response.error, 'error');
                                    $.each($('.btn-action'),function(index,value){
                                        $(value).attr("disabled",false);
                                    });
                                });
                        }else{
                            $('#no_name_message').fadeIn(300);
                        }
                    }
                }
            };
            vm.loadPlaylists = function(){
                var settings = {
                    "crossDomain": true,
                    "url": $rootScope.apiUrl + "/api/v1/playlist?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id),
                    "method": "GET",
                    "headers": {
                        "cache-control": "no-cache"
                    }
                };

                $.ajax(settings).done(function (playlists) {
                    vm.playlists = playlists;
                    if(playlists.length > 0){
                        $scope.$apply();
                    }
                });
            };
            vm.loadPlaylists();
        }else{
            vm.player_id = $stateParams.player_id;
            vm.NewEdit = function(action){
                Auth.isLoggedIn();
                vm.player_name       = $('#player-name').val();
                vm.logo_top          = $('#logo-top').val();
                vm.logo_panel        = $('#logo-panel').val();
                vm.logo_url          = $('#logo-url').val();
                vm.add_tag_url       = $('#add-tag-url').val();
                vm.peer_five         = $('#peer_five_id').val();
                vm.ga                = $('#ga').val();
                vm.comscore          = $('#comscore').val();
                vm.comscore_c3       = $('#comscore_c3').val();
                vm.vast_skip         = $('#vast-skip').val();
                vm.vast_ts_key       = $('#vast-ts-key').val();
                vm.autoplay          = $('#autoplay').prop("checked");
                vm.video360          = $('#video360').prop("checked");
                vm.vast_custom_text  = $('#vast-custom-text').val();
                vm.wt_url            = $('#wt_url').val();
                vm.wt_destination    = $('#wt_destination').val();
                vm.wt_opacity        = $('#wt_opacity').val();
                vm.wt_pos            = $('#wt_pos').val();
                vm.wt_height         = $('#wt_height').val();
                vm.autoplay_relation = $('#autoplay_relation').prop("checked");
                vm.download_audio    = $('#download_audio').prop("checked");
                vm.cxense            = $('#cxense').val();
                vm.related_delay     = $('#related_delay').val();
                vm.show_title        = $('#show_title').prop("checked");
                vm.quality_picker    = $('#quality_picker').val();
                vm.sharing_facebook  = $('#sharing_facebook').prop("checked");
                vm.sharing_twitter	 = $('#sharing_twitter').prop("checked");
                vm.sharing_gplus 	 = $('#sharing_gplus').prop("checked");
                vm.sharing_embedded  = $('#sharing_embedded').prop("checked");
                vm.twitter_text_input  = $('#twitter_text_input').val();
                vm.countdown_ads     = $('#countdown_ads').val();
                vm.ga_hostname       = $('#ga_hostname').val();
                vm.ga_hostname       = $('#ga_hostname').val();
                vm.ga_play           = $('#ga_play').prop("checked");
                vm.ga_loaded         = $('#ga_loaded').prop("checked");
                vm.ga_percentsPlayed = $('#ga_percentsPlayed').prop("checked");
                vm.ga_start          = $('#ga_start').prop("checked");
                vm.ga_end            = $('#ga_end').prop("checked");
                vm.ga_seek           = $('#ga_seek').prop("checked");
                vm.ga_pause          = $('#ga_pause').prop("checked");
                vm.ga_resize         = $('#ga_resize').prop("checked");
                vm.ga_volumeChange   = $('#ga_volumeChange').prop("checked");
                vm.ga_error          = $('#ga_error').prop("checked");
                vm.ga_fullscreen     = $('#ga_fullscreen').prop("checked");


                if(action == 'preview'){
                    
                    var preview_url = $rootScope.apiUrl + "/api/v1/player/preview?logo_top=" + vm.logo_top + '&logo_panel=' + vm.logo_panel + '&logo_url=' + vm.logo_url + '&add_tag_url=' + encodeURIComponent(vm.add_tag_url) + '&bgPanel=' + vm.bgPanel.replace("#", "%23") + '&bgSlider=' +vm.bgSlider.replace("#", "%23")+ '&bgControls= '+ vm.bgControls.replace("#", "%23") + '&bgMainButton=' + vm.bgMainButton.replace("#", "%23") + '&bgMainButtonHover=' + vm.bgMainButtonHover.replace("#", "%23") + '&autoplay=' + vm.autoplay + '&vast_custom_text=' + vm.vast_custom_text + '&playlist_id=' + $('#playlist_select').val() + '&relation=' + vm.relation + '&relation_selected=' + vm.related_select + '&video360=' + $('#video360').prop("checked") + "&wt_url=" + vm.wt_url + "&wt_destination=" + vm.wt_destination + "&wt_opacity=" + vm.wt_opacity + "&wt_pos=" + vm.wt_pos + "&wt_height=" + vm.wt_height + '&vast_skip=' + vm.vast_skip + '&vast_ts_key=' + vm.vast_ts_key + '&title=' + vm.show_title + '&quality_picker=' + vm.quality_picker + '&external_css=' + encodeURIComponent($('#external_css').val()) + '&sharing_facebook=' + vm.sharing_facebook + '&sharing_twitter=' + vm.sharing_twitter + '&sharing_gplus=' + vm.sharing_gplus  + '&sharing_embedded=' + vm.sharing_embedded + '&twitter_text_input=' + vm.twitter_text_input + '&autoplay_relation=' + vm.autoplay_relation + '&related_delay=' + vm.related_delay + '&countdown_ads=' + vm.countdown_ads;
                    
                    $('#custom_player').html('<h4>PlayerId: '+vm.player_id+'</h4><iframe src="'+preview_url+'" frameborder="0" allowfullscreen width="650" height="422" scrolling="no"></iframe>');
                }else{
                    if(vm.publisher_selected == 0){
                        $('#no_publisher_message').fadeIn(300);
                    }else{
                        $.each($('.btn-action'),function(index,value){
                            $(value).attr("disabled",true);
                        });
                        $('#no_publisher_message').hide();
                        if(vm.player_name){
                            $('#no_name_message').fadeOut(300);
                            vm.client_id = JSON.parse(localStorage.getItem('session')).client_id;
                            if(vm.relation == 'playlist'){
                                vm.playListFilter = $('#playlist_select').val();
                            }else{
                                vm.related_select = $('#related_select').val();
                            }
                            var json = {
                                'player_id'         : vm.player_id,
                                'client_id'         : encodeURIComponent(vm.client_id),
                                'player_name'       : encodeURIComponent(vm.player_name),
                                'logo_top'			: encodeURIComponent(vm.logo_top),
                                'logo_panel'		: encodeURIComponent(vm.logo_panel),
                                'logo_url'			: encodeURIComponent(vm.logo_url),
                                'add_tag_url'		: encodeURIComponent(vm.add_tag_url),
                                'bgPanel'			: encodeURIComponent(vm.bgPanel),
                                'bgSlider'			: encodeURIComponent(vm.bgSlider),
                                'bgControls'		: encodeURIComponent(vm.bgControls),
                                'bgMainButton'		: encodeURIComponent(vm.bgMainButton),
                                'bgMainButtonHover'	: encodeURIComponent(vm.bgMainButtonHover),
                                'peer_five'         : encodeURIComponent(vm.peer_five),
                                'ga'				: encodeURIComponent(vm.ga),
                                'comscore'			: encodeURIComponent(vm.comscore),
                                'comscore_c3'		: encodeURIComponent(vm.comscore_c3),
                                'vast_skip' 		: encodeURIComponent(vm.vast_skip),
                                'vast_ts_key' 		: encodeURIComponent(vm.vast_ts_key),
                                'autoplay' 			: encodeURIComponent(vm.autoplay),
                                'vast_custom_text'  : encodeURIComponent(vm.vast_custom_text),
                                'playlist_id'       : encodeURIComponent($('#playlist_select').val()),
                                'relation'          : encodeURIComponent(vm.relation),
                                'relation_selected' : encodeURIComponent(vm.related_select),
                                'video360'          : encodeURIComponent(vm.video360),
                                'wt_url'			: encodeURIComponent(vm.wt_url),
                                'wt_destination'	: encodeURIComponent(vm.wt_destination),
                                'wt_opacity' 		: encodeURIComponent(vm.wt_opacity),
                                'wt_pos' 			: encodeURIComponent(vm.wt_pos),
                                'wt_height' 		: encodeURIComponent(vm.wt_height),
                                'autoplay_relation' : encodeURIComponent(vm.autoplay_relation),
                                'download_audio'    : encodeURIComponent(vm.download_audio),
                                'cxense'            : encodeURIComponent(vm.cxense),
                                'related_delay'     : encodeURIComponent(vm.related_delay),
                                'show_title'        : encodeURIComponent(vm.show_title),
                                'quality_picker' 	: encodeURIComponent(vm.quality_picker),
                                'sharing_facebook' 	: encodeURIComponent(vm.sharing_facebook),
                                'sharing_twitter'	: encodeURIComponent(vm.sharing_twitter),
                                'sharing_gplus'		: encodeURIComponent(vm.sharing_gplus),
                                'sharing_embedded'	: encodeURIComponent(vm.sharing_embedded),
                                'twitter_text_input'	: encodeURIComponent(vm.twitter_text_input),
                                "pid"               : vm.publisher_selected,
                                'external_css'		: encodeURIComponent($('#external_css').val()),
                                'countdown_ads'     : vm.countdown_ads,
                                'ga_hostname'       : vm.ga_hostname,
                                'ga_play'           : vm.ga_play,
                                'ga_loaded'         : vm.ga_loaded,
                                'ga_percentsPlayed' : vm.ga_percentsPlayed,
                                'ga_start'          : vm.ga_start,
                                'ga_end'            : vm.ga_end,
                                'ga_seek'           : vm.ga_seek,
                                'ga_pause'          : vm.ga_pause,
                                'ga_resize'         : vm.ga_resize,
                                'ga_volumeChange'   : vm.ga_volumeChange,
                                'ga_error'          : vm.ga_error,
                                'ga_fullscreen'     : vm.ga_fullscreen
                            };
                            var data = JSON.stringify(json);
                            var settings = {
                                "crossDomain": true,
                                "url": $rootScope.apiUrl + "/api/v1/player",
                                "method": "POST",
                                "data": {
                                    "model" : data
                                }
                            };
                            $.ajax(settings).success(function(response) {
                                toastr.success(response.info, 'success');
                                $state.go('player-list', {}, {reload: true});
                            })
                                .error(function(error) {
                                    toastr.error(response.error, 'error');
                                    $.each($('.btn-action'),function(index,value){
                                        $(value).attr("disabled",false);
                                    });
                                });
                        }else{
                            $('#no_name_message').fadeIn(300);
                        }
                    }
                }
            };
            vm.loadPlayerConf = function(player_id){
                var settings = {
                    "crossDomain": true,
                    "url": $rootScope.apiUrl + "/api/v1/player?player_id=" + player_id,
                    "method": "GET"
                };
                $.ajax(settings).done(function(settings){
                    vm.loadPublishers();
                    $.each(settings,function(key,value){
                        if(value){
                            switch(key) {
                                case 'name':
                                    $('#player-name').val(value);
                                    break;
                                case 'logo':
                                    $('#logo-top').val(value);
                                    break;
                                case 'logo_panel':
                                    $('#logo-panel').val(value);
                                    break;
                                case 'destination_url':
                                    $('#logo-url').val(value);
                                    break;
                                case 'add_tag_url':
                                    $('#add-tag-url').val(value);
                                    break;
                                case 'bg_panel':
                                    vm.bgPanel = value;
                                    break;
                                case 'bg_slider':
                                    vm.bgSlider = value;
                                    break;
                                case 'bg_controls':
                                    vm.bgControls = value;
                                    break;
                                case 'bg_main_btn':
                                    vm.bgMainButton = value;
                                    break;
                                case 'bg_main_btn_hover':
                                    vm.bgMainButtonHover = value;
                                    break;
                                case 'peer_five':
                                    $('#peer_five_id').val(value);
                                    break;
                                case 'ga':
                                    $('#ga').val(value);
                                    if(value){
                                        $('.gaEvents').show(300);
                                    }
                                    break;
                                case 'comscore':
                                    $('#comscore').val(value);
                                    break;
                                case 'comscore_c3':
                                    $('#comscore_c3').val(value);
                                    break;
                                case 'vast_skip':
                                    $('#vast-skip').val(value);
                                    break;
                                case 'vast_ts_key':
                                    $('#vast-ts-key').val(value);
                                    break;
                                case 'autoplay':
                                    $('#autoplay').prop("checked",value);
                                    break;
                                case 'video360':
                                    $('#video360').prop("checked",value);
                                    break;
                                case 'vast_custom_text':
                                    $('#vast-custom-text').val(value);
                                    break;
                                case 'playlist_id':
                                    vm.relation = 'playlist';
                                    vm.relation_type = 'playlist';
                                    $('#playlist_select').val(value);
                                    break;
                                case 'wt_url':
                                    $('#wt_url').val(value);
                                    break;
                                case 'wt_destination':
                                    $('#wt_destination').val(value);
                                    break;
                                case 'wt_opacity':
                                    $('#wt_opacity').val(value);
                                    break;
                                case 'wt_pos':
                                    $('#wt_pos').val(value);
                                    break;
                                case 'wt_height':
                                    $('#wt_height').val(value);
                                    break;
                                case 'autoplay_relation':
                                    $('#autoplay_relation').prop("checked",value);
                                    break;
                                case 'download_audio':
                                    $('#download_audio').prop("checked",value);
                                    break;
                                case 'relation':
                                    vm.relation = 'related';
                                    vm.relation_type = 'related';
                                    $('#related_select').val(value);
                                    break;
                                case 'cxense':
                                    $('#cxense').val(value);
                                    break;
                                case 'related_delay':
                                    $('#related_delay').val(value);
                                    break;
                                case 'show_title':
                                    $('#show_title').prop("checked",value);
                                    break;
                                case 'quality_picker':
                                    $('#quality_picker').val(value);
                                    break;
                                case 'pid':
                                    vm.publisher_selected = value;
                                    break;
                                case 'external_css':
                                    $('#external_css').val(value);
                                    break;
                                case 'sharing_facebook':
                                    $('#sharing_facebook').prop("checked",value);
                                    break;
                                case 'sharing_twitter':
                                    $('#sharing_twitter').prop("checked",value);
                                    break;
                                case 'sharing_gplus':
                                    $('#sharing_gplus').prop("checked",value);
                                    break;
                                case 'sharing_embedded':
                                    $('#sharing_embedded').prop("checked",value);
                                    break;
                                case 'twitter_text_input':
                                    $('#twitter_text_input').val(value);
                                    break;
                                case 'countdown_ads':
                                    $('#countdown_ads').val(value);
                                    break;
                                case 'ga_hostname':
                                    $('#ga_hostname').val(value);
                                    break;
                                case 'ga_play':
                                    $('#ga_play').prop("checked",value);
                                    break;
                                case 'ga_loaded':
                                    $('#ga_loaded').prop("checked",value);
                                    break;
                                case 'ga_percentsPlayed':
                                    $('#ga_percentsPlayed').prop("checked",value);
                                    break;
                                case 'ga_start':
                                    $('#ga_start').prop("checked",value);
                                    break;
                                case 'ga_end':
                                    $('#ga_end').prop("checked",value);
                                    break;
                                case 'ga_seek':
                                    $('#ga_seek').prop("checked",value);
                                    break;
                                case 'ga_pause':
                                    $('#ga_pause').prop("checked",value);
                                    break;
                                case 'ga_resize':
                                    $('#ga_resize').prop("checked",value);
                                    break;
                                case 'ga_volumeChange':
                                    $('#ga_volumeChange').prop("checked",value);
                                    break;
                                case 'ga_error':
                                    $('#ga_error').prop("checked",value);
                                    break;
                                case 'ga_fullscreen':
                                    $('#ga_fullscreen').prop("checked",value);
                                    break;
                                default:
                                    return '';
                                    break;
                            }
                        }
                    });
                    vm.NewEdit('preview');
                });
            };
            vm.loadPlaylists = function(){
                var settings = {
                    "crossDomain": true,
                    "url": $rootScope.apiUrl + "/api/v1/playlist?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id),
                    "method": "GET",
                    "headers": {
                        "cache-control": "no-cache"
                    }
                };

                $.ajax(settings).done(function (playlists) {
                    vm.playlists = playlists.playlists;
                    $scope.$apply();
                    vm.loadPlayerConf(vm.player_id);
                });
            };
            vm.loadPlaylists();
        }

        vm.changeGA = function(){
            if(vm.ga_id != null && vm.ga_id != ''){
                $('.gaEvents').show(300);
            }else{
                $('.gaEvents').fadeOut(300);
            }
        }

        vm.changeTWcustomText = function(){
            if($('#sharing_twitter').prop("checked")){
                $('.tw-related').show(300);
            }else{
                $('.tw-related').fadeOut(300);
            }
        }

        setTimeout(function(){
            $.each($(".accordion"),function(index,value){
                value.onclick = function() {
                    this.classList.toggle("active");
                    var panel = this.nextElementSibling;
                    $(panel).css("display","block");
                    if (panel.style.maxHeight){
                        if($(value).attr("id") == 'look-and-feel'){
                            $('.look-and-feel').removeAttr("style");
                        }else{
                            panel.style.maxHeight = null;
                            panel.style.padding = '0px';
                        }
                    } else {
                        if($(value).attr("id") == 'look-and-feel'){
                            panel.style.maxHeight = '315px';
                            panel.style.padding = '24px 30px 315px';
                        }else{
                            console.log($(value).attr("id"));
                            panel.style.padding = '10px';
                            if($(value).attr("id") == 'sharing-panel'){
                                if($('#sharing_twitter').prop("checked")){
                                    $('.tw-related').show();
                                }
                                panel.style.maxHeight = '206px';
                            }else{
                                panel.style.maxHeight = panel.scrollHeight + 'px';
                            }

                        }
                    }
                }
            });
        }, 200);
    }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.playlists')
       .controller('PlaylistModifyCtrl', PlaylistModifyCtrl);

  /** @ngInject */
  function PlaylistModifyCtrl($scope, toastr, $rootScope, $state, $stateParams) {

    var vm 			          = this;
  	vm.loading 		        = false;
  	vm.rule_items         = [];
  	vm.rule_select        = [];
		vm.quantity 	        = [];
		vm.playlist  	        = [];
		vm.edit               = false;
		vm.publishers         = [];
		vm.publisher_selected = '';

		vm.loadPublishers  = function(){
	  	var client_id  = JSON.parse(localStorage.getItem('session')).client_id;
			var settings   = {
				"async": false,
			  	"crossDomain": true,
				"url": $rootScope.apiUrl + "/api/v1/publisher/restricted/" + client_id,
				"method": "GET"
			};

			$.ajax(settings).done(function(publishers) {
			  	vm.publishers = publishers;
			});
	  	};
	  	vm.loadPublishers();

		if(typeof($stateParams.id) !='undefined'){
			vm.edit = true;
			vm.loadPlaylist = function(){
				var settings = {
				  "async": true,
				  "crossDomain": true,
				  "url": $rootScope.apiUrl + "/api/v1/playlist/settings/" + $stateParams.id,
				  "method": "GET",
				  "headers": {
				    "cache-control": "no-cache",
				  }
				}

				$.ajax(settings).done(function(conf) {
				  	$('#playlist_name').val(conf.name);
				  	$('#playlist_description').val(conf.description);
				  	$('#publishers_select').val(conf.publisher);
				  	vm.playlist   = conf;
				  	vm.rule_items = conf.rules;
				  	$scope.$apply();
				  	vm.initialize(0,0);
				});
			}
			vm.loadPlaylist();
		}
      	//Class Rule
  	vm.rule = {
  	  "id" : null,
  	  "position": null,
		  "categories": null,
		  "tags": null,
		  "orderBy": 'most_recent',
		  "quantity": null
		};
    vm.sortableOptions = {
          start: function(e, ui) {
        		// creates a temporary attribute on the element with the old index
        		$(this).attr('data-previndex', ui.item.index());
		    },
		    update: function(e, ui) {
		        // gets the new and old index then removes the temporary attribute
		        var newIndex = ui.item.index();
		        var oldIndex = $(this).attr('data-previndex');
		        $(this).removeAttr('data-previndex');
		    }
        };
		vm.loadCategories = function(){
	        var settings = {
	          "async": true,
	          "crossDomain": true,
	          "url": $rootScope.apiUrl + "/api/v1/categories",
	          "data":{
	                    'client_id': JSON.parse(localStorage.getItem("session")).client_id,
	                    'list' : 1,
                      'pid': $('#publishers_select').val()
	                 },
	          "method": "POST"
	        }
	        $.ajax(settings).done(function(response) {
	           $('.categories').html(response);
	        })
	        .error(function(error){
	          //console.log(error);
	        });
	    }
    vm.loadTags = function(index,tmp_items){
	    	var settings = {
			  "async": true,
			  "crossDomain": true,
			  "url": $rootScope.apiUrl + "/api/v1/tags?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id),
			  "method": "GET",
			  "headers": {
			    "cache-control": "no-cache",
			  }
			}

			$.ajax(settings).done(function (response) {
			  	$('.tags').html(response);
			  	if(typeof($stateParams.id) =='undefined'){
			  		vm.render(index,tmp_items);
			  	}else{
			  		$(".chosen-select").chosen({no_results_text: "Oops, nothing found!"});
					$(".chosen-select").trigger("chosen:updated");
			  		angular.forEach(vm.rule_items, function(value, index) {
			  			$('#rule-'+index +" .ruleSelect-" + index).val(value.orderBy);
					    $('#rule-'+index +" .quantity-" + index).val(value.quantity);
					    $('#rule-'+index +" .categories-" + index).val(value.categories);
					    $('#rule-'+index +" .categories-" + index).trigger('chosen:updated');
					    $('#rule-'+index +" .tags-" + index).val(value.tags);
						$('#rule-'+index +" .tags-" + index).trigger('chosen:updated');
			  		});
			  	}

			});
	    }
  	vm.initialize = function(index,tmp_items){
  		vm.loadCategories();
  		vm.loadTags(index,tmp_items);
  	}
  	vm.render = function(index,tmp_items){
  		$(".chosen-select").chosen({no_results_text: "Oops, nothing found!"});
	$(".chosen-select").trigger("chosen:updated");

	$.each(tmp_items,function(index,value){
	  $('#rule-'+index +" .ruleSelect-" + index).val(value.orderBy);
	  $('#rule-'+index +" .quantity-" + index).val(value.quantity);
	  $('#rule-'+index +" .categories-" + index).val(value.categories);
	  $('#rule-'+index +" .categories-" + index).trigger('chosen:updated');
	  $('#rule-'+index +" .tags-" + index).val(value.tags);
	  $('#rule-'+index +" .tags-" + index).trigger('chosen:updated');
	});
  	}
  	vm.getItems = function(){
  		vm.rule_items = [];
  		$.each($('.rule-item'),function(index,value){
  			if($(value).is(':visible')){
		  var rule = {
		  		"position"   : index,
		        "orderBy"    : $(".ruleSelect-" + index).val(),
		        "quantity"   : $(".quantity-" + index).val(),
		        "categories" : $('.categories-'+index).val(),
		        "tags"       : $('.tags-'+index).val()
		  }
		  vm.rule_items.push(rule);
		}
	});
  		return vm.rule_items;
  	}
  	vm.save = function(){
  		var items = vm.getItems();
  		var playlist = {
  			'name'		  : $('#playlist_name').val(),
  			'description' : $('#playlist_description').val(),
  			'items'       : items
  		}
  		var settings = {
	  "async": true,
	  "crossDomain": true,
	  "url": $rootScope.apiUrl + "/api/v1/playlist",
	  "data": {
	  	 "client_id": JSON.parse(localStorage.getItem("session")).client_id,
	  	 "playlist" : playlist,
  			"pid"       : $('#publishers_select').val()
	  },
	  "method": "POST",
	  "headers": {
	    "cache-control": "no-cache",
	  }
	}

	$.ajax(settings)
	.success(function (response) {
	    toastr.success(response.info, 'success');
	    $state.go('playlists', {}, {reload: true});
	})
	.error(function (response) {
	  	toastr.error(response.error, 'error');
	});
  	}
  	vm.modify = function(){
  		var items = vm.getItems();
  		var playlist = {
  			'name'		  : $('#playlist_name').val(),
  			'description' : $('#playlist_description').val(),
  			'items'       : items
  		}
  		var settings = {
	  "async": true,
	  "crossDomain": true,
	  "url": $rootScope.apiUrl + "/api/v1/playlist",
	  "data": {
	  	 "client_id": JSON.parse(localStorage.getItem("session")).client_id,
	  	 "playlist" : playlist,
	  	 "id"       : $stateParams.id,
	  	 "pid"      : $('#publishers_select').val()
	  },
	  "method": "PUT",
	  "headers": {
	    "cache-control": "no-cache",
	  }
	}
	$.ajax(settings).done(function(response) {
        	toastr.success(response.info, 'success');
	    $state.go('playlists', {}, {reload: true});
      })
      .error(function(error){
        	toastr.error(response.error, 'error');
      });
  	}
  	vm.validate = function(edit){
  		var valid = true;
  		//Chequeo nombre de playlist
  		if($('#playlist_name').val() != ''){
  			valid = false;
  			$('#name-msg').fadeOut(300);
  		}else{
  			$('#name-msg').fadeIn(300);
  		}
  		console.log($('#publishers_select').val());
  		if($('#publishers_select').val()  != ''){
  			valid = false;
  			$('#no_publisher_message').fadeOut(300);
  		}else{
  			$('#no_publisher_message').fadeIn(300);
  		}

  		//Chequeo que por lo menos una regla y esten bien
  		if(vm.rule_items.length > 0){
  			$.each($('.rule-item'),function(index,value){
    			if($(value).is(':visible')){
    				var categories = $('.categories-'+index).val();
    				var tags       = $('.tags-'+index).val();
		    	if((categories == null) && (tags == null)){
		    		valid = false;
		    		alert("The rule must have a category or tags");
		    		exit;
		    	}else{
		    		valid = true;
		    	}
			}
		});
  		}else{
  			alert("You must add a rule..");
  			valid = false;
  		}
  		if(valid){
  			if(edit){
  				vm.modify();
  			}else{
  				vm.save();
  			}
  		}
  	}
  	vm.addRow = function(index){
  		//Create item object
  		var tmp_items = vm.getItems();
  		var item = Object.create(vm.rule);
  		vm.rule_items.push(item);
  		vm.rule_select[index]      = 'most_recent';
  		vm.quantity[index]         = '';
  		vm.initialize(index,tmp_items);
  	}
  	vm.removeItem = function(index){
      		$('#rule-'+index).hide();
        }
  }

})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.playlists')
       .controller('PlaylistsCtrl', PlaylistsCtrl);

  /** @ngInject */
  function PlaylistsCtrl($scope, toastr, $rootScope) {
  		var vm 			 = this;
		vm.loading   	 = true;
		vm.playlists 	 = [];
		vm.permissions 	 = [];

		vm.loadPlaylists = function(){
			var settings = {
			  "crossDomain": true,
			  "url": $rootScope.apiUrl + "/api/v1/playlist?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id),
			  "method": "GET"
			}

			$.ajax(settings).done(function (response) {
				vm.loading   	= false;
			  	vm.playlists 	= response.playlists;
			  	vm.permissions 	= response.permissions;
			  	$scope.$apply();
			});
		}
		vm.loadPlaylists();
		vm.deletePlaylist = function(playlist_id){
        	var settings = {
			  "async": true,
			  "crossDomain": true,
			  "url": $rootScope.apiUrl + "/api/v1/playlist",
			  "data": {
			  	 "client_id": JSON.parse(localStorage.getItem("session")).client_id,
			  	 "playlist_id"       : playlist_id
			  },
			  "method": "DELETE",
			  "headers": {
			    "cache-control": "no-cache",
			  }
			}
			if (confirm('Are you sure you want to delete this playlist?')) {
				$.ajax(settings).done(function(response) {
		          	toastr.success(response.info, 'success');
				    vm.loadPlaylists();
		        })
		        .error(function(error){
		          	toastr.error(response.error, 'error');
		        });
			}
        }
        vm.showJson = function(playlist_id){
        	var url = $rootScope.apiUrl + "/api/v1/playlist/"+playlist_id+"/playerId/0";
        	var settings = {
			  "crossDomain": true,
			  "url": url,
			  "method": "GET",
			}

			$.ajax(settings).done(function (json) {
			  	var code = JSON.stringify(json, null, 4);
			  	$('.json-request').text("Request-url: " + url);
			  	$('.json-content').text(code);
        		$('.json-sidebar').fadeIn(300);
			});
        }
        vm.hideJson = function(){
        	$('.json-sidebar').fadeOut(300);
        }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  function ProfilePageCtrl($scope, $rootScope, $crypthmac, toastr, $state) {
      var vm = this;
      vm.user_conf    = [];
      vm.pass1 		   = '';
      vm.pass2 	       = '';
      vm.loadUserConf = function(){
          var session  = JSON.parse(localStorage.getItem('session'));
          var settings = {
              "async": true,
              "crossDomain": true,
              "url": $rootScope.apiUrl + "/api/v1/users?client_id="+ encodeURIComponent(session.client_id) +"&uid=" + session.user_id,
              "method": "GET"
          };
          $.ajax(settings).done(function (response) {
              vm.user_conf = response;
              $scope.$apply();
          });
      };
      vm.loadUserConf();
      vm.validatePassword = function(pass1,pass2){
          var validator = ((pass1 == pass2) && (/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(pass1)));
          return validator;
      };
      vm.saveData = function(){
          var valid = vm.validate();
          var password;
          if (vm.pass1.length > 0){
              password = $crypthmac.encrypt(vm.pass1,"");
          }else {
              password = null;
          }

          if(valid){
              var session  = JSON.parse(localStorage.getItem('session'));
              var settings = {
                  "url": $rootScope.apiUrl + "/api/v1/users/profile?client_id=" + encodeURIComponent(session.client_id) +"&uid=" + session.user_id + "&name=" + $('#inputFirstName').val() + "&last_name=" + $('#inputLastName').val() + "&password=" + password,
                  "method": "PUT",
                  "headers": {
                      "cache-control": "no-cache"
                  }
              };
              $.ajax(settings)
                  .success(function (response) {
                      toastr.success('The user has been updated successfully!', 'User Edit');
                      $state.go('dashboard');
                  })
                  .error(function (response) {
                      console.log(response);
                  })
          }
      };
      vm.validate = function(){
          var name         = $('#inputFirstName').val();
          var last_name    = $('#inputLastName').val();
          var email        = $('#inputEmail3').val();
          var validator    = vm.validatePassword(vm.pass1, vm.pass2);
          if(validator && name.length > 3 && last_name.length > 3){
              console.log("paso validacion");
              return true;
          }else{
              alert("Please check the mandatory fields with *");
              return false;
          }
      }
      // $scope.picture = $filter('profilePicture')('Nasta');
      // $scope.removePicture = function () {
      //   $scope.picture = $filter('appImage')('theme/no-photo.png');
      //   $scope.noPicture = true;
      // };
      // $scope.uploadPicture = function () {
      //   var fileInput = document.getElementById('uploadFile');
      //   fileInput.click();
      // };
      // $scope.getFile = function () {
      //   fileReader.readAsDataUrl($scope.file, $scope)
      //       .then(function (result) {
      //         $scope.picture = result;
      //       });
      // };
  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.realtime')
      .controller('RealtimeCtrl', RealtimeCtrl)

  /** @ngInject */
  function RealtimeCtrl($scope, $rootScope, $sce) {
    var vm         = this;
    vm.publishers  = [];
    vm.source      = "";

    var session  = JSON.parse(localStorage.getItem('session'));
    
    var settings   = {
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/api/v1/publisher/restricted/" + session.client_id,
        "method": "GET"
    };

    $.ajax(settings).done(function(publishers) {
        vm.publishers = publishers.map(function(pub){
            return {"id" : pub.id, "name" : pub.value }
        });
        vm.selected_publishers = vm.publishers[0].id;
        vm.refreshPublisher();
    });


    vm.refreshPublisher = function() {
      vm.source = $sce.trustAsResourceUrl($rootScope.rtUrl + "/realtime?token="+encodeURIComponent(session.client_id)+"&pid="+vm.selected_publishers);
    }
   
  }
})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.scheduler')
    .controller('SchedulerCtrl', SchedulerCtrl);
  	function SchedulerCtrl($scope, $rootScope, $state, $uibModal, baConfig) {
	  	var vm = this;

  		vm.showContainer = function(){
  			$uibModal.open({
	          animation: true,
	          size: 'lg',
	          templateUrl: 'app/pages/scheduler/schedulerModal.html',                
	          scope: $scope
        });
  		}
  	}
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.scheduler')
    .controller('SchedulerModalCtrl', SchedulerModalCtrl);
  	
  	function SchedulerModalCtrl($scope, $rootScope, $state, $uibModal) {
	  	var vm = this;
      vm.date = {
        start : moment().format('YYYY-MM-DD'),
        end   : moment().format('YYYY-MM-DD')
      }
      vm.opts = {
        format: 'YYYY-MM-DD',
        singleDatePicker: true,
      }
  		$('.timepickerElement').timepicker();

      if(typeof($scope.start) != 'undefined'){
          setTimeout(function(){ 
            $('#scheduleDateRangeStart').val($scope.start);
            $('#scheduleDateRangeEnd').val($scope.start);
          }, 100);
      }

  	}
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration')
    .controller('CredentialsCtrl', CredentialsCtrl);

  function CredentialsCtrl($scope, $rootScope, toastr) {
      var vm = this;
      vm.credentials = [];

      vm.loadCredentials = function(){
        var session  = JSON.parse(localStorage.getItem('session'));
        var settings = {
          "async": true,
          "crossDomain": true,
          "url": $rootScope.apiUrl + "/auth/credentials?client_id=" + encodeURIComponent(session.client_id) + "&group_id=" + session.group_id,
          "method": "GET",
          "headers": {
            "cache-control": "no-cache",
          }
        }

        $.ajax(settings).done(function (response) {
           vm.credentials = response;
           $scope.$apply();
        });
      }
      vm.loadCredentials();

      vm.generateCredential = function(){
        var session  = JSON.parse(localStorage.getItem('session'));
        var settings = {
          "async": true,
          "crossDomain": true,
          "url": $rootScope.apiUrl + "/auth/credentials",
          "data": {
              "client_id" : session.client_id,
              "group_id"  : session.group_id
          },
          "method": "POST",
          "headers": {
            "cache-control": "no-cache",
          }
        }

        $.ajax(settings).done(function (response) {
            vm.loadCredentials();
        }); 
      }
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration')
    .controller('ProfileGroupCtrl', ProfileGroupCtrl)
    .directive('switch', switchDirective);

  function ProfileGroupCtrl($scope,$http, $sce, $rootScope, $stateParams, $state, toastr) {
    var vm               = this;
    vm.action            = $state.current.name;
    vm.categories        = [];

    vm.loadCategories = function(){
      var settings = {
          "crossDomain": true,
          "url": $rootScope.apiUrl + "/api/v1/categories",
          "data":{
              'client_id': JSON.parse(localStorage.getItem('session')).client_id,
              'view_all' : 1
          },
          "method": "POST",
          "headers": {
            "cache-control": "no-cache",
          }
      }
      $.ajax(settings).done(function(response) {
          var tree_data = response;
          $('#tree_categories').jstree(
            {
              'core': {
                'data' : tree_data,
                'check_callback': true,
                'themes': {
                  'responsive': true
                }
              },
              'types': {
                'folder': {
                  'icon': 'ion-ios-folder'
                },
                'default': {
                  'icon': 'ion-ios-folder'
                }
              },
              "checkbox": {
                    "keep_selected_style": false
              },
              "plugins": ['checkbox','types']
            }
          );
          $('#tree_categories').bind('loaded.jstree',function(e,data){
              $.each(vm.categories,function(index,value){
                  $('#tree_categories').jstree("open_all");
                  $('#tree_categories').jstree('select_node',value);
              });
          });
      });
    }    
    vm.loadConf = function(){
      var settings = {
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/api/v1/profile-groups/"+$stateParams.group.id,
        "method": "GET",
        "headers": {
          "cache-control": "no-cache",
        }
      }

      $.ajax(settings).done(function (response) {
          //To get the value is $('#cat_edit').find('input').bootstrapSwitch("state");
          //Name
          $('#inputFirstName').val(response.name);
          //Categories
          $('#cat_create').find('input').bootstrapSwitch("state",response.cat_create);
          $('#cat_delete').find('input').bootstrapSwitch("state",response.cat_delete);
          $('#cat_edit').find('input').bootstrapSwitch("state",response.cat_edit);
          //Player
          $('#player_create').find('input').bootstrapSwitch("state",response.player_create);
          $('#player_delete').find('input').bootstrapSwitch("state",response.player_delete);
          $('#player_edit').find('input').bootstrapSwitch("state",response.player_edit);
          //Content
          $('#content_create').find('input').bootstrapSwitch("state",response.content_create);
          $('#content_delete').find('input').bootstrapSwitch("state",response.content_delete);
          $('#content_edit').find('input').bootstrapSwitch("state",response.content_edit);
          //Playlist
          $('#playlist_create').find('input').bootstrapSwitch("state",response.playlist_create);
          $('#playlist_delete').find('input').bootstrapSwitch("state",response.playlist_delete);
          $('#playlist_edit').find('input').bootstrapSwitch("state",response.playlist_edit);
          //DVR && Dashboard
          $('#dvr').find('input').bootstrapSwitch("state",response.dvr);
          $('#dashboard').find('input').bootstrapSwitch("state",response.dashboard);
          $('#content_download').find('input').bootstrapSwitch("state",response.content_download);

          vm.profile    = response;
          vm.categories = response.categories;
          $scope.$apply();   
          vm.loadCategories();       
      });
    }
    vm.valid = function(){
        var result     = false;
        var name       = $('#inputFirstName').val();
        var categories = $("#tree_categories").jstree('get_checked');
        if((name.length > 3) && (categories.length > 0)){
          result = true;
        }
        return result;
    }
    vm.saveProfile = function(){
        var validation = vm.valid();
        if(validation){
          var profile_id   = (typeof($stateParams.group) != 'undefined')? $stateParams.group.id : 0;
          var undetermined = [];
          $.each($('.jstree-undetermined'),function(index,value){
              undetermined.push($(value).parent().attr("id").split('_anchor')[0]);
          });
          var categories = $("#tree_categories").jstree('get_checked');
          categories     = categories.concat(undetermined);
          var settings   = {
            "async": true,
            "crossDomain": true,
            "url": $rootScope.apiUrl + "/api/v1/profile-groups",
            "data": {
              'group_id'         :  JSON.parse(localStorage.getItem("session")).group_id,
              'profile_id'       :  profile_id,
              'client_id'        :  JSON.parse(localStorage.getItem("session")).client_id,
              'name'             :  $('#inputFirstName').val(),
              'cat_create'       :  $('#cat_create').find('input').bootstrapSwitch("state"),
              'cat_delete'       :  $('#cat_delete').find('input').bootstrapSwitch("state"),
              'cat_edit'         :  $('#cat_edit').find('input').bootstrapSwitch("state"),
              'player_create'    :  $('#player_create').find('input').bootstrapSwitch("state"),
              'player_delete'    :  $('#player_delete').find('input').bootstrapSwitch("state"),
              'player_edit'      :  $('#player_edit').find('input').bootstrapSwitch("state"),
              'playlist_create'  :  $('#playlist_create').find('input').bootstrapSwitch("state"),
              'playlist_delete'  :  $('#playlist_delete').find('input').bootstrapSwitch("state"),
              'playlist_edit'    :  $('#playlist_edit').find('input').bootstrapSwitch("state"),
              //'dvr'              :  $('#dvr').find('input').bootstrapSwitch("state"),
              'dashboard'        :  $('#dashboard').find('input').bootstrapSwitch("state"),
              'content_download' :  $('#content_download').find('input').bootstrapSwitch("state"),
              'categories'       :  JSON.stringify(categories)
            },
            "method": "POST",
            "headers": {
              "cache-control": "no-cache",
            }
          }
          $.ajax(settings)
            .success(function (response) {
                toastr.success("Profile created successfully!", 'Profile System');
                window.history.back();
            })
            .error(function(error){
                toastr.error(error.responseJSON.error, 'Profile System');
            });
        }else{
          alert("The name must be bigger than 3 characters and you must select a category");
        }
    }    
    if(vm.action == 'profiles-create'){
      //Estoy en un create
      vm.btn_action = 'Create Group';
      vm.loadCategories();
    }else{
      //Estoy en un edit      
      if($stateParams.group == null){
        toastr.error('You must select a profile group first', 'Error on group edit');
        $state.go('administration.profiles');
      }else{
        vm.loadConf();
  		  vm.btn_action = 'Save Changes';
  		  vm.group      = $stateParams.group;
      }
  		
  	}

  }

  function switchDirective($timeout) {
      return {
        restrict: 'EA',
        replace: true,
        scope: {
          ngModel: '='
        },
        template: function(el, attrs) {
          return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
        },
        link: function (scope, elem, attr) {
          $timeout(function(){
            var input = $(elem).find('input');
            input.bootstrapSwitch({
              size: 'small',
              onColor: attr.color
            });
            input.on('switchChange.bootstrapSwitch', function(event, state) {
              scope.ngModel = state;
              scope.$apply();
            });

          });
        }
      };
  }  
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration')
    .controller('ProfileGroupsListCtrl', ProfileGroupsListCtrl);

  /** @ngInject */
  function ProfileGroupsListCtrl($scope,$http, $sce, $rootScope, $state, toastr) {
	var vm = this;
	vm.loading = false;
	vm.page    = 1;	
  vm.groups  = [];	
	vm.loadGroupsProfile = function(){
		vm.loading   = true;
		var settings = {
		  "async": true,
		  "crossDomain": true,
		  "url": $rootScope.apiUrl + "/api/v1/profile-groups/list?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id),
		  "method": "GET",
		  "headers": {
		    "cache-control": "no-cache"
		  }
		}

		$.ajax(settings).done(function (response) {
			  vm.loading = false;
		  	vm.groups  = response;
		  	$scope.$apply();
		});		
	}
	vm.loadGroupsProfile();
    vm.lockedError = function(){
    	toastr.info('This group cannot be edited', 'Info');
    }
    vm.removeProfile = function(profile_id){
    	console.log(profile_id);
    	var settings = {
            "async": true,
            "crossDomain": true,
            "url": $rootScope.apiUrl + "/api/v1/profile-groups?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id) + '&profile_id=' + profile_id,
            "method": "DELETE",
            "headers": {
              "cache-control": "no-cache",
            }
          }
          $.ajax(settings)
            .success(function (response) {
                toastr.success("Profile deleted successfully!", 'Profile System');
                vm.loadGroupsProfile();
            })
            .error(function(error){
                toastr.error(error.responseJSON.error, 'Profile System');
            });
    }
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration')
    .controller('SchemaCtrl', SchemaCtrl);

  function SchemaCtrl($scope,$http, $sce, $rootScope, $state, $filter, editableOptions, editableThemes, toastr , $stateParams) {
  	var vm = this;
  	vm.loading     = false;
  	vm.publishers  = [];
    vm.schemas     = [];
    vm.loadPublishers = function(){
      	vm.loading = true;
      	var settings = {
    		  "async": true,
    		  "crossDomain": true,
    		  "url": $rootScope.apiUrl + "/api/v1/publisher/" +  JSON.parse(localStorage.getItem("session")).client_id,
    		  "method": "GET",
    		  "headers": {
    		    "cache-control": "no-cache",
    		  }
  		  }
  		  $.ajax(settings).done(function (response) {
    			vm.loading = false;
    		  	vm.publishers = response;
    		  	$scope.$apply();
            if($stateParams.type == 'edit'){
              $('#select-publisher').val($stateParams.schema.pid);
              vm.loadSchemaConf();
              $scope.$apply();
            }
    		});
    }
    vm.loadSchemaConf = function(){
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/api/v1/schema?client_id="+encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id)+"&pid="+$stateParams.schema.pid+"&name="+$stateParams.schema.name,
        "method": "GET",
        "headers": {
          "cache-control": "no-cache",
        }
      }

      $.ajax(settings).done(function (response) {
         vm.schemas      = response;
         vm.schemas.name = $stateParams.schema.name;
         $scope.$apply();
      });
    }
    vm.initialize = function(){
      vm.loadPublishers();      
    }
    vm.initialize();
    vm.RemoveProperty = function(index) {
    	if (confirm('Are you sure you want to delete this property?')) {
      		vm.schemas.splice(index, 1);
		  }
    };
    vm.addProperty = function() {
      vm.inserted = {
        id: '',
        value: '',
      };
      vm.schemas.push(vm.inserted);
    };   
    vm.saveRows = function(){
      var valid = vm.validateRows();
      if(valid){
        if($stateParams.type == 'edit'){
        		var settings = {
      			  "async": true,
      			  "crossDomain": true,
      			  "url": $rootScope.apiUrl + "/api/v1/schema",
      			  "data": {
      			  		"client_id"	: JSON.parse(localStorage.getItem("session")).client_id,
      			  		"rows"      : vm.schemas,
                  "type"      : $stateParams.type,
                  "name"      : vm.schemas.name,
                  "old_name"  : $stateParams.schema.name,
                  "pid"       : $('#select-publisher').val()
      			  },
      			  "method": "POST",
      			  "headers": {
      			    "cache-control": "no-cache",
      			  }
            }
			 }else{
            var settings = {
              "async": true,
              "crossDomain": true,
              "url": $rootScope.apiUrl + "/api/v1/schema",
              "data": {
                  "client_id" : JSON.parse(localStorage.getItem("session")).client_id,
                  "rows"      : vm.schemas,
                  "type"      : $stateParams.type,
                  "name"      : vm.schemas.name,
                  "pid"       : $('#select-publisher').val()
              },
              "method": "POST",
              "headers": {
                "cache-control": "no-cache",
              }
            }
       }

			$.ajax(settings)
            .success(function (response) {
                if($stateParams.type == 'edit'){
                  var text = 'Schema updated!';
                }else{
                  var text = 'Schema created!';
                }
                toastr.success(text, 'System Admin');
                window.history.back();
            })
            .error(function (response) {
                toastr.error(response.error, 'System Admin');
                console.log(response);
            })
      
    	}else{
    		alert("Property name could not be empty!");
    	}
    }
    vm.validateRows = function(){
    	var validation = true;
		$.each(vm.schemas,function(index,item){
		  if(item.value == ''){
		    validation = false;
		  }
		});

    	return validation;
    }
    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration')
    .controller('SchemaListCtrl', SchemaListCtrl);

  /** @ngInject */
  function SchemaListCtrl($scope, $rootScope, toastr) {
  	var vm         = this;
    vm.loading     = false;
    vm.noContent   = false;
    vm.schemasList = [];
    vm.loadSchemas = function(){
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/api/v1/schema/list?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id),
        "method": "GET",
        "headers": {
          "cache-control": "no-cache",
        }
      }

      $.ajax(settings).done(function (response) {
          vm.schemasList = response;
          if(response.length == 0){
            vm.noContent = true;
          }else{
            vm.noContent = false;
          }
          $scope.$apply();
      });
    }
    vm.loadSchemas();
  }


})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration')
    .controller('ABMPublishersListCtrl', ABMPublishersListCtrl);
  function ABMPublishersListCtrl($scope,$rootScope,$state, toastr) {
  	var vm = this;
  	vm.loading          = false;
  	vm.publishers       = [];
    vm.apiUrl           = $rootScope.apiUrl;
    vm.loadPublishers = function(){
    	vm.loading = true;
    	var settings = {
  		  "async": true,
  		  "crossDomain": true,
  		  "url": $rootScope.apiUrl + "/api/v1/publisher/" + JSON.parse(localStorage.getItem("session")).client_id,
  		  "method": "GET",
  		  "headers": {
  		      "cache-control": "no-cache",
  		  }
      }
  		$.ajax(settings).done(function (response) {
  			vm.loading = false;
  		  	vm.publishers = response;
  		  	$scope.$apply();          
  		});
    }
    vm.saveChanges = function(){      
      vm.loading = true;
      var items = [];
      $.each($('.une'),function(index,value){
        var id   = $(value).attr("id").split("une-")[1];
        var val  = $(value).val();
        var trxe = $('#trxe-'+id).val();
        var item = {
          "id"    : id,
          "value" : val,
          "trxe"  : trxe
        }
        items.push(item);
      });
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/api/v1/publisher/edit",
        "method": "POST",
        "data" : {
          "client_id" : JSON.parse(localStorage.getItem("session")).client_id,
          "items"     : items
        },
        "headers": {
            "cache-control": "no-cache",
        }
      }

      $.ajax(settings)
        .success(function (response) {
            vm.loading = false;
            toastr.success("Publisher/s Updated!", 'Publisher System');
            vm.loadPublishers();
        })
        .error(function(error) {
            toastr.error(response.error, 'error');
        });
    }
    vm.loadPublishers();
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration')
    .controller('PublishersListCtrl', PublishersListCtrl);

  function PublishersListCtrl($scope,$http, $sce, $rootScope, $state, $filter, editableOptions, editableThemes, toastr) {
  	var vm = this;
  	vm.loading = false;
  	vm.publishers = [];
    vm.loadPublishers = function(){
    	vm.loading = true;
    	var settings = {
		  "async": true,
		  "crossDomain": true,
		  "url": $rootScope.apiUrl + "/api/v1/publisher/list/" + JSON.parse(localStorage.getItem("session")).client_id,
		  "method": "GET",
		  "headers": {
		    "cache-control": "no-cache",
		  }
		}

		$.ajax(settings).done(function (response) {
			vm.loading = false;
		  	vm.publishers = response;
		  	$scope.$apply();
		});
    }
    vm.loadPublishers();
    /*vm.removePublisher = function(index) {
    	if (confirm('Are you sure you want to delete this publisher?')) {
      		vm.publishers.splice(index, 1);
		}
    };*/
    vm.addPublisher = function() {
      vm.inserted = {
        id: '',
        value: '',
        group_id: '',
        group: '',
      };
      vm.publishers.push(vm.inserted);
    };   
    vm.saveRows = function(){
    	var valid = vm.validateRows();
    	if(valid){
    		var settings = {
			  "async": true,
			  "crossDomain": true,
			  "url": $rootScope.apiUrl + "/api/v1/publisher/admin",
			  "data": {
			  		"client_id"	: JSON.parse(localStorage.getItem("session")).client_id,
			  		"rows"      : vm.publishers
			  },
			  "method": "POST",
			  "headers": {
			    "cache-control": "no-cache",
			  }
			}

			$.ajax(settings)
            .success(function (response) {
                toastr.success('GID & PID updated!', 'System Admin');
                vm.loadPublishers();
            })
            .error(function (response) {
                toastr.error(response.error, 'System Admin');
                console.log(response);
            })
    	}else{
    		alert("Group and Publisher could not be empty!");
    	}
    }
    vm.validateRows = function(){
    	var validation = true;
		$.each(vm.publishers,function(index,item){
		  if((item.value == '') || (item.group == '')){
		    validation = false;
		  }
		});

    	return validation;
    }
    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration')
    .controller('UserCtrl', UserCtrl);

  /** @ngInject */
  function UserCtrl($scope,$http, $sce, $rootScope, $stateParams, $state, toastr, $crypthmac) {
  	var vm          = this;
    vm.action       = $state.current.name;
    vm.profiles     = [];
    vm.user_conf    = [];
    vm.group_id     = JSON.parse(localStorage.getItem("session")).group_id;

    vm.hashCode  = function(length) {
      var hash   = '';
      var chars  = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!@#';
        for (var i = length; i > 0; --i) hash += chars[Math.floor(Math.random() * chars.length)];
        return hash;
    }
    vm.loadProfiles = function(profile){
      var settings = {
        "async": false,
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/api/v1/profile-groups/list/groupId/" + vm.group_id,
        "method": "GET"        
      }

      $.ajax(settings).done(function (response) {
          vm.profiles = response;
          setTimeout(function() {
            $scope.$apply();
            $('#user_profile').val(parseInt(profile));
          }, 200);
      });
    }
    vm.loadUserConf = function(){
      var session  = JSON.parse(localStorage.getItem('session'));
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/api/v1/users?client_id="+ encodeURIComponent(session.client_id) +"&uid=" + $stateParams.user ,
        "method": "GET"
      }

      $.ajax(settings).done(function (response) {
          vm.user_conf = response;
          vm.loadProfiles(response.user_profile);          
          if(response.status == 'enabled'){
            $('input[type="checkbox"]').bootstrapSwitch("state",true);
          }else{
            $('input[type="checkbox"]').bootstrapSwitch("state",false)
          }
          $scope.$apply();
      });
    }
    vm.validate = function(){
        var name         = $('#inputFirstName').val();
        var last_name    = $('#inputLastName').val();
        var user_profile = $('#user_profile').val();
        var email        = $('#inputEmail3').val();
        if(name.length > 3 && last_name.length > 3 && user_profile != null && email != ''){
            console.log("paso validacion");
            return true;
        }else{
            alert("Please check the mandatory fields with *");
            return false;
        }
    }
  	if(vm.action == 'create'){
  		//Estoy en un create
      vm.loadProfiles('');
  		vm.btn_action = 'Create User';
  		vm.hash       = vm.hashCode(8);
      vm.saveData = function(){
        var valid = vm.validate();
        if(valid){
          //vm.encrypted_pass = $crypthmac.encrypt(vm.password,"");
          var session  = JSON.parse(localStorage.getItem('session'));
            var settings = {
              "async": true,
              "crossDomain": true,
              "url": $rootScope.apiUrl + "/api/v1/users",
              "data": {
                          "client_id"     : session.client_id,
                          "name"          : $('#inputFirstName').val(),
                          "last_name"     : $('#inputLastName').val(),
                          "email"         : $('#inputEmail3').val().toLowerCase(),
                          "pass"          : vm.hash,
                          "password"      : $crypthmac.encrypt(vm.hash,""),
                          "user_profile"  : $('#user_profile').val(),
                          "group_id"      : vm.group_id
              },
              "method": "POST",
              "headers": {
                "cache-control": "no-cache",
              }
            }

            $.ajax(settings)
            .success(function (response) {
                toastr.success('The user has been created successfully!', 'User Creation');
                $state.go('administration.users');
            })
            .error(function (response) {
                toastr.error(response.responseJSON.error, 'User Creation');
                console.log(response);
            })
        }
      }
  	}else{
  		//Estoy en un edit
      if($stateParams.user == null){
        toastr.error('You must select a user first', 'Error on user edit');
        $state.go('administration.users');
      }else{
        vm.btn_action = 'Save Changes';
        vm.user      = $stateParams.user;        
        vm.loadUserConf();
        vm.saveData = function(){
          var valid = vm.validate();
          if(valid){
            var session  = JSON.parse(localStorage.getItem('session'));
            var settings = {
              "async": true,
              "crossDomain": true,
              "url": $rootScope.apiUrl + "/api/v1/users?client_id=" + encodeURIComponent(session.client_id) +"&uid=" + $stateParams.user + "&name=" + $('#inputFirstName').val() + "&last_name=" + $('#inputLastName').val() + "&group=" + vm.group_id + "&user_profile=" + $('#user_profile').val() + '&status=' + $('input[type="checkbox"]').bootstrapSwitch("state"),
              "method": "PUT",
              "headers": {
                "cache-control": "no-cache",
              }
            }

            $.ajax(settings)
              .success(function (response) {
                  toastr.success('The user has been updated successfully!', 'User Edit');
                  $state.go('administration.users');
              })
              .error(function (response) {
                  console.log(response);
              })
          }
        }
      }
  	}

  }


})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration')
    .controller('UsersListCtrl', UsersListCtrl);

  function UsersListCtrl($scope,$http, $sce, $rootScope, $state) {
  	var vm = this;
	vm.loading     = false;
	vm.noContent   = false;
	vm.search_user = '';
	vm.page        = 1;

	vm.loadUsers = function(){
		vm.loading 	 = true;
		vm.noContent = false;
		var session   	   = JSON.parse(localStorage.getItem('session'));
		var settings  = {
		  "async": true,
		  "crossDomain": true,
		  "url": $rootScope.apiUrl + "/api/v1/users/list?client_id=" + encodeURIComponent(session.client_id) + "&group_id=" + session.group_id,
		  "method": "GET",
		  "headers": {
		    "cache-control": "no-cache",
		  }
		}

		$.ajax(settings).done(function (response) {
			vm.loading = false;
			vm.users   = response;
			$scope.$apply();
		});
	}
	vm.loadUsers();

	vm.searchUser = function(){
		if((vm.search_user.length >= 3) || (vm.search_user.length == 0)){
			if(vm.timeoutSearch){
		        clearTimeout(vm.timeoutSearch);
		    }
		      vm.timeoutSearch =  setTimeout(function() {
		          var query = vm.search_user;
		          if(query != ''){
		          	var session = JSON.parse(localStorage.getItem('session'));
		            vm.loading = true;
		            var settings = {
					  "async": true,
					  "crossDomain": true,
					  "url": $rootScope.apiUrl + "/api/v1/users/search?client_id=" + encodeURIComponent(session.client_id) + "&query=" + vm.search_user + "&group_id=" + session.group_id,
					  "method": "GET",
					  "headers": {
					    "cache-control": "no-cache",
					  }
					}
		            $.ajax(settings).done(function(response) {
		                vm.users = response;
		                vm.loading = false;
		                if(vm.users.total == 0){
		                	vm.noContent = true;
		                }else{
		                	vm.noContent = false;
		                }
						$scope.$apply();
		                $.each($('.markeable'),function(index,value){    
		                    var src_str = $(value).text();
		                    var term = query;
		                    term = term.replace(/(\s+)/,"(<[^>]+>)*$1(<[^>]+>)*");
		                    var pattern = new RegExp("("+term+")", "gi");

		                    src_str = src_str.replace(pattern, "<mark>$1</mark>");
		                    src_str = src_str.replace(/(<mark>[^<>]*)((<[^>]+>)+)([^<>]*<\/mark>)/,"$1</mark>$2<mark>$4");

		                    $(value).html(src_str);
		                });
		            });
		          }else{
		            vm.loadUsers();
		          }
		      }, 100);
		}
	}

  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
      .controller('MailTabCtrl', MailTabCtrl);

  /** @ngInject */
  function MailTabCtrl(composeModal, mailMessages) {

    var vm = this;
    vm.navigationCollapsed = true;
    vm.showCompose = function(subject, to , text){
      composeModal.open({
        subject : subject,
        to: to,
        text: text
      })
    };

    vm.tabs = mailMessages.getTabs();
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('mailMessages', mailMessages);

  /** @ngInject */
  function mailMessages($sce) {
    var messages = [
      {
        "id": "4563faass",
        "name": "Nasta Linnie",
        "subject": "Great text",
        "date": "2015-08-28T07:57:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Check out this cool text.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "attachment": "poem.txt",
        "position": "Great Employee",
        "tag": "friend",
        "labels": ['inbox']
      },
      {
        "id": "4563fdfvd",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-11-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ex mauris, ultrices vel lectus quis, scelerisque hendrerit ipsum. Suspendisse ullamcorper turpis neque, eget dapibus magna placerat ac. Suspendisse rhoncus ligula ac mi tempus varius ut sed lacus. Sed et commodo nulla, et placerat leo. Nam rhoncus vulputate sem non pharetra. Praesent fringilla massa in laoreet convallis. Aliquam lobortis dui a congue facilisis. Aenean dapibus semper semper. Quisque aliquam, nibh dapibus interdum condimentum, ex velit tempor tortor, at vestibulum magna leo quis leo. Morbi pulvinar varius erat ac rutrum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In hac habitasse platea dictumst.</p>" +
          "<br><p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "4563zxcss",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-10-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey Nasta, </p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "work",
        "labels": ['sent', 'important']
      },
      {
        "id": "8955sddf",
        "name": "Nick Cat",
        "subject": "New Design",
        "date": "2015-05-05T12:59:45",
        "body": $sce.trustAsHtml("<p>Hey John, Consectetur adipiscing elit</p><br>" +
          "<p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "attachment": "design.psd",
        "tag": "work",
        "labels": ['inbox']
      },
      {
        "id": "8955sdfcc",
        "name": "Nick Cat",
        "subject": "Gift card",
        "date": "2015-07-18T10:19:01",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Consectetur adipiscing elit, Lorem ipsum dolor sit amet</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "8955asewf",
        "name": "Nick Cat",
        "subject": "Some news",
        "date": "2015-09-23T03:04:10",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "work",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334uudsa",
        "name": "Kostya Danovsky",
        "subject": "Street Art",
        "date": "2015-11-22T10:05:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Aliquam eu facilisis eros, quis varius est.</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Lorem ipsum dolor sit amet! Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed." +
          "Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "attachment": "file.doc",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334aefvv",
        "name": "Kostya Danovsky",
        "subject": "New product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Aliquam eu facilisis eros, quis varius est. Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Nulla facilisi. Nulla congue, arcu eget blandit lacinia, leo ante ullamcorper lectus, vel pulvinar justo ipsum vitae justo." +
          "Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334cvdss",
        "name": "Kostya Danovsky",
        "subject": "Old product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<br>"+
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "study",
        "labels": ['trash']
      },
      {
        "id": "8223xzxfn",
        "name": "Andrey Hrabouski",
        "subject": "Skype moji",
        "date": "2015-07-16T06:47:53",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Lorem ipsum dolor I find moji in skype sit amet!.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['trash']
      },
      {
        "id": "8223sdffn",
        "name": "Andrey Hrabouski",
        "subject": "My App",
        "date": "2015-06-20T07:05:02",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur My Falasson App elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['spam']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "Cool",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['draft']
      },
      {
        "id": "8223xsdaa",
        "name": "Andrey Hrabouski",
        "subject": "Car rent",
        "date": "2015-02-25T10:58:58",
        "body": $sce.trustAsHtml("<p>Hey Andrey. </p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": "family",
        "labels": ['draft']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "What next",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Esse esse labore tempor ullamco ullamco. Id veniam laborum c.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['sent']
      }
    ].sort(function (a, b) {
        if (a.date > b.date) return 1;
        if (a.date < b.date) return -1;
      }).reverse();
    var tabs = [{
      label: 'inbox',
      name: 'Inbox',
      newMails: 7
    }, {
      label: 'sent',
      name: 'Sent Mail'
    }, {
      label: 'important',
      name: 'Important'
    }, {
      label: 'draft',
      name: 'Draft',
      newMails: 2
    }, {
      label: 'spam',
      name: 'Spam'
    }, {
      label: 'trash',
      name: 'Trash'
    }];

    return{
      getTabs : function(){
        return tabs
      },
      getMessagesByLabel : function(label){
        return messages.filter(function(m){
          return m.labels.indexOf(label) != -1;
        });
      },
      getMessageById : function(id){
        return messages.filter(function(m){
          return m.id == id;
        })[0];
      }
    }

  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.administration')
    .controller('TranscoderOptionsCtrl', TranscoderOptionsCtrl);

  function TranscoderOptionsCtrl($scope,$http, $sce, $rootScope, $state,toastr) {
  	var vm = this;
  	vm.loading = false;
  	vm.publishers = [];
    vm.models = {};

    vm.loadPublishers = function(){
    	vm.loading = true;
    	var settings = {
  		  "async": true,
  		  "crossDomain": true,
  		  "url": $rootScope.apiUrl + "/api/v1/publisher/transcoder/" + JSON.parse(localStorage.getItem("session")).client_id,
  		  "method": "GET",
  		  "headers": {
  		    "cache-control": "no-cache",
  		  }
  		}

  		$.ajax(settings).done(function (response) {
  			vm.loading = false;
  		  	vm.publishers = response.publishers;
          vm.models     = response.qualities;
          $.each(response.publishers,function(index,value){
            vm.models['defaultMobile_' + value.id]       = value.defaultMobile;
            vm.models['defaultDesktop_' + value.id]      = value.defaultDesktop;
            vm.models['defaultTranscoder_' + value.id]   = value.defaultTranscoder;
            vm.models['preview_' + value.id]             = value.preview;
            vm.models['desktop_240P_' + value.id]        = false;
            vm.models['desktop_360P_' + value.id]        = false;
            vm.models['desktop_480P_' + value.id]        = false;
            vm.models['desktop_720P_' + value.id]        = false;
            vm.models['desktop_1080P_' + value.id]       = false;
            vm.models['mobile_240P_' + value.id]         = false;
            vm.models['mobile_360P_' + value.id]         = false;
            vm.models['mobile_480P_' + value.id]         = false;
            vm.models['mobile_720P_' + value.id]         = false;
            vm.models['mobile_1080P_' + value.id]        = false;

            value.qualitiesDesktop.split(",").map(function(item) {
                vm.models['desktop_'+ item + '_' + value.id] = true;
            });
            value.qualitiesMobile.split(",").map(function(item) {
                vm.models['mobile_'+ item + '_' + value.id] = true;
            });
          });
  		  	$scope.$apply();
  		});
    }
    vm.applyChanges = function(){
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/api/v1/publisher/transcoder?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id) + '&models=' + JSON.stringify(vm.models),
        "method": "PUT",
        "headers": {
          "cache-control": "no-cache",
        }
      }

      $.ajax(settings).done(function (response) {
          toastr.success('Updated successfully!', 'Cloud Transcoder');
      });
    }
    vm.loadPublishers();

  }

})();

/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.tree')
    .controller('treeCtrl', treeCtrl);

  /** @ngInject */
  function treeCtrl($scope, $timeout) {

    $scope.ignoreChanges = false;
    var newId = 0;
    $scope.ignoreChanges = false;
    $scope.newNode = {};

    $scope.basicConfig = {
      core: {
        multiple: false,
        check_callback: true,
        worker: true
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      'plugins': ['types'],
      'version': 1
    };

    $scope.dragConfig = {
      'core': {
        'check_callback': true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      "plugins": ["dnd", 'types']
    };

    $scope.addNewNode = function () {
      $scope.ignoreChanges = true;
      var selected = this.basicTree.jstree(true).get_selected()[0];
      if (selected)
        $scope.treeData.push({
          id: (newId++).toString(),
          parent: selected,
          text: "New node " + newId,
          state: {opened: true}
        });
      $scope.basicConfig.version++;
    };


    $scope.refresh = function () {
      $scope.ignoreChanges = true;
      newId = 0;
      $scope.treeData = getDefaultData();
      $scope.basicConfig.version++;
    };

    $scope.expand = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = true;
      });
      $scope.basicConfig.version++;
    };

    $scope.collapse = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = false;
      });
      $scope.basicConfig.version++;
    };

    $scope.readyCB = function() {
      $timeout(function() {
        $scope.ignoreChanges = false;
      });
    };


    $scope.applyModelChanges = function() {
      return !$scope.ignoreChanges;
    };

    $scope.treeData = getDefaultData();
    $scope.dragData = [
      {
        "id": "nd1",
        "parent": "#",
        "type": "folder",
        "text": "Node 1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd2",
        "parent": "#",
        "type": "folder",
        "text": "Node 2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd3",
        "parent": "#",
        "type": "folder",
        "text": "Node 3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd4",
        "parent": "#",
        "type": "folder",
        "text": "Node 4",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd5",
        "parent": "nd1",
        "text": "Node 1.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd6",
        "parent": "nd1",
        "text": "Node 1.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd7",
        "parent": "nd1",
        "text": "Node 1.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd8",
        "parent": "nd2",
        "text": "Node 2.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd9",
        "parent": "nd2",
        "text": "Node 2.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd10",
        "parent": "nd2",
        "text": "Node 2.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd11",
        "parent": "nd3",
        "text": "Node 3.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd12",
        "parent": "nd3",
        "text": "Node 3.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd13",
        "parent": "nd3",
        "text": "Node 3.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd14",
        "parent": "nd4",
        "text": "Node 4.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd15",
        "parent": "nd4",
        "text": "Node 4.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd16",
        "parent": "nd4",
        "text": "Node 4.3",
        "state": {
          "opened": true
        }
      }
    ];

    function getDefaultData() {
      return [
        {
          "id": "n1",
          "parent": "#",
          "type": "folder",
          "text": "Node 1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n2",
          "parent": "#",
          "type": "folder",
          "text": "Node 2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n3",
          "parent": "#",
          "type": "folder",
          "text": "Node 3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n5",
          "parent": "n1",
          "text": "Node 1.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n6",
          "parent": "n1",
          "text": "Node 1.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n7",
          "parent": "n1",
          "text": "Node 1.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n8",
          "parent": "n1",
          "text": "Node 1.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n9",
          "parent": "n2",
          "text": "Node 2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n10",
          "parent": "n2",
          "text": "Node 2.2 (Custom icon)",
          "icon": "ion-help-buoy",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n12",
          "parent": "n3",
          "text": "Node 3.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n13",
          "parent": "n3",
          "type": "folder",
          "text": "Node 3.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n14",
          "parent": "n13",
          "text": "Node 3.2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n15",
          "parent": "n13",
          "text": "Node 3.2.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n16",
          "parent": "n3",
          "text": "Node 3.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n17",
          "parent": "n3",
          "text": "Node 3.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n18",
          "parent": "n3",
          "text": "Node 3.5",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n19",
          "parent": "n3",
          "text": "Node 3.6",
          "state": {
            "opened": true
          }
        }
      ]
    }


  }
})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.content')
  .controller('CategoriesCtrl', CategoriesCtrl);
    function CategoriesCtrl($scope,toastr,$http, $sce, $rootScope) {
        var vm           = this;
        vm.publishers    = [];
        vm.level         = 0;
        vm.selected_id   = 0;
        vm.name1         = '';
        vm.name2         = '';
        vm.name3         = '';
        vm.selected_pub  = null;
        vm.cat1          = [];
        vm.cat2          = [];
        vm.cat3          = [];
        vm.permissions   = [];

        vm.loadCategory = function(){
            var client_id = JSON.parse(localStorage.getItem("session")).client_id;            
            var settings = {
              "async": true,
              "crossDomain": true,
              "url": $rootScope.apiUrl + "/api/v1/category/level/"+vm.level+"?client_id=" + encodeURIComponent(client_id) + "&cid=" + vm.selected_id + "&pid=" + vm.selected_pub,
              "method": "GET",
              "headers": {
                "cache-control": "no-cache",
              }
            }

            $.ajax(settings).done(function(categories) {
                  switch(vm.level) {
                    case 0:
                        vm.cat1 = categories;
                        $("#cat2-select").val("");
                        vm.name1 = '';
                        break;
                    case 1:
                        vm.cat2 = categories;
                         if(vm.cat2.length != 0){
                            $('.cat2-select').show();
                            $("#cat2-select").val("");
                         }else{
                            $('.cat2-select').hide();
                            $($('.cat2-select')[0]).show();
                         }
                        $('.cat3-select').hide();
                        vm.name2 = '';
                        break;
                    case 2:
                        vm.cat3 = categories;
                        if(vm.cat3.length != 0){
                            $('.cat3-select').show();
                            $("#cat3-select").val("");
                        }else{
                            $('.cat3-select').hide();
                            $($('.cat3-select')[0]).show();
                        }
                        vm.name3 = '';
                        break;
                    default:
                        console.log("check level");
                }
                $scope.$apply();
            });
        }
        vm.loadPublishers = function(){
            var settings = {
              "async": true,
              "crossDomain": true,
              "url": $rootScope.apiUrl + "/api/v1/publisher/restricted/" + JSON.parse(localStorage.getItem("session")).client_id,
              "method": "GET",
              "headers": {
                "cache-control": "no-cache"
              }
            }

            $.ajax(settings).done(function (response) {
                vm.publishers = response;
                $scope.$apply();
            });
        }
        vm.initialize = function(){
            vm.selected_id = 0;
            vm.level       = 0;
            $('.cat1-select').show();
            $("#cat1-select").val("");
            $('.cat2-select').hide();
            $('.cat3-select').hide();
            
            vm.loadCategory();

            $('#cat1-select').change(function(){
                vm.level         = 1;
                vm.name1         = $("#cat1-select option:selected").text();
                vm.selected_id   = $('#cat1-select').val();
                vm.loadCategory();
            });

            $('#cat2-select').change(function(){
                vm.level         = 2;
                vm.name2         = $("#cat2-select option:selected").text();
                vm.selected_id   = $('#cat2-select').val();
                vm.loadCategory();
            });

            $('#cat3-select').change(function(){
                vm.level         = 3;
                vm.name3         = $("#cat3-select option:selected").text();
                vm.selected_id   = $('#cat2-select').val();
                $scope.$apply();
            });
        }
        vm.editCategory = function(select_id){
            var cat_editable = {
                "id"   : null,
                "name" : null
            }
            switch(select_id) {
                case 1:
                    cat_editable.id   = $("#cat1-select option:selected").val();
                    cat_editable.name = vm.name1;
                    break;
                case 2:
                    cat_editable.id   = $("#cat2-select option:selected").val();
                    cat_editable.name = vm.name2;
                    break;
                case 3:
                    cat_editable.id   = $("#cat3-select option:selected").val();
                    cat_editable.name = vm.name3;
                    break;
                default:
                    console.log("check select_id");
            }
            if(cat_editable.name != '' && cat_editable.name.length > 4){
                var settings = {
                  "async": true,
                  "crossDomain": true,
                  "url": $rootScope.apiUrl + "/api/v1/category/edit",
                  "data": { 
                            "client_id": JSON.parse(localStorage.getItem("session")).client_id,
                            "cid"      : cat_editable.id,
                            "name"     : cat_editable.name
                  },
                  "method": "POST",
                  "headers": {
                    "cache-control": "no-cache",
                  }
                }

                $.ajax(settings).success(function (response) {
                    toastr.success(response.success, 'Success');
                    vm.initialize();
                });
            }else{
                alert("Category name could not be empty and must be bigger than 3 characters!");
            }
        }
        vm.addCategory  = function(select_id){
            var name   = null;
            var level  = null;
            var parent = null;
            switch(select_id) {
                case 1:
                    name   = $('#cat1').val();
                    level  = 0;
                    break;
                case 2:
                    parent = $("#cat1-select option:selected").val();
                    name   = $('#cat2').val();
                    level  = 1;
                    break;
                case 3:
                    parent = $("#cat2-select option:selected").val();
                    name = $('#cat3').val();
                    level = 2;
                    break;
                default:
                    console.log("add category - check select_id");
            }
            if(name != '' && name.length >= 4){
                var settings = {
                  "async": true,
                  "crossDomain": true,
                  "url": $rootScope.apiUrl + "/api/v1/category",
                  "data": { 
                            "client_id": JSON.parse(localStorage.getItem("session")).client_id,
                            "name"     : name,
                            "level"    : level,
                            "pid"      : vm.selected_pub,
                            "parent"   : parent
                  },
                  "method": "PUT",
                  "headers": {
                    "cache-control": "no-cache",
                  }
                }

                $.ajax(settings).success(function (response) {
                    toastr.success(response.success, 'Success');
                    vm.initialize();
                });
            }else{
                alert("Category name could not be empty and must be bigger than 3 characters!");
            }
        }
        vm.deleteCategory  = function(select_id){
            if (confirm('are you sure you want to delete this category?')) {
                var id = null;
                switch(select_id) {
                    case 1:
                        id = $("#cat1-select option:selected").val();
                        break;
                    case 2:
                        id = $("#cat2-select option:selected").val();
                        break;
                    case 3:
                        id = $("#cat3-select option:selected").val();
                        break;
                    default:
                        console.log("delete category - check select_id");
                }
                var settings = {
                  "async": true,
                  "crossDomain": true,
                  "url": $rootScope.apiUrl + "/api/v1/category",
                  "data": { 
                            "client_id": JSON.parse(localStorage.getItem("session")).client_id,
                            "cid"      : id
                  },
                  "method": "DELETE",
                  "headers": {
                    "cache-control": "no-cache",
                  }
                }

                $.ajax(settings).success(function (response) {
                    toastr.success(response.success, 'Success');
                    vm.initialize();
                });
                $.ajax(settings).error(function (response) {                    
                    toastr.error(JSON.parse(response.responseText).MsgError, 'Error');
                });
            }
        }
        vm.loadCategoriesPermissions = function(){
            var settings = {
              "crossDomain": true,
              "url": $rootScope.apiUrl + "/api/v1/profile-groups/" + JSON.parse(localStorage.getItem("session")).user_profile,
              "method": "GET"
            }

            $.ajax(settings).done(function(response) {
                vm.permissions = response;
                $scope.$apply();
            });            
        }
        vm.loadCategoriesPermissions();
        vm.loadPublishers();
    }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.content')
    .controller('ContentGraphModalCtrl', ContentGraphModalCtrl);

  function ContentGraphModalCtrl($scope, $rootScope, $uibModal) {
      $scope.loading = false;
      $scope.data = [];
      $scope.showDates = false;
      if(typeof($scope.date) == 'undefined'){
        $scope.showDates = true;
        $scope.date = {
            startDate: moment().subtract(7, 'days'),
            endDate: moment()
        };
      }

      $scope.loadGraph = function(){
          var start = moment($scope.date.startDate);
          start.set({hour:0,minute:0,second:0});
          start = start.format("YYYY-MM-DD HH:mm:ss");
          var end   = moment($scope.date.endDate);
          end.set({hour:24,minute:0,second:0});
          end = end.format("YYYY-MM-DD HH:mm:ss");

          var settings = {
            "async": true,
            "crossDomain": true,
            "url": $rootScope.apiUrl + '/api/v1/graph/contentplays?content_id=' + $scope.content_id + "&group_id=" + JSON.parse(localStorage.getItem("session")).group_id + "&start=" + start + "&end=" + end,
            "method": "GET",
            "headers": {
              "cache-control": "no-cache"
            }
          };
          $scope.loading = true;
          $.ajax(settings).success(function (data) {
              $scope.loading = false;
              $scope.data = data;
              Highcharts.chart('container', {
                  chart: {
                      zoomType: 'x',
                      type: 'line'
                  },
                  title: {
                      text: 'Analytics'
                  },
                  subtitle: {
                      text: document.ontouchstart === undefined ?
                              'Click and drag in the plot area to zoom in' : 'Pinch the chart to zoom in'
                  },
                  xAxis: {
                      categories: data.dates
                  },
                  yAxis: {
                      title: {
                          text: ''
                      }
                  },
                  series: [{
                      name: 'Plays',
                      data: data.plays,
                      zIndex: 5
                  },{
                      name: 'Impressions: ',
                      data: data.impressions,
                      zIndex: 4
                  },{
                      name: 'Preroll',
                      data: data.preroll,
                      zIndex: 3
                  },{
                      name: 'Midroll',
                      data: data.midroll,
                      zIndex: 2
                  },{
                      name: 'Postroll',
                      data: data.postroll,
                      zIndex: 1
                  }]
              });
              $scope.$apply();
              if(data.length != 0){
                $('.no-content').hide();
              }else{
                $('.no-content').show();
              }
          })
          .error(function (error) {
              $scope.loading = false;
            //console.log(error);
          });

      };

      $scope.loadGraphPercentage = function(){
          var start = moment($scope.date.startDate);
          start.set({hour:0,minute:0,second:0});
          start = start.format("YYYY-MM-DD HH:mm:ss");
          var end   = moment($scope.date.endDate);
          end.set({hour:24,minute:0,second:0});
          end = end.format("YYYY-MM-DD HH:mm:ss");

          var settings = {
              "async": true,
              "crossDomain": true,
              "url": $rootScope.apiUrl + '/api/v1/graph/percentage-of-video-playback?content_id=' + $scope.content_id + "&from=" + start + "&to=" + end,
              "method": "GET",
              "headers": {
                  "cache-control": "no-cache"
              }
          };
          $scope.loading = true;
          $.ajax(settings).success(function (data) {
              $scope.loading = false;
              var serie= [];
              serie.push(data.plays.value, data.firstquartile.value, data.midpoint.value, data.thirdquartile.value, data.ended.value);

              Highcharts.chart('container', {
                  chart: {
                      zoomType: 'x'
                  },
                  title: {
                      text: 'Percentage Video Playback (PVP)'
                  },
                  subtitle: {
                      text: document.ontouchstart === undefined ?
                          'Click and drag in the plot area to zoom in' : 'Pinch the chart to zoom in'
                  },
                  xAxis: {
                      categories: ['Plays', 'Firstquartile', 'Midpoint', 'Thirdquartile', 'Ended']
                  },
                  yAxis: {
                      title: {
                          text: ''
                      }
                  },
                  series: [{
                      name: "PVP",
                      data: serie
                  }]
              });
              $scope.$apply();
              if(data.length != 0){
                  $('.no-content').hide();
              }else{
                  $('.no-content').show();
              }
          })
              .error(function (error) {
                  $scope.loading = false;
                  //console.log(error);
              });

      };

      $scope.graphSelected = 'analytics';
      $scope.loadGraph();

      $scope.updateDate = function(){
        switch ($scope.graphSelected) {
            case 'analytics' : $scope.loadGraph();
                break;
            case 'percentage': $scope.loadGraphPercentage();
                break
        }

      }
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.timeline')
      .controller('TimelineCtrl', TimelineCtrl);

  /** @ngInject */
  function TimelineCtrl() {
    var timelineBlocks = $('.cd-timeline-block'),
        offset = 0.8;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
      if (!window.requestAnimationFrame) {
        setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100);
      } else {
        window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
      }
    });

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
      });
    }
  }
})();
angular.module('BlurAdmin.pages.content')
    .controller('ClippingModalCtrl', ClippingModalCtrl);

/** @ngInject */
function ClippingModalCtrl($scope,toastr,$http, $sce ,$rootScope, $stateParams, $state, $window, $uibModal) {
    JSON.parse(localStorage.getItem('session'));
    var client_id = encodeURIComponent(JSON.parse(localStorage.getItem('session')).client_id);
    $scope.clippingSrc = $sce.trustAsResourceUrl($rootScope.clippingUrl +'/clipping?content_id=' + $scope.content_id + '&client_id=' + client_id + '&pid=' + $scope.pid + '&cid=' + $scope.cid);
}



(function () {
  'use strict';

  angular.module('BlurAdmin.pages.content')
    .controller('ContentCtrl', ContentCtrl);

  /** @ngInject */
  function ContentCtrl($scope,toastr,$uibModal,$http ,$rootScope, Auth, $stateParams, $state, $location) {
    $scope.page                 = 1;
    $scope.offset               = 0;
    $scope.current              = $scope.page * 50;
    $scope.feeds                = [];
    $scope.loading              = false;
    $scope.selectCategory       = true;
    $scope.errorCategory        = false;
    $scope.entryId_tmp          = '';
    $scope.playlists            = [];
    $scope.playListFilter       = '';
    $scope.pl_manual_filter     = '';
    $scope.search               = 0;
    $scope.ignoreChanges        = false;
    $scope.search_media         = '';
    $scope.newNode              = {};
    $scope.apiUrl               = $rootScope.apiUrl;
    $scope.S3ButcketThumbs      = $rootScope.S3ButcketThumbs;
    $scope.addItemsPlaylist     = false;
    $scope.playlist_name        = '';
    $scope.manual_playlist      = [];
    $scope.createPlaylist       = true;
    $scope.editManual           = false;
    $scope.manual_playlists     = [];
    $scope.playlistName         = '';

    $scope.cssView = 'list';
    if(JSON.parse(localStorage.getItem('view'))){
      $scope.cssView = JSON.parse(localStorage.getItem('view')).style;
      switch($scope.cssView) {
        case 'box':
            $('#list-view').removeClass('view-active');
            $('#list-box').addClass('view-active');
            break;
        case 'list':
            $('#list-box').removeClass('view-active');
            $('#list-view').addClass('view-active');
            break;
        default:
            console.log("none view");
        }
    }
    $scope.dragConfig = {
      'core': {
        'check_callback': true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-ios-folder'
        }
      },
      //"plugins": ["dnd", 'types','state']
      "plugins": ['types','state']
    };
    $scope.dragData             = JSON.parse(localStorage.getItem('categories'));
    $scope.session              = JSON.parse(localStorage.getItem('session'));
    $scope.category_selected    = 0;
    $scope.paginatorOn          = true;
    $scope.timeoutSearch        = 0;
    $scope.noContent            = false;
    $scope.selectedAll          = false;
    $scope.publishers           = [];
    $scope.publisher_selected   = '';

    $scope.queryParams = $location.search();

    $scope.msToTime = function(s) {
        // Pad to 2 or 3 digits, default is 2
        function pad(n, z) {
            z = z || 2;
            return ('00' + n).slice(-z);
        }
        s = parseInt(s);
        var ms = s % 1000;
        s = (s - ms) / 1000;
        var secs = s % 60;
        s = (s - secs) / 60;
        var mins = s % 60;
        var hrs = (s - mins) / 60;
        var time ="";
        if (hrs != 0){
            time += pad(hrs) + ':';
        }
        time += pad(mins) + ':' + pad(secs);
        return time;
    };

    $('#treeCategories').jstree("refresh");

      $('#select-all').click(function() {
          if($scope.selectedAll){
            $scope.selectedAll = false;
          }else{
            $scope.selectedAll = true;
          }
          $.each($('.content-item'),function(index,value){
             $(value).prop("checked",$scope.selectedAll);
          });
      });

    $scope.loadPublishers  = function(){
        var client_id  = JSON.parse(localStorage.getItem('session')).client_id;
        var settings   = {
          "crossDomain": true,
          "url": $rootScope.apiUrl + "/api/v1/publisher/restricted/" + client_id,
          "method": "GET"
        };

        $.ajax(settings).done(function(publishers) {
            $scope.publishers = publishers;
        });
    };
    $scope.loadPublishers();

    $rootScope.$on('refreshFeeds', function(event) {
      $scope.loadFeeds('refresh');
    });

    $scope.loadFeeds  = function(action){
      $scope.paginatorOn       = true;
      $scope.noContent         = false;
      $scope.errorCategory     = false;
      $scope.feeds             = 0;
      if($scope.page  != '' && $scope.page != 0 && $scope.page != null){
        $scope.updateOffset();
        if($scope.search){
          $scope.searchItems();
        }else{
          if(typeof(JSON.parse(localStorage.getItem("session")).lastNode) != 'undefined' && action != 'deleted-0'){
            $scope.category_selected = JSON.parse(localStorage.getItem("session")).lastNode;
            $.each($('.jstree-anchor'), function(index,item){
              var id  = $(item).attr("id");
                var id  = id.split('#')[0].split('_anchor')[0];
                var tmp = id.split('-');
                if(tmp[1] == JSON.parse(localStorage.getItem("session")).lastNode.split('-')[1]){
                  $scope.category_selected = tmp[0] + "-" + tmp[1];
                }
            });
          }
          $scope.session.lastNode = $scope.category_selected;
          localStorage.setItem('session', JSON.stringify($scope.session));
          $('#treeCategories').jstree('deselect_all');
          $('#treeCategories').jstree('select_node',$scope.session.lastNode);

          $scope.selectCategory = false;
          $scope.loading = true;
          var settings = {
            "async": true,
            "crossDomain": true,
            "url": $rootScope.apiUrl + "/api/v1/category",
            "data":{
                     'client_id': $scope.session.client_id,
                     'page'     : $scope.page,
                     'cid'      : $scope.category_selected,
                     'pubs_id'  : JSON.parse(localStorage.getItem("session")).publishers_ids,
                     'action'   : action
            },
            "method": "GET"
          }
          $.ajax(settings).done(function(response) {
             $scope.feeds     = response;

              $scope.feeds.feeds = response.feeds.map(function (feed) {
                  if (feed.duration == null){
                      return feed;
                  }
                  feed.created_at = new Date(feed.created_at + '+00:00');
                  feed.created_at = feed.created_at.toLocaleString();
                  feed.duration = $scope.msToTime(feed.duration);
                  return feed;
              });

             $scope.errorCategory = false;
             //console.log(response);
             $scope.paginator = parseInt($scope.feeds.total) / 50;
             if($scope.paginator % 1 != 0){
                $scope.paginator = parseInt($scope.paginator) + 1;
             }
             $scope.current   = $scope.page * 50;
             $scope.loading   = false;
             $scope.$apply();
          })
          .error(function(error){
              $scope.loading   = false;
              //toastr.error(error.responseJSON.error, 'Error');
              $scope.errorCategory = error.responseJSON.error;
              if(error.responseJSON.error == 'no session found.'){
                //console.log("logueate otra vez");
                Auth.isLoggedIn();
              }
              $scope.$apply();
          });
        }
      }
    }
    $scope.selectNode = function(event) {
      $scope.search = 0;
      $('#select-all').prop("checked",false);
      $scope.selectedAll = false;
      var category_selected = $('#treeCategories').jstree('get_selected')[0];
      if(category_selected.split("-")[0] != 'god'){
        $scope.category_selected = category_selected;
        $scope.page = 1;
        $scope.session.lastNode = category_selected;
        localStorage.setItem('session', JSON.stringify($scope.session));
        $state.go('content.media-content.category', {id : category_selected, page: $scope.page});
        $scope.loadFeeds(category_selected);
      }
    }
    $scope.deletedItems = function(){
      $scope.search = 0;
      $scope.page = 1;
      $scope.category_selected = 'deleted-0';
      $scope.loadFeeds($scope.category_selected);
    };
    $scope.searchItems = function(){
      $scope.search = 0;
      $('#select-all').prop("checked",false);
    if(($scope.search_media.length > 2) || ($scope.search_media.length == 0) || $.isNumeric($scope.search_media)){
        if($scope.timeoutSearch){
          clearTimeout($scope.timeoutSearch);
        }
        $scope.timeoutSearch =  setTimeout(function() {
            var query = $scope.search_media;
            $scope.category_selected = 0;
            if(query != ''){
              $scope.loading = true;
              $scope.search  = 1;
              $scope.updateOffset();
              var settings = {
                "async": true,
                "crossDomain": true,
                "url": $rootScope.apiUrl + "/api/v1/content/search?publishers_ids="+encodeURIComponent(JSON.parse(localStorage.getItem("session")).publishers_ids)+"&query="+query+"&page=" + $scope.page + "&client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id),
                "method": "GET",
                "headers": {
                  "cache-control": "no-cache",
                }
              }

              $.ajax(settings).done(function(response) {
                  $scope.errorCategory = '';
                  $scope.feeds     = response;
                  $scope.feeds.feeds = response.feeds.map(function (feed) {
                      if (feed.duration == ""){
                          return feed;
                      }
                      feed.duration = $scope.msToTime(feed.duration);
                      return feed;
                  });
                  $scope.paginator = parseInt($scope.feeds.total / 50);
                  $scope.current   = $scope.page * 50;
                  $scope.loading   = false;
                  if(response.feeds.length == 0){
                    $scope.noContent = true;
                    $scope.errorCategory = false;
                  }else{
                    $scope.noContent = false;
                  }
                  $.each($('.markeable'),function(index,value){
                      var src_str = $(value).text();
                      var term = query;
                      term = term.replace(/(\s+)/,"(<[^>]+>)*$1(<[^>]+>)*");
                      var pattern = new RegExp("("+term+")", "gi");

                      src_str = src_str.replace(pattern, "<mark>$1</mark>");
                      src_str = src_str.replace(/(<mark>[^<>]*)((<[^>]+>)+)([^<>]*<\/mark>)/,"$1</mark>$2<mark>$4");

                      $(value).html(src_str);
                  });
                  $scope.$apply();
              });
            }else{
              $scope.search = 0;
              $scope.category_selected = $('#treeCategories').jstree('get_selected')[0];;
              $scope.loadFeeds();
            }
        }, 300);
      }
    }
    $scope.up = function(){
      if(($scope.page + 1) <= $scope.paginator){
        $scope.page = $scope.page + 1;
        if($scope.search){
          $scope.searchItems();
        }else{
          $state.go('content.media-content.category', {id : category_selected, page: $scope.page});
          $scope.loadFeeds();
        }
      }
    }
    $scope.down = function(){
      if(($scope.page - 1) > 0){
        $scope.page = $scope.page - 1;
        if($scope.search){
          $scope.searchItems();
        }else{
          $state.go('content.media-content.category', {id : category_selected, page: $scope.page});
          $scope.loadFeeds();
        }
      }
    }
    $scope.updateOffset = function(){
      if(($scope.page) >= 3){
        $scope.offset  = ($scope.page - 1) * 50;
      }else{
        if(($scope.page - 1) == 0){
          $scope.offset  = 0;
        }else{
          $scope.offset  = ($scope.page - 1) * 50;
        }
      }
    }
    $scope.showSmallVideo = function(content_id){
      $('#small-'+content_id).html('<iframe src="'+$rootScope.apiUrl+'/player/embed/playerId/0/contentId/'+content_id+'?admin=007&status=enabled&autoplay=true" style="margin-right: 15px;border: 1px solid black;height: 100px;width: 100%;"></iframe>');
      $('#play-small-video-'+content_id).remove();
      $('#small-image-'+content_id).remove();
      $('#information-'+content_id).css('margin-bottom', '0px');
      $('#information-'+content_id).css('position', 'relative');
      $('#information-'+content_id).css('top', '-3px');
    }
    $scope.getVideoUrl  = function(entryId){
        var settings = {
          "async": true,
          "crossDomain": true,
          "url": $rootScope.apiUrl + "/api/v1/content/" + entryId + '?client_id=' + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id),
          "method": "GET"
        }

        $.ajax(settings).done(function(response) {
            var video_name    = response.name;
            $scope.content_id = entryId;
            $uibModal.open({
              animation: true,
              size: 'lg',
              templateUrl: 'app/pages/content/mediaContent/videoModal.html',
              scope: $scope
            });

            setTimeout(function(){
                $('#title-video').text(video_name);
                $('#entryId').text(entryId);
            }, 200);
        })
        .error(function(error){
          toastr.error(error.statusText, 'Error');
        });
    }
    $scope.uploadVideo = function(action){
      $scope.uploadModal = $uibModal.open({
        animation: true,
        size: 'lg',
        backdrop: 'static',
        templateUrl: 'app/pages/content/upload/upload.html',
        scope: $scope
      }).closed.then(function(){
        if(action != 'video'){
          if(typeof(JSON.parse(localStorage.getItem("session")).lastNode) != 'undefined'){
            $scope.search = 0;
            $scope.selectedAll = false;
            $scope.page = 1;
            $scope.loadFeeds(JSON.parse(localStorage.getItem("session")).lastNode);
          }else{
            $scope.loadFeeds('refresh');
          }
        }else{
            $('#progress-line').width('0%');
            $('#progress-line').text('0%');
        }
      });
    }
    $scope.upload = function(type){
      $scope.upload_type = type;
      switch(type) {
        case 'video':
            if($scope.category_selected){
              $scope.uploadVideo('video');
            }else{
              alert("You must select a category first!");
            }
        break;
        case 'audio':
            $scope.uploadVideo('audio');
        break;
        case 'youtube':
            $scope.uploadVideo('youtube');
        break;
        case 'live':
            $scope.uploadVideo('live');
        break;
        default:
          return '';
        break;
      }
    }
    $scope.download = function(content_id) {
      var found = $scope.feeds.feeds.find(function(element) {
        return element.entry_id == content_id;
      });
      console.log(found);
      console.log(found.link);
      var pom = document.createElement('a');
      pom.setAttribute('href', found.link);
      pom.setAttribute('target', "_blank");
      pom.setAttribute('download', content_id + ".mp4");
      if (document.createEvent) {
          var event = document.createEvent('MouseEvents');
          event.initEvent('click', true, true);
          pom.dispatchEvent(event);
          pom.remove();
      }
      else {
          pom.click();
          pom.remove();
      }
    };

    $scope.downloadByApi = function(content_id) {
      $scope.loading  = true;
      var settings = {
          "async": true,
          "crossDomain": true,
          "url": $rootScope.apiUrl + "/api/v1/content/" + content_id + "?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id),
          "method": "GET",
          "headers": {
              "cache-control": "no-cache"
          }
      };

      $.ajax(settings).done(function (response) {
          $scope.loading  = false;
          var pom = document.createElement('a');
          pom.setAttribute('href', response.download_url[0].link);
          pom.setAttribute('target', "_blank");
          pom.setAttribute('download', content_id + ".mp4");
          if (document.createEvent) {
              var event = document.createEvent('MouseEvents');
              event.initEvent('click', true, true);
              pom.dispatchEvent(event);
              pom.remove();
          }
          else {
              pom.click();
              pom.remove();
          }
      });
    };

    $scope.loadPlaylists = function(){
      $scope.loading  = true;
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/api/v1/playlist?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id),
        "method": "GET",
        "headers": {
          "cache-control": "no-cache",
        }
      }

      $.ajax(settings).done(function (playlists) {
          $scope.loading  = false;
          $scope.playlists = playlists;
          if(playlists.length > 0){
              $scope.playlistFilter();
          }
      });
    }
    $scope.playlistFilter = function(){
      $scope.noContent         = false;
      $scope.search            = 0;
      $scope.category_selected = 0;
      $scope.playListFilter = $('#playlist_select').val();
      $scope.loading        = true;
      $scope.selectCategory = 0;
      $scope.paginatorOn  = false;
      if($scope.playListFilter != ''){
        var settings = {
          "async": true,
          "crossDomain": true,
          "url": $rootScope.apiUrl + "/api/v1/playlist/"+$scope.playListFilter+"/playerId/0",
          "method": "GET",
          "headers": {
            "cache-control": "no-cache",
          }
        }

        $.ajax(settings).done(function (items) {
          $scope.loading      = false;
          $scope.feeds.feeds  = items.feeds;
          $scope.page = 1;
          $scope.$apply();
        });
      }
    }

    $scope.hidePlaylistSidebar = function(){
      $('.playlist-sidebar').fadeOut(300);
    }
    $scope.showPlaylistSidebar = function(){
      $('.playlist-sidebar').fadeIn(300);
    }
    $scope.editPlaylist = function(){
      $scope.editManual    = true;
      $scope.loadPlaylistsManual();
      $('.playlist-sidebar').fadeIn(300);
    }
    $scope.createPlaylist = function(PlaylistName){
      if(typeof(PlaylistName) == 'undefined'){
        $scope.playlistModal = $uibModal.open({
          animation: true,
          size: 'lg',
          templateUrl: 'app/pages/content/mediaContent/manualPlaylistModal.html',
          scope: $scope
        });
      }else{
        $scope.playlist_name = PlaylistName;
        if(($scope.playlist_name.length >= 4) && ($('#publishers_select').val() != "")){
          $("#no_publisher_message").hide();
          $scope.addItemsPlaylist  = true;
          $scope.createPlaylist    = false;
          $scope.editManual        = false;
          $scope.manual_playlist = {
            "name"        : $scope.playlist_name,
            "description" : null,
            "pid"         : $('#publishers_select').val(),
            "items"       : []
          };
          $('#playlist-description').val('');
          $scope.playlistModal.close();
          $('.playlist-sidebar').fadeIn(300);
        }else{
            $("#no_publisher_message").show();
            $scope.playlistModal.close();
            alert('Playlist name must be bigger than 3 characters, please try again.');
            $scope.createPlaylist();
        }
      }

    }
    $scope.validateIfExist = function(id){
      var response = false;
      angular.forEach($scope.manual_playlist.items, function(value, key) {
        if(value.id == id){
            response = true;
        }
      });
      return response;
    }
    $scope.addItems = function(){
      var selected = false;
      $.each($('.content-item'),function(index,value){
        if($(this).is(':checked')){
          selected = true;
          var exist = $scope.validateIfExist($(this).attr('data-item').split('&')[0]);
          if(!exist){
            $scope.manual_playlist.items.push({
              id : $(this).attr('data-item').split('&')[0],
              name : $(this).attr('data-item').split('&')[1],
              thumbnail: $(this).attr('data-item').split('&')[2]
            });
          }
          $(this).attr("checked",false);
        }
      });
      $('#select-all').attr("checked",false);
      if(selected){
        $('.playlist-sidebar').fadeIn(300);
      }else{
        alert("Please select an item...");
      }
    }
    $scope.removeItem = function(id){
      angular.forEach($scope.manual_playlist.items, function(value, key) {
        if(value.id == id){
            $scope.manual_playlist.items.splice(key, 1);
        }
      });
    }
    $scope.updateName = function(){
      $scope.manual_playlist.name = $('#playlist-name').val();
    }
    $scope.updateDesc = function(){
        $scope.manual_playlist.description = $('#playlist-description').val();
    }
    $scope.savePlaylist = function(){
      if($scope.manual_playlist.items.length > 0){
        if($('#playlist-name').val().length >= 4){
            var ids = '';
            angular.forEach($scope.manual_playlist.items, function(value, key) {
                if(key == 0){
                  ids = value.id;
                }else{
                  ids = ids + ',' + value.id;
                }
            });
            var settings = {
              "async": true,
              "crossDomain": true,
              "url": $rootScope.apiUrl + "/api/v1/playlist",
              "data": {
                 "client_id": JSON.parse(localStorage.getItem("session")).client_id,
                 "playlist" : $scope.manual_playlist,
                 "pid"      : $scope.manual_playlist.pid,
                 "ids"      : ids
              },
              "method": "POST",
              "headers": {
                "cache-control": "no-cache",
              }
            }
            $.ajax(settings)
            .success(function (response) {
                toastr.success(response.info, 'success');
                $scope.hidePlaylistSidebar();
                $scope.addItemsPlaylist  = false;
                $scope.createPlaylist    = true;
                $scope.loadPlaylists();
            })
            .error(function (response) {
                toastr.error(response.error, 'error');
            });
        }else{
            alert('Playlist name must be bigger than 3 characters, please try again.');
        }
      }else{
          alert('Please add some content to the playlist first..');
      }
    }
    $scope.sortableOptions = {
      update: function(e, ui) {
        var logEntry = $scope.manual_playlist.items.map(function(i){
          return i.value;
        }).join(', ');
      },
      stop: function(e, ui) {
        // this callback has the changed model
        var logEntry = $scope.manual_playlist.items.map(function(i){
          return i.value;
        }).join(', ');
      }
    };
    $scope.loadPlaylistsManual = function(){
      $scope.loading  = true;
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/api/v1/playlist?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id) + '&manual=true',
        "method": "GET",
        "headers": {
          "cache-control": "no-cache",
        }
      }

      $.ajax(settings).done(function (playlists) {
          console.log(playlists);
          $scope.manual_playListFilter = playlists.playlists;
          $scope.loading = false;
          if(playlists.playlists.length > 0){
            setTimeout(function(){
                $scope.ManualPlaylistFilter();
                $scope.$apply();
            }, 200);
          }
      });
    }
    $scope.ManualPlaylistFilter = function(){
      $scope.noContent         = false;
      $scope.search            = 0;
      $scope.category_selected = 0;
      $scope.pl_manual_filter  = $('#manual_playlist_select').val();
      // $scope.loading        = true;
      // $scope.selectCategory = 0;
      // $scope.paginatorOn  = false;
      if($scope.pl_manual_filter != ''){
        var settings = {
          "async": true,
          "crossDomain": true,
          "url": $rootScope.apiUrl + "/api/v1/playlist/"+$scope.pl_manual_filter+"/playerId/0",
          "method": "GET",
          "headers": {
            "cache-control": "no-cache",
          }
        }

        $.ajax(settings).done(function (items) {
          console.log(items);
          $scope.loading               = false;
          $scope.manual_playlist.items = items.feeds;
          $scope.playlist_name         = items.name;
          $scope.playlist_description  = items.description;
          $scope.addItemsPlaylist      = true;
          $scope.$apply();
        });
      }
    }
    $scope.changeView = function(type){
      $scope.cssView = type;
      switch(type) {
        case 'box':
            $('#list-view').removeClass('view-active');
            $('#list-box').addClass('view-active');
            break;
        case 'list':
            $('#list-box').removeClass('view-active');
            $('#list-view').addClass('view-active');
            break;
        default:
            console.log("none view");
        }
        localStorage.setItem('view',JSON.stringify({'style': type}));
    }
    $scope.editPlaylistSave = function(){
      //edito manual
      var ids = '';
      angular.forEach($scope.manual_playlist.items, function(value, key) {
          if(key == 0){
            ids = value.id;
          }else{
            ids = ids + ',' + value.id;
          }
      });
      var playlist = {
        'name'        : $('#playlist-name').val(),
        'description' : $('#playlist-description').val()
      }
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": $rootScope.apiUrl + "/api/v1/playlist",
        "data": {
           "client_id"  : JSON.parse(localStorage.getItem("session")).client_id,
           "playlist"   : playlist,
           "id"         : $scope.pl_manual_filter,
          'content_ids' : ids
        },
        "method": "PUT",
        "headers": {
          "cache-control": "no-cache",
        }
      }
      $.ajax(settings).done(function(response) {
          toastr.success(response.info, 'success');
          $scope.hidePlaylistSidebar();
      })
      .error(function(error){
          toastr.error(response.error, 'error');
      });
    }
    $scope.openModalContentGraph = function(content_id){
       $scope.content_id = content_id;
       $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'app/pages/content/content-graphs/contentGraph.html',
        scope: $scope
      });
    }

    if(typeof($state.params.id) != 'undefined'){
        $scope.search = 0;
        $('#select-all').prop("checked",false);
        $scope.selectedAll = false;
        var category_selected = $state.params.id;
        if(category_selected.split("-")[0] != 'god'){
          $scope.category_selected = category_selected;
          $scope.page = 1;
          if(typeof($scope.queryParams.page) != 'undefined'){
            $scope.page = parseInt($scope.queryParams.page);
          }
          $scope.loadFeeds(category_selected);
        }
    }else{
      if(typeof(JSON.parse(localStorage.getItem("session")).lastNode) != 'undefined'){
        $scope.search = 0;
        $('#select-all').prop("checked",false);
        $scope.selectedAll = false;
        var category_selected = JSON.parse(localStorage.getItem("session")).lastNode;

        if(category_selected.split("-")[0] != 'god'){
          $scope.category_selected = category_selected;
          $scope.page = 1;
          if(typeof($scope.queryParams.page) != 'undefined'){
            $scope.page = parseInt($scope.queryParams.page);
          }
          $scope.loadFeeds(category_selected);
        }
      }
    }


    $.fn.styleddropdown = function(){
      return this.each(function(){
        var obj = $(this)
        //console.log(obj);
        obj.find(".field").click(function() { //onclick event, "list" fadein
        obj.find(".list").fadeIn(400);

        obj.find(".list").hover(function(){ },
          function(){
            $(this).fadeOut(400);
          });
        });

        obj.find(".list li").click(function() { //onclick event, change field value with selected "list" item and fadeout "list"
        obj.find(".list").fadeOut(400);
        });
      });
    };

    $(function(){
      $('.size').styleddropdown();
    });
  }

})();


(function () {
    'use strict';

    angular.module('BlurAdmin.pages.content')
        .controller('ContentEditCtrl', ContentEditCtrl);

    function ContentEditCtrl($scope,toastr,$http, $sce ,$rootScope, $stateParams, $state, $window, $uibModal) {
        var vm = this;
        vm.content_id             = $stateParams.content_id;
        vm.name                   = $stateParams.name;
        vm.comscore               = [];
        vm.categories_selected    = '';
        vm.historial              = [];
        vm.history_page           = 1;
        vm.loading                = false;
        vm.error                  = false;
        vm.info                   = [];
        vm.info.download_url      = [];
        vm.selected_download_link = '';
        vm.live_url               = '';
        vm.content_referrer       = '';
        vm.environment            = $rootScope.environment;
        vm.group_name             = JSON.parse(localStorage.getItem("session")).group_name;
        $scope.pid = null;
        $scope.cid = null;


        vm.comscoreGetValues = function(){
            var comscore_values = [];
            var item            = null;
            $.each($('.comscore-values'),function(index,value){
                var comscore_struct = {
                    'key'   : null,
                    'value' : null
                };
                comscore_struct.key   = $(value).attr("id");
                comscore_struct.value = $(value).val();
                comscore_values.push(comscore_struct);
            });
            return comscore_values;
        }
        vm.downloadUrl = function(){
            var pom = document.createElement('a');
            pom.setAttribute('href', vm.selected_download_link);
            pom.setAttribute('download', "file.mp4");
            if (document.createEvent) {
                var event = document.createEvent('MouseEvents');
                event.initEvent('click', true, true);
                pom.dispatchEvent(event);
            }
            else {
                pom.click();
            }

        }
        setTimeout(function(){
            $("#tags").tagsinput();
            $('#save-changes').click(function(e){
                $('#save-changes').attr("disabled", true);
                vm.loading      = true;
                $scope.$apply();
                var description = ($('#media-description').val() != '')? $('#media-description').val() : null;
                var sharing_url = ($('#sharing-url').val() != '')? $('#sharing-url').val() : null;
                var tags        = ($('#tags').val() != '')? $('#tags').val() : null;
                var categories  = ($('#categories').val() != '')? $('#categories').val() : null;
                var geoblock    = ($('#geoblock').val() != '')? $('#geoblock').val() : null;
                var comscore    = vm.comscoreGetValues();

                var settings = {
                    "crossDomain": true,
                    "data": {
                        "client_id"    : JSON.parse(localStorage.getItem("session")).client_id,
                        "content_id"   : vm.content_id,
                        "name"         : $('#media-name').val(),
                        "description"  : description,
                        "sharing_url"  : sharing_url,
                        "tags"         : tags,
                        "categories"   : categories,
                        "status"       : $('#media-status').val(),
                        "remove"       : 0,
                        "comscore"     : comscore,
                        "live_url"     : $('#live_url').val(),
                        "geoblock"     : geoblock
                    },
                    "url": $rootScope.apiUrl + "/api/v1/content/edit",
                    "method": "POST",
                    "headers": {
                        "cache-control": "no-cache",
                    }
                }

                $.ajax(settings).success(function (response) {
                    $('#save-changes').attr("disabled", false);
                    toastr.success("Your content has been updated!", 'Success');
                    vm.loading = false;
                    history.back();
                    $scope.$apply();
                })
                    .error(function (error) {
                        $('#save-changes').attr("disabled", false);
                        vm.loading = false;
                        console.log(error);
                    });
            });

            $('#delete-item').click(function(e){
                debugger;
                var valid = confirm("Are you sure you want to delete this item?");
                if(valid){
                    vm.loading = true;
                    $('#media-status').val('disabled');
                    var description = ($('#media-description').val() != '')? $('#media-description').val() : null;
                    var sharing_url  = ($('#sharing-url').val() != '')? $('#sharing-urln').val() : null;
                    var tags        = ($('#tags').val() != '')? $('#tags').val() : null;
                    var categories  = ($('#categories').val() != '')? $('#categories').val() : null;
                    var settings = {
                        "crossDomain": true,
                        "data": {
                            "client_id"    :   JSON.parse(localStorage.getItem("session")).client_id,
                            "content_id"   :   vm.content_id,
                            "name"         :   $('#media-name').val(),
                            "description"  :   description,
                            "sharing_url"   :   sharing_url,
                            "tags"         :   tags,
                            "categories"   :   [0],
                            "status"       :   $('#media-status').val(),
                            "remove"       :   1
                        },
                        "url": $rootScope.apiUrl + "/api/v1/content/edit",
                        "method": "POST",
                        "headers": {
                            "cache-control": "no-cache",
                        }
                    }

                    $.ajax(settings).success(function (response) {
                        vm.loading = false;
                        toastr.success("Your content has been removed!", 'Success');
                        history.back();
                        $scope.$apply();
                    })
                        .error(function (error) {
                            vm.loading = false;
                            console.log(error);
                        });
                }
            });

            $('#cancel').click(function(e){
                history.back();
                $scope.$apply();
            });
            /*var comscore_schema  = JSON.parse('[{"entry_id":155,"name":"Messi","partner_id":1,"created_at":"2016-12-20 17:52:36","status":"enabled","thumbnail":"http://localhost:8000/thumbs/1-28-3JKPLM1482260881_480P.jpg"},{"entry_id":154,"name":"golazo!","partner_id":1,"created_at":"2016-12-20 16:34:58","status":"enabled","thumbnail":"http://localhost:8000/thumbs/1-28-HQLTLZ1482261974_1080P.jpg"}]');
            var code = JSON.stringify(comscore_schema, null, 4);
            $('#json_schema').text(code);*/
        }, 100);
        vm.back = function(){
            history.back();
            $scope.$apply();
        };

        vm.loadContent = function(){
            $http({
                method: 'GET',
                url: $rootScope.apiUrl + "/api/v1/content/" + vm.content_id + '?client_id=' + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id)
            }).then(function(response) {
                $scope.pid = response.data.pid;
                $scope.cid = response.data.cid;
                vm.info = response.data;
                vm.live_url = response.data.live_url;
                $('#media-name').val(response.data.name);
                vm.status = response.data.status;
                $('#iframe-content').attr("src",$rootScope.apiUrl +'/player/embed/playerId/0/contentId/' + vm.content_id + "?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id) + "&admin=007" + "&status=" + vm.status);
                $('#media-status').val(response.data.status);
                $('#media-description').val(response.data.description);
                $('#sharing-url').val(response.data.sharing_url);
                $.each(response.data.tags, function(index,value){
                    $("#tags").tagsinput('add', value);
                });
                var cid = response.data.cid;
                $(".chosen-select").val(cid.split(','));
                $(".chosen-select").trigger('chosen:updated');

                vm.content_id = response.data.id;
                $('#media-ReferenceId').val(response.data.external_id);
                vm.content_referrer = response.data.referrer;
                vm.mediaReferenceId = response.data.external_id;
                vm.mediaGenoaId = response.data.id;
                $scope.plays = response.data.plays;
                vm.geoblock     = response.data.geoblock;
                $scope.preroll  = response.data.preroll;
                $scope.midroll  = response.data.midroll;
                $scope.postroll = response.data.postroll;
                $scope.impressions = response.data.impressions;
                var created_at = new Date(response.data.created_at + '+00:00');
                created_at = created_at.toLocaleString();
                $('#media-created_at').val(created_at);
                if(response.data.created_by == 0){
                    $('#media-created_by').val('Genoa-API');
                }else{
                    $('#media-created_by').val(response.data.created_by);
                }
                $('#media-kalturaId').val(response.data.kalturaId);
            }, function(error) {
                vm.error = error.statusText;
            });
        };

        vm.loadCategories = function(){
            var settings = {
                "async": true,
                "crossDomain": true,
                "url": $rootScope.apiUrl + "/api/v1/categories",
                "data":{
                    'client_id': JSON.parse(localStorage.getItem("session")).client_id,
                    'list' : 1
                },
                "method": "POST"
            }
            $.ajax(settings).done(function(response) {
                $('#categories').html(response);
                $(".chosen-select").chosen({no_results_text: "Oops, nothing found!"});
                vm.loadContent();
            })
                .error(function(error){
                    //console.log(error);
                });
        }
        vm.loadCategories();
        vm.loadComscoreValues = function(){
            var settings = {
                "async": true,
                "crossDomain": true,
                "url": $rootScope.apiUrl + "/api/v1/content/comscore/contentId/" + vm.content_id,
                "method": "GET",
                "headers": {
                    "cache-control": "no-cache",
                }
            }

            $.ajax(settings).done(function (response) {
                vm.comscore = response;
                $scope.$apply();
            });
        }
        vm.loadComscoreValues();
        vm.loadHistorial = function(paginator){
            var settings = {
                "async": true,
                "crossDomain": true,
                "url": $rootScope.apiUrl + "/api/v1/history/contentId/" + vm.content_id + "?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id) + '&page=' + vm.history_page,
                "method": "GET",
            }

            $.ajax(settings).done(function (response) {
                if(paginator){
                    if(response.length > 0){
                        vm.historial = vm.historial.concat(response);
                        $scope.$apply();
                    }
                }else{
                    if(response.length > 0){
                        vm.historial = response;
                        $scope.$apply();
                        $('#more-results').show();
                        $('#cd-timeline').show();
                    }else{
                        $('#more-results').hide();
                        $('#cd-timeline').hide();
                    }
                }

            });
        }
        vm.loadHistorial(false);
        vm.bringMoreHistory = function(){
            vm.history_page = vm.history_page + 1;
            vm.loadHistorial(true);
        }
        vm.refreshIframe = function(){
            $('#message_status').show();
            $('#iframe-content').attr("src",$rootScope.apiUrl +'/player/embed/playerId/0/contentId/' + vm.content_id + "?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id) + "&admin=007" + "&status=" + $('#media-status').val());
        }

        vm.openClippingModal = function () {
            $scope.content_id = vm.content_id;
            $scope.ClippingModal = $uibModal.open({
                animation: true,
                size: 'lg',
                templateUrl: 'app/pages/content/mediaContent/ClippingModal.html',
                scope: $scope,
                windowClass: 'clipping-modal'
            });
        };


        var timelineBlocks = $('.cd-timeline-block'),
            offset = 0.8;
        //hide timeline blocks which are outside the viewport
        hideBlocks(timelineBlocks, offset);

        //on scolling, show/animate timeline blocks when enter the viewport
        $(window).on('scroll', function () {
            if (!window.requestAnimationFrame) {
                setTimeout(function () {
                    showBlocks(timelineBlocks, offset);
                }, 100);
            } else {
                window.requestAnimationFrame(function () {
                    showBlocks(timelineBlocks, offset);
                });
            }
        });

        function hideBlocks(blocks, offset) {
            blocks.each(function () {
                ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
            });
        }

        function showBlocks(blocks, offset) {
            blocks.each(function () {
                ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
            });
        }
        setTimeout(function(){
            $.each($(".accordion"),function(index,value){
                value.onclick = function() {
                    this.classList.toggle("active");
                    var panel = this.nextElementSibling;
                    $(panel).css("display","block");
                    if (panel.style.maxHeight){
                        if($(value).attr("id") == 'controls'){
                            $('.controles').removeAttr("style");
                        }else{
                            panel.style.maxHeight = null;
                            panel.style.padding = '0px';
                        }
                    } else {
                        if($(value).attr("id") == 'controls'){
                            panel.style.maxHeight = '315px';
                            panel.style.padding = '24px 30px 315px';
                        }else{
                            panel.style.padding = '10px';
                            panel.style.maxHeight = panel.scrollHeight + 'px';
                        }
                    }
                }
            });
        }, 200);
    }
})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.content')
    .controller('ContentModalCtrl', ContentModalCtrl);

  /** @ngInject */
  function ContentModalCtrl($scope,toastr,$http, $sce, $rootScope, $window, $uibModal) {
      $scope.session = JSON.parse(localStorage.getItem('session'));

      $scope.contentUri     = '';
      $scope.server_url     = $rootScope.apiUrl;
      $scope.selectedPlayer = 0;
      $scope.playerVersion  = '';
      $scope.playerVersion = 'v2/';
      $scope.widescreen    = false;

      var clipboard = new Clipboard('#clipboard-copy');
      clipboard.on('success', function(e) {
          toastr.success('Code html copied!', 'Success');
      });

      clipboard.on('error', function(e) {
          toastr.error(e.action, 'Error');
      });


      $scope.generateHtml = function(code){
        var pretty_code = Prism.highlight(code, Prism.languages.javascript);
        $('.html-embebed').html(pretty_code);
      }

      $scope.renderCustomPlayer = function(){
        $scope.contentUri       = $scope.trustSrc($rootScope.apiUrl+'/player/'+ $scope.playerVersion +'embed/playerId/' + $scope.selectedPlayer + '/contentId/' + $scope.content_id);
        $('#contentIframe').attr("src", $scope.contentUri);

        $.ajax({
            "crossDomain": true,
            "url": $rootScope.apiUrl + "/api/v1/video/aspect?contents=" + $scope.content_id,
            "method": "GET",
             "headers": {
                "cache-control": "no-cache",
              }
        }).success(function(result){
          if(result[$scope.content_id] == 'vertical') {
            $scope.widescreen = true;
            $scope.html = '<iframe src="' + $rootScope.apiUrl+'/player/'+ $scope.playerVersion +'embed/playerId/' + $scope.selectedPlayer + '/contentId/' + $scope.content_id + '" frameborder="0" allowfullscreen width="auto" height="400" scrolling="no"></iframe>';
          } else {
            $scope.widescreen = false;
            $scope.html = '<iframe src="' + $rootScope.apiUrl+'/player/'+ $scope.playerVersion +'embed/playerId/' + $scope.selectedPlayer + '/contentId/' + $scope.content_id + '" frameborder="0" allowfullscreen width="100%" height="390" scrolling="no"></iframe>';
          }
          $scope.generateHtml($scope.html);
        })
        .error(function(error) {
          $scope.html = '<iframe src="' + $rootScope.apiUrl+'/player/'+ $scope.playerVersion +'embed/playerId/' + $scope.selectedPlayer + '/contentId/' + $scope.content_id + '" frameborder="0" allowfullscreen width="650" height="390" scrolling="no"></iframe>';
          $scope.generateHtml($scope.html);
        });
      }

      $scope.switchAspect = function() {
        if($scope.widescreen) {
          $scope.html = '<iframe src="' + $rootScope.apiUrl+'/player/'+ $scope.playerVersion +'embed/playerId/' + $scope.selectedPlayer + '/contentId/' + $scope.content_id + '" frameborder="0" allowfullscreen width="auto" height="400" scrolling="no"></iframe>';
        } else {
          $scope.html = '<iframe src="' + $rootScope.apiUrl+'/player/'+ $scope.playerVersion +'embed/playerId/' + $scope.selectedPlayer + '/contentId/' + $scope.content_id + '" frameborder="0" allowfullscreen width="100%" height="390" scrolling="no"></iframe>';
        }
        $scope.generateHtml($scope.html);
      }

      $scope.playerList = function(){
          $scope.players = [];
          var client_id  = encodeURIComponent(JSON.parse(localStorage.getItem('session')).client_id);
          var settings = {
              "crossDomain": true,
              "url": $rootScope.apiUrl + "/api/v1/player/list?order=pid,updated_at&client_id=" + client_id + "&publishers_ids=" + JSON.parse(localStorage.getItem('session')).publishers_ids,
              "method": "GET",
               "headers": {
                  "cache-control": "no-cache",
                }
          }
          $.ajax(settings).success(function(players){
              $scope.players    = players.players_list;
              if($scope.players.length > 0){
                $scope.selectedPlayer = $scope.players[0].id;
                $scope.$apply();
                $scope.renderCustomPlayer();
              }
          })
          .error(function(error) {
              //console.log(error);
          });
      }

      $scope.playerList();

      $scope.trustSrc = function(src) {
        return $sce.trustAsResourceUrl(src);
      }

      $scope.generatePageView = function(){

          console.log("pageView");
          $window.open($scope.server_url+"/player/preview/" + $scope.playerVersion + "player_id/"+$scope.selectedPlayer+"/content_id/"+$scope.content_id, "_blank")
      }
      $scope.$on("$destroy", function() {
          clipboard.destroy();
      });
  }

})();


(function () {
  'use strict';

  angular.module('BlurAdmin.pages.content')
  .controller('UploadCtrl', UploadCtrl);

  /** @ngInject */
  function UploadCtrl($scope,toastr,$http, $sce, $rootScope, $window, $uibModal,$uibModalStack, Auth) {
    if (!String.prototype.includes) {
      String.prototype.includes = function(search, start) {
          'use strict';
          if (typeof start !== 'number') {
              start = 0;
          }

          if (start + search.length > this.length) {
              return false;
          } else {
              return this.indexOf(search, start) !== -1;
          }
      };
    }

    var vm             = this;    
    vm.mediaUrl        = '';
    vm.files           = [];
    vm.progress        = false;
    vm.transcoder      = 'aws';
    vm.player = null;
    vm.pid             = null;
    $scope.loading     = false;
    $scope.client_id   = JSON.parse(localStorage.getItem('session')).client_id;

    vm.checkTranscoder = function(){
        var settings = {
          "async": true,
          "crossDomain": true,
          "url": $rootScope.apiUrl + "/api/v1/publishers/category/" + $scope.category_selected + "?client_id=" + encodeURIComponent(JSON.parse(localStorage.getItem("session")).client_id),
          "method": "GET"
        }
        $.ajax(settings).done(function(response) {
           if(response.trxe && response.default_transcoder == 'genoa') {
            vm.transcoder = response.trxe;
            vm.pid = response.pid;
           } else {
            vm.transcoder = 'aws';
            vm.pid = null;
           }
        })
        .error(function(error){
          //console.log(error);
        });
    }
    vm.checkTranscoder();

    $scope.updateFiles = function(){
        vm.files = $('#uploader')[0].files;
        if($('#uploader')[0].files.length > 0){
            $('#uploadBtn').prop("disabled",false);
        }else{
            $('#uploadBtn').prop("disabled",true);
        }
        $scope.$apply();
    }
    $scope.cancel = function(){
        vm.mediaUrl = null;
        console.log("Aborting request upload..");
        if(typeof vm.request != 'undefined'){
            vm.request.abort();
        }
        $uibModalStack.dismissAll();
    }
    $scope.uploadFiles = function(){
        var data = new FormData();
        var errorName = false;
        $scope.loading = true;

        if(vm.transcoder == 'aws'){
            $.each($('#uploader')[0].files, function(i, file) {
                var first_validation = vm.fileValidation(file.name, file.type);
                if(first_validation){
                    $scope.loading = false;
                    errorName = true;
                    return false;
                }
                if (file.name.includes('___')){
                    alert("The filename cannot include tree underscores together. The following file not comply with this restriction: " + file.name);
                    errorName = true;
                    return false;
                } else {
                    data.append(file.name, file);
                }
            });
            if (errorName){
                vm.files = [];
                data = new FormData();
                return;
            }
            vm.progress = true;
            vm.request = $.ajax({
                url : $rootScope.apiUploads + "/api/v1/content/upload/" + $scope.client_id + '/' + $scope.category_selected,
                type: "POST",
                data : data,
                xhr: function () {
                    var xhr = $.ajaxSettings.xhr();
                    xhr.upload.onprogress = function (e) {
                        if (e.lengthComputable) {
                            var porcentage = e.loaded / e.total;
                            porcentage = porcentage.toFixed(2);
                            porcentage = porcentage.split(".")[1];
                            $('#progress-line').width(porcentage+'%');
                            $('#progress-line').text(porcentage+'%');
                        }
                    };
                    return xhr;
                },
                processData: false,
                contentType: false,
                success:function(data, textStatus, jqXHR){
                    $scope.loading   = false;
                    toastr.success("The files were upload successfully, starting processing data..", 'Success');
                    $('#uploadBtn').prop("disabled",false);

                    $uibModalStack.dismissAll();

                },
                error: function(jqXHR, textStatus, errorThrown){
                    $scope.loading   = false;
                    $('#uploadBtn').prop("disabled",false);
                    toastr.error(errorThrown, 'Error');
                    $scope.errorCategory = errorThrown;
                    if(typeof error != 'undefined'){
                        if(error.responseJSON.error == 'no session found.'){
                            Auth.isLoggedIn();
                        }
                    }
                    $uibModalStack.dismissAll();
                }
            });
        } else {
            $.each($('#uploader')[0].files, function(i, file) {
                var first_validation = vm.fileValidation(file.name, file.type);
                if(first_validation){
                    $scope.loading = false;
                    errorName = true;
                    return false;
                }
                if (file.name.includes('___')){
                    alert("The filename cannot include tree underscores together. The following file not comply with this restriction: " + file.name);
                    errorName = true;
                    return false;
                } else {
                    var tmp = file.name.substr(0, file.name.lastIndexOf('.')) || file.name
                    data.append("file", file);
                    data.append("name", tmp);
                    data.append("cid", $scope.category_selected.split('-')[1]);
                    data.append("access_token", "D0B7F48B03BC883151A814C5714D2370D6A13E3A697A70ED00E319F80CD4F1C6");
                    data.append("created_by", JSON.parse(localStorage.getItem('session')).name);
                    data.append("pid", vm.pid);
                }
            });
            if (errorName){
                vm.files = [];
                data = new FormData();
                return;
            }
            vm.progress = true;
            vm.request = $.ajax({
                url : vm.transcoder + "/upload",
                type: "POST",
                data : data,
                xhr: function () {
                    var xhr = $.ajaxSettings.xhr();
                    xhr.upload.onprogress = function (e) {
                        if (e.lengthComputable) {
                            var porcentage = e.loaded / e.total;
                            porcentage = porcentage.toFixed(2);
                            porcentage = porcentage.split(".")[1];
                            $('#progress-line').width(porcentage+'%');
                            $('#progress-line').text(porcentage+'%');
                        }
                    };
                    return xhr;
                },
                processData: false,
                contentType: false,
                success:function(data, textStatus, jqXHR){
                    $scope.loading   = false;
                    toastr.success("The files were upload successfully, starting processing data..", 'Success');
                    $('#uploadBtn').prop("disabled",false);

                    $uibModalStack.dismissAll();

                },
                error: function(jqXHR, textStatus, errorThrown){
                    $scope.loading   = false;
                    $('#uploadBtn').prop("disabled",false);
                    toastr.error(errorThrown, 'Error');
                    $scope.errorCategory = errorThrown;
                    if(typeof error != 'undefined'){
                        if(error.responseJSON.error == 'no session found.'){
                            Auth.isLoggedIn();
                        }
                    }
                    $uibModalStack.dismissAll();
                }
            });

        }
    }
    $scope.uploadAudio = function(){
        var data        = new FormData();
        var name        = $('#media-name').val();
        var description = $('#media-description').val();
        var tags        = ($('#tags').val() != '')? $('#tags').val() : '';
        var cid         = ($('#categories').val() != '')? $('#categories').val() : '';
        var files       = $('#uploaderAudio')[0].files;


        if((name != '') && (categories != '') && (files.length > 0)){
            var first_validation = vm.fileValidation(files[0].name, files[0].type);
            if(first_validation){
                $scope.loading = false;
                return false;
            }
            $scope.loading  = true;
            data.append("name",name);
            data.append("description",description);
            data.append("tags",tags);
            data.append("cid",cid);
            data.append("file", files[0]);
            data.append("client_id", $scope.client_id);
            vm.request = $.ajax({
            url : $rootScope.apiUploads + "/api/v1/content/upload/audio",
            type: "POST",
            data : data,
            processData: false,
            contentType: false,
            success:function(data, textStatus, jqXHR){
                $scope.session.lastNode = 'CAT-' + cid;
                localStorage.setItem('session', JSON.stringify($scope.session));
                $scope.loading   = false;
                toastr.success("The file was upload successfully, starting processing data..", 'Success');
                $uibModalStack.dismissAll();

            },
            error: function(jqXHR, textStatus, errorThrown){
                $scope.loading   = false;
                toastr.error(errorThrown, 'Error');
                $uibModalStack.dismissAll();
            }
        });
        }else{
            alert("You must enter a name, categories and upload a file!");
        }
    }
    $scope.enableUploadBtn = function(){
      $scope.disableBtn = false;
    }
    vm.loadCategories = function(){
        var settings = {
          "async": true,
          "crossDomain": true,
          "url": $rootScope.apiUrl + "/api/v1/categories",
          "data":{
                    'client_id': JSON.parse(localStorage.getItem("session")).client_id,
                    'list' : 1
                 },
          "method": "POST"
        }
        $.ajax(settings).done(function(response) {
           $('#categories').html(response);
           $(".chosen-select").chosen({no_results_text: "Oops, nothing found!"});
           $("#tags").tagsinput();
        })
        .error(function(error){
          //console.log(error);
        });
    }
    vm.loadCategories();
    vm.checkYoutubeVideo = function(){
        if(vm.mediaUrl != ''){
            $.ajax({
                "async": true,
                "crossOrigin": true,
                "crossDomain": true,
                "url": $rootScope.apiUrl + "/api/v1/youtube/validation"+"?yt_url="+vm.mediaUrl,
                "method": "GET"
            }).success(function (response) {
                console.log(response.html)
                var html = response.html.replace('width="'+response.width+'"','width="100%"');
                console.log(html)
                $('#yt-display').html(html);
            }).error(function (error) {
                console.log(error)
                $('#yt-display').html("Ups, No youtube url valid found.");
            });
        } else {
            $('#content-display').hide();
            $('#yt-display').html("");
        }
    }
    vm.checkM3u8 = function(){
        if(vm.mediaUrl != ''){
            videojs('content-display').ready(function(){
                var player = this;
                player.src({ type: 'application/x-mpegURL', src: vm.mediaUrl });
                $('#content-display').show();
            });
        }
    }
    vm.validateData = function(type){
        var name        = $('#media-name').val();
        var description = $('#media-description').val();
        var tags        = ($('#tags').val() != '')? $('#tags').val() : '';
        var cid         = ($('#categories').val() != '')? $('#categories').val() : '';
        var yt_url      = $('#media-mediaUrl').val();

        if((name != '') && (categories != '') && (yt_url != '')){
            var settings = {
              "async": true,
              "crossDomain": true,
              "url": $rootScope.apiUrl + "/api/v1/content/" + type,
              "data": {
                "client_id"   : JSON.parse(localStorage.getItem("session")).client_id,
                "name"        : name,
                "description" : description,
                "yt_url"   : yt_url,
                "cid"         : cid,
                "tags"        : tags
              },
              "method": "POST",
              "headers": {
                "cache-control": "no-cache",
              }
            }

            $.ajax(settings)
            .success(function (response) {
                toastr.success("The file have been upload successfully, starting processing data..", 'Upload File');
                $scope.session.lastNode = 'CAT-' + cid;
                localStorage.setItem('session', JSON.stringify($scope.session));
                $scope.loading   = false;
                $uibModalStack.dismissAll();
            })
            .error(function (error){
                toastr.error("Ups, something went wrong.", 'Error');
                console.log(error);
            });
        }else{
            alert("You must complete name, categories, url!");
        }
    }
    vm.fileValidation = function(filename, type){
        var ext  = type.split("/")[1];
        var name = filename.split("." + ext)[0];
        var splChars = "*|,\":<>[]{}`\';()@&$#%";
        var notAllowed  = false;

        for (var i = 0; i < name.length; i++) {
            if (splChars.indexOf(name.charAt(i)) != -1){
                notAllowed = true;
                break;
            }
        }
        if(notAllowed){
            alert('Your filename contains illegal characters, please remove all the special characters and try again.');
            return true;
        }
        return false;
    }
}

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    // $scope.users = {
    //   0: {
    //     name: 'Vlad',
    //   },
    //   1: {
    //     name: 'Kostya',
    //   },
    //   2: {
    //     name: 'Andrey',
    //   },
    //   3: {
    //     name: 'Nasta',
    //   }
    // };

    // $scope.notifications = [
    //   {
    //     userId: 0,
    //     template: '&name posted a new article.',
    //     time: '1 min ago'
    //   },
    //   {
    //     userId: 1,
    //     template: '&name changed his contact information.',
    //     time: '2 hrs ago'
    //   },
    //   {
    //     image: 'assets/img/shopping-cart.svg',
    //     template: 'New orders received.',
    //     time: '5 hrs ago'
    //   },
    //   {
    //     userId: 2,
    //     template: '&name replied to your comment.',
    //     time: '1 day ago'
    //   },
    //   {
    //     userId: 3,
    //     template: 'Today is &name\'s birthday.',
    //     time: '2 days ago'
    //   },
    //   {
    //     image: 'assets/img/comments.svg',
    //     template: 'New comments on your post.',
    //     time: '3 days ago'
    //   },
    //   {
    //     userId: 1,
    //     template: '&name invited you to join the event.',
    //     time: '1 week ago'
    //   }
    // ];

    // $scope.messages = [
    //   {
    //     userId: 3,
    //     text: 'After you get up and running, you can place Font Awesome icons just about...',
    //     time: '1 min ago'
    //   },
    //   {
    //     userId: 0,
    //     text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
    //     time: '2 hrs ago'
    //   },
    //   {
    //     userId: 1,
    //     text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
    //     time: '10 hrs ago'
    //   },
    //   {
    //     userId: 2,
    //     text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
    //     time: '1 day ago'
    //   },
    //   {
    //     userId: 3,
    //     text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
    //     time: '1 day ago'
    //   },
    //   {
    //     userId: 1,
    //     text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
    //     time: '2 days ago'
    //   },
    //   {
    //     userId: 0,
    //     text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
    //     time: '1 week ago'
    //   }
    // ];

    // $scope.getMessage = function(msg) {
    //   var text = msg.template;
    //   if (msg.userId || msg.userId === 0) {
    //     text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
    //   }
    //   return $sce.trustAsHtml(text);
    // };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes,  $rootScope) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states    = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
              var user_profile   = JSON.parse(localStorage.getItem("session")).user_profile;
              if(item.name != 'administration'){
                return item.level == 0;
              }else{
                if(user_profile == 2){
                  return item.level == 0;
                }
              }
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          removeNotAllowedItems();
          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }

        function removeNotAllowedItems () {
          var session  = JSON.parse(localStorage.getItem("session"));
          var settings = {
            "crossDomain": true,
            "url": $rootScope.apiUrl + "/api/v1/profile-groups/" + session.user_profile,
            "method": "GET"        
          }

          $.ajax(settings).done(function(permissions) {
            $.each($('.al-sidebar-list-link'),function(index,value){
                var href = $(value).attr("href");
                if(!permissions.dashboard){
                  if(href == '#!/dashboard'){
                    $(value).hide();
                  }
                  if(href == '#!/realtime'){
                    $(value).hide();
                  }
                }
              });
          });
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailDetailCtrl', MailDetailCtrl);

  /** @ngInject */
  function MailDetailCtrl($stateParams, mailMessages) {
    var vm = this;
    vm.mail = mailMessages.getMessageById($stateParams.id);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author a.demeshko
 * created on 24/12/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('composeBoxCtrl', composeBoxCtrl);

  /** @ngInject */
  function composeBoxCtrl(subject, to, text) {
    var vm = this;
    vm.subject = subject;
    vm.to = to;
    vm.text = text;
  }
})();
/**
 * @author a.demeshko
 * created on 12/24/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .service('composeModal', composeModal);

  /** @ngInject */
  function composeModal($uibModal) {
      this.open = function(options){
        return $uibModal.open({
          animation: false,
          templateUrl: 'app/pages/components/mail/composeBox/compose.html',
          controller: 'composeBoxCtrl',
          controllerAs: 'boxCtrl',
          size: 'compose',
          resolve: {
            subject: function () {
              return options.subject;
            },
            to: function () {
              return options.to;
            },
            text: function () {
              return options.text;
            }
          }
        });
      }

  }

})();
/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.components.mail')
    .controller('MailListCtrl', MailListCtrl);

  /** @ngInject */
  function MailListCtrl($stateParams,  mailMessages) {
    var vm = this;
    vm.messages = mailMessages.getMessagesByLabel($stateParams.label);
    vm.label = $stateParams.label;
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module("BlurAdmin").run(["$templateCache", function($templateCache) {$templateCache.put("app/pages/administration/administration.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ui-view=\"\"></div></div></div>");
$templateCache.put("app/pages/changepass/changepass.html","<style type=\"text/css\">\n  body{\n    background: url(\"assets/img/blur-bg.jpg\");\n  }\n  @font-face {\n    font-family: \'socicon\';\n    src: url(\"../assets/fonts/socicon.eot\");\n    src: url(\"../assets/fonts/socicon.eot?#iefix\") format(\"embedded-opentype\"), url(\"../assets/fonts/socicon.woff\") format(\"woff\"), url(\"../assets/fonts/socicon.woff2\") format(\"woff2\"), url(\"../assets/fonts/socicon.ttf\") format(\"truetype\"), url(\"../assets/fonts/socicon.svg#sociconregular\") format(\"svg\");\n    font-weight: 400;\n    font-style: normal;\n    text-transform: initial; }\n\n  ::-webkit-scrollbar {\n    width: 0.5em;\n    height: 0.5em; }\n\n  ::-webkit-scrollbar-thumb {\n    background: #d9d9d9;\n    cursor: pointer; }\n\n  ::-webkit-scrollbar-track {\n    background: transparent; }\n\n  .btn:focus, .btn:active:focus, .btn.active:focus,\n  .btn.focus, .btn:active.focus, .btn.active.focus {\n    outline: none; }\n\n  .btn {\n    border-radius: 5px;\n    -webkit-transition: all 0.1s ease;\n    transition: all 0.1s ease; }\n\n  .btn:hover {\n    -webkit-transform: scale(1.2);\n            transform: scale(1.2); }\n\n  .form-control, .form-control:focus {\n    background-color: rgba(0, 0, 0, 0.4);\n    border-radius: 5px;\n    color: #ffffff; }\n    .form-control::-webkit-input-placeholder, .form-control:focus::-webkit-input-placeholder {\n      color: #ffffff;\n      opacity: 0.9; }\n    .form-control:-moz-placeholder, .form-control:focus:-moz-placeholder {\n      /* Firefox 18- */\n      color: #ffffff;\n      opacity: 0.9; }\n    .form-control::-moz-placeholder, .form-control:focus::-moz-placeholder {\n      /* Firefox 19+ */\n      color: #ffffff;\n      opacity: 0.9; }\n    .form-control:-ms-input-placeholder, .form-control:focus:-ms-input-placeholder {\n      color: #ffffff;\n      opacity: 0.9; }\n\n  .form-control[disabled]::-webkit-input-placeholder, .form-control[readonly]::-webkit-input-placeholder, fieldset[disabled] .form-control::-webkit-input-placeholder {\n    color: #ffffff;\n    opacity: 0.6; }\n\n  .form-control[disabled]:-moz-placeholder, .form-control[readonly]:-moz-placeholder, fieldset[disabled] .form-control:-moz-placeholder {\n    /* Firefox 18- */\n    color: #ffffff;\n    opacity: 0.6; }\n\n  .form-control[disabled]::-moz-placeholder, .form-control[readonly]::-moz-placeholder, fieldset[disabled] .form-control::-moz-placeholder {\n    /* Firefox 19+ */\n    color: #ffffff;\n    opacity: 0.6; }\n\n  .form-control[disabled]:-ms-input-placeholder, .form-control[readonly]:-ms-input-placeholder, fieldset[disabled] .form-control:-ms-input-placeholder {\n    color: #ffffff;\n    opacity: 0.6; }\n\n  .auth-main {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    height: 100%;\n    width: 100%; }\n\n  .auth-block {\n    width: 540px;\n    margin: 0 auto !important;\n    border-radius: 5px;\n    background: rgba(0, 0, 0, 0.55);\n    color: #fff;\n    opacity: 0.81;\n    padding: 32px; }\n    .auth-block h1 {\n      font-weight: 300;\n      margin-bottom: 28px;\n      text-align: center; }\n    .auth-block p {\n      font-size: 16px; }\n    .auth-block a {\n      text-decoration: none;\n      outline: none;\n      -webkit-transition: all 0.2s ease;\n      transition: all 0.2s ease;\n      color: #209e91; }\n      .auth-block a:hover {\n        color: #1b867b; }\n    .auth-block .control-label {\n      padding-top: 11px;\n      color: #ffffff; }\n    .auth-block .form-group {\n      margin-bottom: 12px; }\n\n  .auth-input {\n    width: 300px;\n    margin-bottom: 24px; }\n    .auth-input input {\n      display: block;\n      width: 100%;\n      border: none;\n      font-size: 16px;\n      padding: 4px 10px;\n      outline: none; }\n\n  a.forgot-pass {\n    display: block;\n    text-align: right;\n    margin-bottom: -20px;\n    float: right;\n    z-index: 2;\n    top: 10px;\n    position: relative; }\n\n  .auth-link {\n    display: block;\n    font-size: 16px;\n    text-align: center;\n    margin-bottom: 33px; }\n\n  .auth-sep {\n    margin-top: 36px;\n    margin-bottom: 24px;\n    line-height: 20px;\n    font-size: 16px;\n    text-align: center;\n    display: block;\n    position: relative; }\n    .auth-sep > span {\n      display: table-cell;\n      width: 30%;\n      white-space: nowrap;\n      padding: 0 24px;\n      color: #ffffff; }\n      .auth-sep > span > span {\n        margin-top: -12px;\n        display: block; }\n    .auth-sep:before, .auth-sep:after {\n      border-top: solid 1px #ffffff;\n      content: \"\";\n      height: 1px;\n      width: 35%;\n      display: table-cell; }\n\n  .btn-auth {\n    color: #ffffff !important; }\n  \n  .login-form{\n    margin-top: 100px;\n    margin-left: 8%;\n  }\n  .error-message{\n    color: red;\n    font-family: Roboto;\n    font-size: 18px;\n  }\n</style><div class=\"row\"><div class=\"login-form col-lg-8\"><div class=\"auth-main\" ng-controller=\"ChangePassCtrl as vm\"><div class=\"auth-block\"><h1>First Time - Change Password</h1><h3>* Your password must have at least one capital letter</h3><h3>* Your password must have at least one number</h3><h3>* Your password lenght must have at least 8 letters</h3><form class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Password</label><div class=\"col-sm-6\"><input type=\"password\" class=\"form-control\" id=\"inputPassword1\" placeholder=\"Password\" required=\"\" title=\"please insert a password\" x-moz-errormessage=\"please enter an password\" ng-model=\"vm.pass1\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Password</label><div class=\"col-sm-6\"><input type=\"password\" class=\"form-control\" id=\"inputPassword2\" placeholder=\"Repeat password\" required=\"\" title=\"please repeat password\" x-moz-errormessage=\"please enter a password\" ng-model=\"vm.pass2\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-9\"><button type=\"submit\" class=\"btn btn-default btn-auth\" ng-click=\"vm.changePassword()\" ng-disabled=\"vm.loading\">Change Password</button><div ng-show=\"vm.loading\" class=\"col-sm-5 loading\" style=\"float: right;\"><img height=\"30px\" src=\"assets/img/app/loading.gif\"></div></div></div></form><div class=\"row text-center\"><span class=\"error-message\" ng-bind=\"vm.error\"></span></div></div></div></div></div>");
$templateCache.put("app/pages/content/contentDummy.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ui-view=\"\"></div></div></div>");
$templateCache.put("app/pages/dashboard/dashboard.html","<section ng-controller=\"DashboardCtrl as vm\"><style type=\"text/css\">\n\n      td {\n        padding: 10px !important;\n      }\n\n      body{\n        background: #fafafa;\n        font-family: Roboto;\n      }\n\n      #selectPublisherAds {\n        position: absolute;\n        top: 12px;\n        left: 277px;\n      }\n\n      #dashboard-dates {\n        padding: 10px;\n      }\n      .content-top{\n        display: none;\n      }\n      .icon-chart{\n        position: relative;\n        left: 10%;\n      }\n      .pie-charts .pie-chart-item-container {\n        position: relative;\n        top: -35px;\n        padding-top: 20px;\n        height: 63px !important;\n        background: #757ce8;\n        color: #fff;\n      }\n      .pie-charts .description {\n        padding: 5px !important;\n        font-size: 20px;\n        font-family: Roboto;\n      }\n      .top-watches{\n        background: white;\n        border: 1px solid grey;\n        box-shadow: 8px 8px 10px #aaa;\n        height: 479px;\n      }\n      .chart-title{\n        padding: 10px;\n      }\n      .feed-panel {\n          max-height: 850px;\n      }\n      .md-button{\n        min-height: 30px;\n        line-height: 32px;\n      }\n      #loader-screen{\n        top: 0px;\n        left: 0px;\n        bottom: 0px;\n        position: absolute;\n        width: 100%;\n        height: 2000px;\n        background: black;\n        z-index: 99999999;\n        opacity: 0.6;\n      }\n      #loading-title{\n        position: absolute;\n        color: white;\n        z-index: 9999999999;\n        margin: 20% 50%;\n      }\n      #spinner{\n        position: absolute;\n        color: white;\n        z-index: 9999999999;\n        margin: 22% 50%;\n      }\n      #sidebar{\n        background: #1c2b36;\n      }\n      #filters-container{\n        margin-top: 15px;\n        padding: 10px;\n        color: white;\n      }\n      .filter-title{\n        color: white !important;\n        width: 100%;\n        padding: 10px;\n        margin-bottom: 5px;\n      }\n      .box{\n        color: white;\n        cursor: pointer;\n        width: 100%;\n        padding: 10px;\n      }\n      .box a{\n        color: white;\n      }\n      .box a:hover{\n        color: grey;\n      }\n      .box:hover{\n        background: black;\n      }\n      .box:focus{\n        outline: none;\n      }\n      .daterange{\n        background: #1c2b36;\n        z-index: 9999999999;\n      }\n      .md-datepicker-input-container {\n        padding: 5px !important;\n      }\n      .md-datepicker-input{\n        color: white;\n      }\n      .md-button.md-icon-button md-icon, button.md-button.md-fab md-icon{\n        color: white;\n      }\n      .md-default-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle, .md-datepicker-triangle-button .md-datepicker-expand-triangle{\n          border-top-color: rgba(255,255,255,0.87);\n      }\n\n      #btn-filter{\n        position: fixed;\n        bottom: 10px;\n        right: 10px;\n        z-index: 9999999999;\n      }\n      md-sidenav{\n        position: fixed;\n        background: #1c2b36;\n        margin-top: 200px;\n        right: 15px;\n        height: 608px;\n        width: 230px;\n        -webkit-box-shadow: 10px 10px 68px 0px rgba(0,0,0,0.75);\n        -moz-box-shadow: 10px 10px 68px 0px rgba(0,0,0,0.75);\n        box-shadow: 10px 10px 68px 0px rgba(0,0,0,0.75);\n      }\n      .pin{\n        color: white;\n        cursor: pointer;\n        top: 10px;\n      }\n      .unpined{\n        color: white;\n        top: 15px;\n        -ms-transform: rotate(45deg); /* IE 9 */\n        -webkit-transform: rotate(45deg); /* Chrome, Safari, Opera */\n        transform: rotate(45deg);\n        cursor: pointer;\n      }\n      .unpined:hover{\n        color: white;\n        top: 10px;\n        -ms-transform: rotate(0deg); /* IE 9 */\n        -webkit-transform: rotate(0deg); /* Chrome, Safari, Opera */\n        transform: rotate(0deg);\n      }\n      .unpined:focus{\n        outline: none;\n      }\n      .pin:focus{\n        outline: none;\n      }\n      .message-header:focus{\n        outline: none;\n      }\n      .message-content:focus{\n        outline: none;\n      }\n      .export-csv{\n        position: absolute;\n        cursor: pointer;\n        top: 5px;\n        right: 30px;\n        color: green;\n      }\n      .choose-publisher{\n        position: absolute;\n        margin-bottom: 20px;\n        top: 12px;\n        left: 170px;\n      }\n      #playsByPidsChart{\n        height: 400px;\n      }\n  </style><div id=\"dashboard-container\"><div id=\"dashboard-dates\" class=\"col-lg-12\"><md-toolbar style=\"background: #3f51b5; color: white; margin-bottom: 40px;\"><div class=\"md-toolbar-tools\"><h3>Dashboard calculated from dates {{start}} to {{end}}</h3></div></md-toolbar><div class=\"pie-charts text-center\"><div class=\"pie-chart-item-container\" ng-repeat=\"chart in charts\"><div><div class=\"pie-chart-item\"><div class=\"description\"><div>{{ ::chart.description }} <b>{{ ::chart.stats }}</b></div></div></div></div></div></div><div class=\"col-lg-12\"><div ng-show=\"analyticsType == \'vod_analytics\'\"><div class=\"row\"><div ng-show=\"playsPids.length > 0\" class=\"col-md-3\" ba-panel=\"\" ba-panel-title=\"Plays by Publishers\" style=\"padding-top: 20px;\"><div id=\"playsByPidsChart\" class=\"admin-chart\"></div></div><div ng-show=\"dailyPlays.length > 0\" class=\"col-md-9\" style=\"padding-top: 20px;\"><div ba-panel=\"\" ba-panel-title=\"Daily Plays by Publishers\" ba-panel-class=\"with-scroll\"><a class=\"export-csv\" ng-click=\"exportPlaysPerPublishersCSV()\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Export data to CSV\"><i class=\"fa fa-2x fa-file-excel-o\" aria-hidden=\"true\"></i></a><div id=\"dailyPlays\"></div></div></div></div><div class=\"row\"><div ng-show=\"dailyPlays.length > 0\" class=\"col-md-12\" style=\"padding-top: 20px;\"><div ba-panel=\"\" ba-panel-title=\"Advertising Details By days\" ba-panel-class=\"with-scroll\"><a class=\"export-csv\" ng-click=\"exportAdsCSV()\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Export data to CSV\"><i class=\"fa fa-2x fa-file-excel-o\" aria-hidden=\"true\"></i></a><select id=\"selectPublisherAds\" ng-model=\"select_publisherAds\" ng-change=\"loadAdsByPids()\"><option ng-repeat=\"pub in publishers\" value=\"{{pub.id}}\">{{pub.value}}</option></select><div id=\"dailyAdsPlays\"></div></div></div></div><div class=\"row\"><div ng-show=\"feed.length > 0\" class=\"col-lg-6 col-md-12 col-sm-12\"><div ba-panel=\"\" ba-panel-title=\"Top 10 Watched\" ba-panel-class=\"medium-panel feed-panel\"><div class=\"feed-messages-container\" track-width=\"smallContainerWidth\" style=\"overflow-y: auto; height: 328px;\"><div class=\"feed-message\" ng-repeat=\"message in feed\"><div class=\"message-icon\" ng-if=\"message.type == \'text-message\'\" ng-click=\"expandMessage(message)\"><img class=\"photo-icon\" ng-src=\"{{message.preview}}\"></div><div class=\"message-icon\" ng-if=\"message.type != \'text-message\'\" ng-click=\"expandMessage(message)\"><img class=\"photo-icon\" ng-src=\"{{message.preview}}\"> <span class=\"sub-photo-icon\" ng-class=\"::message.type\"></span></div><div class=\"text-block text-message\"><div class=\"message-header\" ng-click=\"expandMessage(message)\"><span class=\"author\">{{ ::message.author }} {{ ::message.surname}}</span></div><div class=\"message-content line-clamp\" ng-class=\"{\'line-clamp-2\' : !message.expanded}\" ng-click=\"expandMessage(message)\"><span ng-if=\"message.preview\">{{message.header}}</span><br>{{::message.text}}</div><div class=\"preview\" ng-show=\"message.expanded\" ng-if=\"message.preview\"><div ng-if=\"!message.embed\"><img ng-src=\"{{message.preview}}\"></div><div ng-if=\"message.embed\"><div ng-if=\"message.file == \'video\'\"><video id=\"video-{{message.id}}\" class=\"video-js vjs-default-skin\" controls=\"\" poster=\"{{message.preview}}\"><source ng-src=\"{{trustSrc(message.embed)}}\" type=\"{{message.source}}\"></video></div><div ng-if=\"message.file == \'audio\'\"><audio id=\"audio-{{message.id}}\" class=\"video-js vjs-default-skin\" controls=\"\" poster=\"{{message.preview}}\"><source ng-src=\"{{trustSrc(message.embed)}}\" type=\"{{message.source}}\"></audio></div></div></div><div ng-show=\"message.expanded\" class=\"message-time\" ng-click=\"expandMessage(message)\"><div class=\"post-time\">{{::message.time}}</div></div></div></div></div></div></div><div ng-show=\"uploadByCategory.length > 0\" class=\"col-lg-6 col-md-12 col-sm-12\" ba-panel=\"\" ba-panel-title=\"Top 5 Categories Inserts\" ba-panel-class=\"medium-panel\"><div class=\"channels-block\"></div><div class=\"channels-info\"><div><div class=\"channels-info-item\" ng-repeat=\"item in uploadByCategory | orderBy:\'order\'\"><div class=\"legend-color\" style=\"background-color: {{item.color}}\"></div><p>{{item.label}}<span class=\"channel-number\">{{item.percentage}}</span></p><div class=\"progress progress-sm channel-progress\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{item.percentage}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{item.percentage}}%\"></div></div></div></div></div></div></div><div class=\"row\"><div ng-show=\"playsByContentGraph.length > 0\" class=\"col-md-12\" style=\"padding-top: 20px;\"><div ba-panel=\"\" ba-panel-title=\"Content\'s plays\" ba-panel-class=\"with-scroll\"><div id=\"playsByContent\" class=\"storageGraph\"></div></div></div></div><div class=\"row\"></div><div class=\"row\"><div class=\"data-table-panel col-lg-3 col-md-3 col-sm-3\" ba-panel=\"\" ba-panel-title=\"Upload By Users\" style=\"padding-top: 20px;\"><select id=\"select-publisher\" class=\"choose-publisher\" ng-model=\"select_publishers\" ng-change=\"reloadUserUploads()\"><option value=\"\">ALL</option><option ng-repeat=\"pub in publishers\" value=\"{{pub.id}}\">{{pub.value}}</option></select><div class=\"row\" style=\"overflow-y: auto !important;height: 400px !important;\"><a class=\"fa fa-2x fa-file-excel-o export-csv\" export-to-csv=\"\" ng-if=\"uploadByUsers.length != 0\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Export data to CSV\"></a><table id=\"uploadsByuserTable\" class=\"table\" ng-if=\"uploadByUsers.length != 0\"><thead><tr><th class=\"text-center\">User</th><th class=\"text-center\">Total</th></tr></thead><tbody class=\"overflow\"><tr ng-model=\"uploadByUsers\" ng-repeat=\"item in uploadByUsers\"><td class=\"text-center\" ng-if=\"item.created_by != 0\"><strong>{{item.created_by}}</strong></td><td class=\"text-center\" ng-if=\"item.created_by == 0\"><strong>API</strong></td><td class=\"text-center\"><strong>{{item.total}}</strong></td></tr></tbody></table><div ng-if=\"uploadByUsers.length == 0\" style=\"padding: 100px;\"><center><h4>No data found</h4></center></div></div></div><div class=\"data-table-panel col-lg-9 col-md-9 col-sm-9\" ba-panel=\"\" ba-panel-title=\"Top Watched\" style=\"padding-top: 20px;\"><select id=\"select-publisher\" class=\"choose-publisher\" ng-model=\"publisher_topten\" ng-change=\"filterTable(\'topWached\',publisher_topten,3)\"><option value=\"\" selected=\"\">ALL</option><option ng-repeat=\"pub in publishers\" value=\"{{pub.value}}\">{{pub.value}}</option></select><div class=\"row\" style=\"overflow-y: auto !important;height: 400px !important;\"><a class=\"fa fa-2x fa-file-excel-o export-csv\" export-to-csv=\"\" ng-if=\"topTenPlayed.length != 0\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Export data to CSV\"></a><table id=\"topWached\" class=\"table\"><thead ng-if=\"topTenPlayed.length != 0\"><tr><th>#</th><th>Name</th><th>Plays</th><th>Publisher</th><th>Referrer</th></tr></thead><tbody class=\"overflow\"><tr ng-model=\"topTenPlayed\" ng-repeat=\"item in topTenPlayed\"><td><a ng-click=\"openModalContentGraph(item.id)\" style=\"cursor: pointer;\">{{item.id}}</a></td><td>{{item.name}}</td><td>{{item.plays}}</td><td>{{item.p_name}}</td><td><a target=\"_blank\" href=\"{{item.referrer}}\">{{item.referrer}}</a></td></tr></tbody></table><div ng-if=\"topTenPlayed.length == 0\" style=\"padding: 100px;\"><center><h4>No data found</h4></center></div></div></div></div></div><div ng-show=\"analyticsType == \'genoa_usage\'\"><div class=\"row pie-charts\"><div class=\"pie-chart-item-container\" ng-repeat=\"chart in genoa_usage_charts\"><div ba-panel=\"\"><div class=\"pie-chart-item\"><div class=\"description\"><div>{{ ::chart.description }}</div><div class=\"description-stats\">{{ ::chart.stats }}</div></div><i class=\"icon-chart fa fa-{{ ::chart.icon }} fa-4x\" aria-hidden=\"true\"></i></div></div></div></div><div class=\"row\"><div ng-show=\"storageGraphCategories.length > 0\" class=\"col-md-12\" style=\"padding-top: 20px;\"><div ba-panel=\"\" ba-panel-title=\"Publishers Storage\" ba-panel-class=\"with-scroll\"><div id=\"storageGraph\" class=\"storageGraph\"></div></div></div></div><div class=\"row\"><div ng-show=\"dataTransferred.length > 0\" class=\"col-md-12\" style=\"padding-top: 20px;\"><div ba-panel=\"\" ba-panel-title=\"Data Transferred by Publishers\" ba-panel-class=\"with-scroll\"><div id=\"dataTransferred\" class=\"dataTransferred\"></div></div></div></div></div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"right\" md-disable-backdrop=\"\" md-whiteframe=\"2\"><div id=\"sidebar\"><div id=\"filters-container\"><div class=\"col-lg-9\"><h4 class=\"filter-title\">Filters</h4></div><div id=\"filter-pin\" ng-click=\"pinChange()\" class=\"unpined col-lg-3 pull-right\"><i class=\"fa fa-thumb-tack\" aria-hidden=\"true\"></i></div><br><br><hr><div ng-click=\"updateFilterDate(\'today\')\" class=\"box\"><a>Today</a></div><div ng-click=\"updateFilterDate(\'yesterday\')\" class=\"box\"><a>Yesterday</a></div><div ng-click=\"updateFilterDate(\'last_7\')\" class=\"box\"><a>Last 7 days</a></div><div ng-click=\"updateFilterDate(\'last_30\')\" class=\"box\"><a>Last 30 days</a></div><div ng-click=\"updateFilterDate(\'last_3m\')\" class=\"box\"><a>Last 3 months</a></div><div class=\"input-group daterange\"><div layout-gt-xs=\"row\"><div flex-gt-xs=\"\"><md-datepicker ng-model=\"date.startDate\" md-placeholder=\"Start date\"></md-datepicker></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"\"><md-datepicker ng-model=\"date.endDate\" md-placeholder=\"End date\"></md-datepicker></div></div><div layout-gt-xs=\"row\"><div flex-gt-xs=\"\"><md-button ng-click=\"updateDate()\" class=\"md-raised md-warn\">Submit Custom Dates</md-button></div></div></div></div></div></md-sidenav><md-button id=\"btn-filter\" class=\"md-fab md-warn\" ng-click=\"toggleRight()\" aria-label=\"Filters\"><md-icon class=\"fa fa-2x fa-filter\"></md-icon></md-button><div ng-if=\"loading\" id=\"loader-screen\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div></div></div></section>");
$templateCache.put("app/pages/login/auth.html","<style type=\"text/css\">\n  body{\n    background: url(\"https://static.vodgc.net/background.jpg\") no-repeat center center fixed;\n    -webkit-background-size: cover;\n    -moz-background-size: cover;\n    -o-background-size: cover;\n    background-size: cover;\n  }\n  @font-face {\n    font-family: \'socicon\';\n    src: url(\"../assets/fonts/socicon.eot\");\n    src: url(\"../assets/fonts/socicon.eot?#iefix\") format(\"embedded-opentype\"), url(\"../assets/fonts/socicon.woff\") format(\"woff\"), url(\"../assets/fonts/socicon.woff2\") format(\"woff2\"), url(\"../assets/fonts/socicon.ttf\") format(\"truetype\"), url(\"../assets/fonts/socicon.svg#sociconregular\") format(\"svg\");\n    font-weight: 400;\n    font-style: normal;\n    text-transform: initial; }\n\n  ::-webkit-scrollbar {\n    width: 0.5em;\n    height: 0.5em; }\n\n  ::-webkit-scrollbar-thumb {\n    background: #d9d9d9;\n    cursor: pointer; }\n\n  ::-webkit-scrollbar-track {\n    background: transparent; }\n\n  .btn:focus, .btn:active:focus, .btn.active:focus,\n  .btn.focus, .btn:active.focus, .btn.active.focus {\n    outline: none; }\n\n  .btn {\n    border-radius: 5px;\n    -webkit-transition: all 0.1s ease;\n    transition: all 0.1s ease; }\n\n  .btn:hover {\n    -webkit-transform: scale(1.2);\n            transform: scale(1.2); }\n\n  .form-control, .form-control:focus {\n    background-color: rgba(0, 0, 0, 0.4);\n    border-radius: 5px;\n    color: #ffffff; }\n    .form-control::-webkit-input-placeholder, .form-control:focus::-webkit-input-placeholder {\n      color: #ffffff;\n      opacity: 0.9; }\n    .form-control:-moz-placeholder, .form-control:focus:-moz-placeholder {\n      /* Firefox 18- */\n      color: #ffffff;\n      opacity: 0.9; }\n    .form-control::-moz-placeholder, .form-control:focus::-moz-placeholder {\n      /* Firefox 19+ */\n      color: #ffffff;\n      opacity: 0.9; }\n    .form-control:-ms-input-placeholder, .form-control:focus:-ms-input-placeholder {\n      color: #ffffff;\n      opacity: 0.9; }\n\n  .form-control[disabled]::-webkit-input-placeholder, .form-control[readonly]::-webkit-input-placeholder, fieldset[disabled] .form-control::-webkit-input-placeholder {\n    color: #ffffff;\n    opacity: 0.6; }\n\n  .form-control[disabled]:-moz-placeholder, .form-control[readonly]:-moz-placeholder, fieldset[disabled] .form-control:-moz-placeholder {\n    /* Firefox 18- */\n    color: #ffffff;\n    opacity: 0.6; }\n\n  .form-control[disabled]::-moz-placeholder, .form-control[readonly]::-moz-placeholder, fieldset[disabled] .form-control::-moz-placeholder {\n    /* Firefox 19+ */\n    color: #ffffff;\n    opacity: 0.6; }\n\n  .form-control[disabled]:-ms-input-placeholder, .form-control[readonly]:-ms-input-placeholder, fieldset[disabled] .form-control:-ms-input-placeholder {\n    color: #ffffff;\n    opacity: 0.6; }\n\n  .auth-main {\n    position: fixed;\n    right: 15%;\n    margin-top: 60px;\n  }\n\n  .auth-block {\n    width: 540px;\n    margin: 0 auto !important;\n    border-radius: 5px;\n    background: rgba(0, 0, 0, 0.55);\n    color: #fff;\n    opacity: 0.81;\n    padding: 32px; }\n    .auth-block h1 {\n      font-weight: 300;\n      margin-bottom: 28px;\n      text-align: center; }\n    .auth-block p {\n      font-size: 16px; }\n    .auth-block a {\n      text-decoration: none;\n      outline: none;\n      -webkit-transition: all 0.2s ease;\n      transition: all 0.2s ease;\n      color: #209e91; }\n      .auth-block a:hover {\n        color: #1b867b; }\n    .auth-block .control-label {\n      padding-top: 11px;\n      color: #ffffff; }\n    .auth-block .form-group {\n      margin-bottom: 12px; }\n\n  .auth-input {\n    width: 300px;\n    margin-bottom: 24px; }\n    .auth-input input {\n      display: block;\n      width: 100%;\n      border: none;\n      font-size: 16px;\n      padding: 4px 10px;\n      outline: none; }\n\n  a.forgot-pass {\n    display: block;\n    text-align: right;\n    margin-bottom: -20px;\n    float: right;\n    z-index: 2;\n    top: 10px;\n    position: relative; \n  }\n\n  .auth-link {\n    display: block;\n    font-size: 16px;\n    text-align: center;\n    margin-bottom: 33px; }\n\n  .auth-sep {\n    margin-top: 36px;\n    margin-bottom: 24px;\n    line-height: 20px;\n    font-size: 16px;\n    text-align: center;\n    display: block;\n    position: relative; }\n    .auth-sep > span {\n      display: table-cell;\n      width: 30%;\n      white-space: nowrap;\n      padding: 0 24px;\n      color: #ffffff; }\n      .auth-sep > span > span {\n        margin-top: -12px;\n        display: block; }\n    .auth-sep:before, .auth-sep:after {\n      border-top: solid 1px #ffffff;\n      content: \"\";\n      height: 1px;\n      width: 35%;\n      display: table-cell; }\n\n  .btn-auth {\n    color: #ffffff !important; }\n  \n  .login-form{\n    margin-top: 100px;\n    margin-left: 8%;\n  }\n  .error-message{\n    color: red;\n    font-family: Roboto;\n    font-size: 18px;\n  }\n  .forgot-password {\n    color: white !important;\n    cursor: pointer;\n  }\n  .recovery{\n    position: absolute;\n  }\n  #over-background{\n    position: fixed;\n    z-index: 2;\n  }\n</style><div id=\"over-background\" ng-controller=\"LoginCtrl as vm\"><div class=\"row\" ng-if=\"!vm.recoveryMode\"><div class=\"login-form col-lg-12 pull-right\"><div class=\"auth-main\"><div class=\"auth-block\" ng-if=\"vm.template_login && !vm.recoveryMode\"><h1>Sign in to Genoa <img src=\"assets/img/tv-logo.png\" height=\"35px\" style=\"top: -7px;position: relative\"></h1><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">Email</label><div class=\"col-sm-6\"><input type=\"email\" class=\"form-control\" id=\"inputEmail3\" placeholder=\"Email\" required=\"\" title=\"please enter an e-Mail\" x-moz-errormessage=\"please enter an e-Mail\" ng-model=\"vm.email\"></div></div><div class=\"form-group\"><label for=\"inputPassword3\" class=\"col-sm-2 control-label\">Password</label><div class=\"col-sm-6\"><input type=\"password\" class=\"form-control\" id=\"inputPassword3\" placeholder=\"Password\" required=\"\" title=\"please enter a password\" x-moz-errormessage=\"please enter a password\" ng-model=\"vm.password\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-9\"><button type=\"submit\" class=\"btn btn-default btn-auth\" ng-click=\"vm.login()\" ng-disabled=\"vm.loading\">Sign in</button><div ng-show=\"vm.loading\" class=\"col-sm-5 loading\" style=\"float: right;\"><img height=\"30px\" src=\"assets/img/app/loading.gif\"></div></div></div></form><div class=\"row text-center\"><span class=\"error-message\" ng-bind=\"vm.error\"></span></div><div ng-click=\"vm.showForgotpassword()\" class=\"forgot-password row pull-right\"><a style=\"color: white\">Forgot password</a></div><div class=\"forgot-password recovery row pull-right\"><a ui-sref=\"recovery\" style=\"color: white\">Recovery Mode</a></div></div><div class=\"auth-block\" ng-if=\"!vm.template_login && !vm.recoveryMode\"><h1>Forgot Password <img src=\"assets/img/tv-logo.png\" height=\"35px\" style=\"top: -7px;position: relative\"></h1><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" ng-model=\"vm.recoveryMail\" id=\"recoveryMail\" placeholder=\"Email\" required=\"\" title=\"please enter an e-mail\" x-moz-errormessage=\"please enter an e-Mail\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-9\"><button ng-click=\"vm.cancel()\" class=\"btn btn-default btn-auth\">Cancel</button> &nbsp; &nbsp; &nbsp; <button type=\"submit\" ng-disabled=\"vm.recoveryDisable\" ng-click=\"vm.requestChangePassword()\" class=\"btn btn-default btn-auth\">Request Change Password</button></div></div></form><div class=\"row text-center alert alert-danger\" ng-if=\"vm.errorUser != \'\'\"><span class=\"error-message\" ng-bind=\"vm.errorUser\"></span></div></div></div></div></div><div class=\"row\" ng-if=\"vm.recoveryMode\"><div class=\"login-form col-lg-12 pull-right\"><div class=\"auth-main\"><div class=\"auth-block\"><h1>Change Password</h1><h3>* Your password must have at least one number</h3><h3>* Your password must have at least one capital letter</h3><h3>* Your password lenght must be 8 characters (numbers and letters only)</h3><form class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Code</label><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control\" id=\"code\" placeholder=\"code\" required=\"\" title=\"Insert your recovery code..\" x-moz-errormessage=\"please enter your recovery code\" ng-model=\"vm.code\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Password</label><div class=\"col-sm-6\"><input type=\"password\" class=\"form-control\" id=\"inputPassword1\" placeholder=\"Password\" required=\"\" title=\"please insert a password\" x-moz-errormessage=\"please enter an password\" ng-model=\"vm.pass1\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Password</label><div class=\"col-sm-6\"><input type=\"password\" class=\"form-control\" id=\"inputPassword2\" placeholder=\"Repeat password\" required=\"\" title=\"please repeat password\" x-moz-errormessage=\"please enter a password\" ng-model=\"vm.pass2\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-9\"><button type=\"submit\" class=\"btn btn-default btn-auth\" ng-click=\"vm.changePassword()\" ng-disabled=\"vm.loading\" style=\"color: white\">Change Password</button><div ng-show=\"vm.loading\" class=\"col-sm-5 loading\" style=\"float: right;\"><img height=\"30px\" src=\"assets/img/app/loading.gif\"></div></div></div></form><div class=\"row text-center\"><span class=\"error-message\" ng-bind=\"vm.error\"></span></div></div></div></div></div></div><style type=\"text/css\">\n  #video-background{\n    top: 0px;\n    left: 0px;\n    position: fixed;\n    width: 100%;\n    z-index: 1;\n    opacity: 0.8;\n    transform: rotateY(180deg);\n    -webkit-transform:rotateY(180deg); /* Safari and Chrome */\n    -moz-transform:rotateY(180deg); /* Firefox */\n  }\n</style>");
$templateCache.put("app/pages/dvr/dvr.html","<style type=\"text/css\">\n	.itemName{\n		color: white;\n	    font-size: 16px;\n	    position: absolute;\n	    z-index: 999999;\n	    padding-top: 5px;\n	}\n	.itemImage{\n		position: relative;\n	}\n	.item-box{\n	    background: black;\n	    border: 3px ridge black;\n	    box-shadow: 8px 8px 10px #aaa;\n	    cursor: pointer;\n	    margin-bottom: 20px;\n	    margin-right: 43px;\n	    min-height: 200px;\n	    position: relative;\n	    transform: scale(1);\n	    transition: all 0.3s ease-in-out 0s;\n	    width: 400px;\n	}\n	.item-box:hover{\n		-webkit-transform: scale(1.1);\n		transform: scale(1.1);\n	}\n	.live:before{\n	    color: red;\n	    content: \'\\25CF\';\n	    font-size: 10px;\n	    left: 6px;\n	    padding-right: 10px;\n	    position: relative;\n	    top: -2px;\n	}\n	.itemLabel{\n		bottom: -2px;\n	    color: white;\n	    left: 0;\n	    padding: 5px;\n	    position: absolute;\n	    z-index: 99999;\n	}\n	#box-container{\n		margin-left: 9% !important;\n	}\n	.loading {\n	    position: absolute;\n	    right: 48%;\n	    top: 45%;\n	}\n	#selectors{\n		left: 289px;\n	    position: absolute;\n	    top: 86px;\n	    padding-bottom: 20px;\n	}\n	#box-container{\n		margin-top: 40px;\n	}\n	.alert{\n		top: -36px;\n	}\n</style><div ng-controller=\"DvrCtrl as vm\"><div class=\"col-lg-12\" style=\"margin-top: 40px;\"><div class=\"alert alert-warning shake\" style=\"color: #a66d3b\"><strong>Warning!</strong> Dont forget to select a publisher and a category to import a DVR channel!</div></div><div id=\"selectors\"><div class=\"col-lg-12 row\">Publisher Selected:<select id=\"publisher-select\" ng-change=\"vm.loadCategories()\" ng-model=\"vm.publisher_selected\" data-placeholder=\"Choose a Publisher...\" width=\"100%\" class=\"form-control chosen-select\"></select>Category to import:<select id=\"category-select\" ng-model=\"vm.categories_selected\" data-placeholder=\"Choose a category...\" width=\"100%\" class=\"form-control chosen-select\"></select></div><div id=\"box-container\" class=\"row\" style=\"margin-top: 150px;\"><div id=\"{{item.name}}\" ng-repeat=\"item in vm.items\" class=\"item-box col-xlg-3 col-lg-6 col-md-6 col-sm-6\" style=\"background-image: url({{item.thumbnail}}); background-size: 400px 200px;\" ng-click=\"vm.validateSelection(item.name)\"><span ng-if=\"!vm.loading\" class=\"itemName\"><strong>{{item.name}}</strong></span> <span ng-if=\"!vm.loading\" class=\"itemLabel\"><span ng-if=\"!vm.loading\" class=\"live\"></span><strong>Live</strong></span><div ng-if=\"vm.loading\" class=\"text-center loading\"><img height=\"20px\" src=\"assets/img/app/loading.gif\"></div></div></div></div></div>");
$templateCache.put("app/pages/dvr/dvrWindow.html","<div ng-controller=\"DvrWinCtrl as vm\"><iframe ng-src=\"{{source}}\" frameborder=\"0\" allowfullscreen=\"\" width=\"100%\" height=\"700px\"></iframe></div>");
$templateCache.put("app/pages/player/playerList.html","<style type=\"text/css\">\n  .table_footer{\n    margin-top: 25px;\n    position: relative;\n    right: -16px;\n    top: 30px;\n    padding-bottom: 10px; \n  }\n  #loading{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #selectPartnerText{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #paginator{\n    position: relative;\n    right: 52px;\n    top:0px;\n  }\n  .inner-addon { \n    position: relative; \n  }\n\n  /* style icon */\n  .inner-addon .glyphicon {\n    position: absolute;\n    padding: 10px;\n    pointer-events: none;\n  }\n\n  /* align icon */\n  .left-addon .glyphicon  { left:  0px;}\n  .right-addon .glyphicon { right: 0px;}\n\n  /* add padding  */\n  .left-addon input  { padding-left:  30px; }\n  .right-addon input { padding-right: 30px; }\n  .table-header{padding-bottom: 15px;}\n  .player_button{\n    padding-right: 30px;\n  }\n  .fa{\n    color: grey;\n    cursor: pointer;\n  }\n  tr{\n    padding: 5px;\n  }\n  .action-icon{\n    padding-right: 5px;\n    padding-left: 5px;\n  }\n  .select_action{\n    padding-top: 5px;\n  }\n  .table{\n    background: white;\n  }\n  #no_players{\n    margin: 70px auto;    \n    background: white;\n    width: 100%;\n    border: 1px solid grey;\n    padding: 100px;\n  }\n  .spinner {\n      position: absolute;\n      z-index: 9999999999;\n      width: 66px;\n      margin: 25% 41% !important;\n      animation: rotator 1.4s linear infinite;\n    }\n</style><div ng-if=\"loading\" id=\"loader-screen\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"row table-header player_button\"><div class=\"col-lg-1 pull-right\"><div class=\"form-group\"><button ng-if=\"permissions.create\" ui-sref=\"player-new({\'type\': \'create\'})\" class=\"btn btn-primary\" id=\"new_player\" name=\"new_player\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Create new player\">Create Player</button></div></div></div><div class=\"row col-lg-12\" style=\"height: 700px;overflow-y:auto;overflow-x:none;\"><div ng-if=\"players.length == 0\" id=\"no_players\" class=\"text-center\"><h1>No Players found</h1></div><div class=\"horizontal-scroll custom-table\" ng-if=\"players.length > 0\"><table class=\"table table-bordered\"><thead><tr><th class=\"table-id text-center\">Player ID</th><th class=\"table-id text-center\">Player Name</th><th class=\"text-center\">Publisher</th><th class=\"text-center\">Creation Date</th><th class=\"text-center\">Last Update</th><th class=\"text-center\">Actions</th></tr></thead><tbody><tr ng-model=\"players\" ng-repeat=\"player in players\"><td class=\"text-center\"><strong>{{player.id}}</strong></td><td class=\"text-center\"><strong>{{player.name}}</strong></td><td class=\"text-center\"><strong>{{player.publisher}}</strong></td><td class=\"text-center\"><strong>{{player.created_at}}</strong></td><td class=\"text-center\"><strong>{{player.updated_at}}</strong></td><td class=\"text-center\"><div class=\"select_action\"><a ng-if=\"permissions.edit\" ui-sref=\"player-edit({\'type\': \'edit\', \'player_id\': player.id })\" class=\"edit action-icon\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Edit Player\"><i class=\"fa fa-2x fa-pencil\" aria-hidden=\"true\"></i></a> <a ng-if=\"permissions.delete\" ng-click=\"deletePlayer(player.id)\" class=\"delete action-icon\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Delete Player\"><i class=\"fa fa-2x fa-trash-o\" aria-hidden=\"true\"></i></a> <a ng-if=\"permissions.create\" ng-click=\"clonePlayer(player.id)\" class=\"clone action-icon\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Clone Player\"><i class=\"fa fa-2x fa-clone\" aria-hidden=\"true\"></i></a> <a ng-if=\"permissions.edit\" ng-click=\"purgePlayer(player.id, player.name)\" class=\"action-icon\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Purge player {{player.name}} from CDN\"><i class=\"fa fa-2x fa-refresh\" aria-hidden=\"true\"></i></a></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/pages/player/playerSettings.html","<style type=\"text/css\">\n	#player-box{\n		min-height: 600px;\n		background: white;\n		border: 1px dotted grey;\n	}\n	#custom_player{\n		margin-top: 60px;\n	}\n	.action{\n		padding-left: 10px;\n	}\n\n	.botonera{\n		padding-top: 10px;\n	}\n	.action{\n		margin-right: 12px;\n		padding: 6px 39px;\n		position: relative;\n	}\n	.footer{\n		margin-top: 25px;\n	}\n	.required{\n		font-size: 16px;\n		color: red;\n	}\n	.tab{\n		min-height: 565px;\n	}\n	button.accordion {\n		background-color: #eee;\n		color: #ff832c;\n		cursor: pointer;\n		padding: 18px;\n		width: 100%;\n		text-align: left;\n		border: none;\n		outline: none;\n		transition: 0.4s;\n	}\n\n	button.accordion.active, button.accordion:hover {\n		background-color: #ddd;\n	}\n\n	div.panel.show {\n		display: block;\n	}\n	button.accordion:after {\n		content: \'\\02795\'; /* Unicode character for \"plus\" sign (+) */\n		font-size: 13px;\n		color: #ff832c;\n		float: right;\n		margin-left: 5px;\n	}\n\n	button.accordion.active:after {\n		content: \"\\2796\"; /* Unicode character for \"minus\" sign (-) */\n	}\n	div.panel {\n		padding: 0px;\n		background-color: white;\n		max-height: 0;\n		overflow: hidden;\n		transition: max-height 0.2s ease-out;\n		display: block;\n		z-index: 50;\n	}\n	.gaEvents{\n		display: none;\n	}\n	.twitter-alert{\n		color: grey;\n		margin-top: 20px;\n\n	}\n</style><div ng-controller=\"PlayerSettingsCtrl as vm\"><div class=\"container-player-settings\"><div class=\"row\"><div class=\"col-lg-5\"><uib-tabset class=\"tab\" active=\"$tabSetStatus.activeTab\"><uib-tab heading=\"General\"><div class=\"col-lg-8\"><div class=\"form-group\"><form><label for=\"input01\"><span class=\"required\">*</span> Player Name</label> <input type=\"text\" class=\"form-control\" id=\"player-name\" placeholder=\"Insert a player Name\"> <span id=\"no_name_message\" class=\"help-block sub-little-text\" style=\"color:red; display:none\">This field name is required, please insert a name for this player!</span></form></div></div><div class=\"col-lg-4\"><div class=\"form-group\"><label class=\"nowrap\"><span class=\"required\">*</span> Publishers</label><br><select id=\"publishers_select\" ng-model=\"vm.publisher_selected\" ng-change=\"vm.hidePublisherError()\" ng-options=\"pub.id as pub.name for pub in vm.publishers\"></select><span id=\"no_publisher_message\" class=\"help-block sub-little-text\" style=\"color:red; display:none\">please select a publisher</span></div></div><button class=\"accordion\">Logo</button><div class=\"panel\"><form><div class=\"form-group\"><label for=\"input03\">Logo Top</label> <input type=\"text\" class=\"form-control\" id=\"logo-top\" placeholder=\"Insert a logo URl\"> <span class=\"help-block sub-little-text\">URL to logo in CDN (or internet)</span></div><div class=\"form-group\"><label for=\"input04\">Panel Logo</label> <input type=\"text\" class=\"form-control\" id=\"logo-panel\" placeholder=\"Insert a logo URl\"> <span class=\"help-block sub-little-text\">URL to player panel logo in CDN (or internet)</span></div><div class=\"form-group\"><label for=\"input05\">Logo Destination</label> <input type=\"text\" class=\"form-control\" id=\"logo-url\" placeholder=\"Insert a hiperlink for the panel logo\"></div></form></div><button id=\"look-and-feel\" class=\"accordion\">Look and feel</button><div class=\"panel look-and-feel\"><div class=\"row\"><div class=\"col-lg-4\"><div class=\"form-group\"><label for=\"input05\">Panel Background</label><color-picker id=\"bgPanel\" options=\"vm.options\" ng-model=\"vm.bgPanel\"></color-picker></div></div><div class=\"col-lg-4\"><div class=\"form-group\"><label for=\"input05\">Slider Background</label><color-picker id=\"bgSlider\" options=\"vm.options\" ng-model=\"vm.bgSlider\"></color-picker></div></div><div class=\"col-lg-4\"><div class=\"form-group\"><label for=\"input05\">Controls Background</label><color-picker id=\"bgControls\" options=\"vm.options\" ng-model=\"vm.bgControls\"></color-picker></div></div></div><div class=\"row\"><div class=\"col-lg-4\"><div class=\"form-group\"><label for=\"input05\">Main Button</label><color-picker id=\"bgMainButton\" options=\"vm.options\" ng-model=\"vm.bgMainButton\"></color-picker></div></div><div class=\"col-lg-4\"><div class=\"form-group\"><label for=\"input05\">Main Button hover</label><color-picker id=\"bgMainButtonHover\" options=\"vm.options\" ng-model=\"vm.bgMainButtonHover\"></color-picker></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><textarea id=\"external_css\" style=\"height: 100px;width: 100%;overflow-y: auto; resize: none\" placeholder=\"Custom CSS\"></textarea></div></div></div><button id=\"controles\" class=\"accordion\">Controls</button><div class=\"panel\"><div class=\"row\"><div class=\"col-lg-4\"><div class=\"form-group\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"autoplay\" value=\"\"> <span>Autoplay</span></label></div></div><div class=\"col-lg-4\"><div class=\"form-group\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"video360\" value=\"\"> <span>Videos 360<br><span style=\"background: yellow\">Deprecated on v3</span></span></label></div></div><div class=\"col-lg-4\"><div class=\"form-group\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"download_audio\" value=\"\"> <span>Audio Download<br><span style=\"background: yellow\">Deprecated on v3</span></span></label></div></div></div><div class=\"row\"><div class=\"col-lg-4\"><div class=\"form-group\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"show_title\" value=\"\"> <span>Show Title</span></label></div></div><div class=\"col-lg-8\"><div class=\"form-group\"><label class=\"checkbox-inline custom-checkbox nowrap\">Show quality picker</label><select id=\"quality_picker\"><option value=\"both\">Both</option><option value=\"only_mobile\">Mobile only</option><option value=\"only_desktop\">Desktop only</option><option value=\"none\">None</option></select></div></div></div></div><button class=\"accordion\">Watermark</button><div class=\"panel\"><span class=\"pull-right\" style=\"background: yellow;\">Deprecated on v3</span><form id=\"watermark\"><div class=\"form-group\"><label>Watermark Url</label> <input type=\"text\" class=\"form-control\" id=\"wt_url\" placeholder=\"Insert watermark url\"></div><div class=\"form-group\"><label>Watermark Destination</label> <input type=\"text\" class=\"form-control\" id=\"wt_destination\" placeholder=\"Insert watermark destination\"></div><div class=\"form-group\"><label>Watermark Opacity</label> <input id=\"wt_opacity\" class=\"form-control\" type=\"number\" min=\"0\" max=\"1\" step=\"any\" placeholder=\"Opacity number\" value=\"\"></div><div class=\"form-group\"><label>Watermark Position</label><select id=\"wt_pos\"><option value=\"top_left\">top left</option><option value=\"top_right\">top right</option><option value=\"center\">center</option><option value=\"bottom_left\">bottom left</option><option value=\"bottom_right\">bottom right</option></select></div><div class=\"form-group\"><label>Watermark height</label> <input id=\"wt_height\" class=\"form-control\" type=\"number\" min=\"0\" max=\"200\" placeholder=\"watermark height\" value=\"\"></div></form></div><button id=\"sharing-panel\" class=\"accordion\">Sharing</button><div class=\"panel\"><div class=\"row\"><div class=\"col-lg-4\"><div class=\"form-group\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"sharing_facebook\" value=\"\"> <span>Facebook</span></label></div></div><div class=\"col-lg-4\"><div class=\"form-group\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"sharing_gplus\" value=\"\"> <span>Google Plus</span></label><br><span style=\"background: yellow\">Deprecated on v3</span></div></div><div class=\"col-lg-4\"><div class=\"form-group\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"sharing_embedded\" value=\"\"> <span>Embedded code</span></label><br><span style=\"background: yellow\">Deprecated on v3</span></div></div></div><div class=\"row\"><div class=\"col-lg-2\"><div class=\"form-group\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"sharing_twitter\" value=\"\" ng-click=\"vm.changeTWcustomText()\"> <span>Twitter</span></label></div></div><div class=\"col-lg-10\"><input type=\"text\" class=\"form-control tw-related\" id=\"twitter_text_input\" placeholder=\"Custom Text For twitter (Optional)\" style=\"display: none;\"></div></div><div class=\"row tw-related\" style=\"display: none;\"><div class=\"col-lg-12\"><div class=\"twitter-alert alert alert-warning\"><br><strong>Attention!</strong> If twitter custom text is empty, you only will see the content name but if you add a custom text you will see it before the name for example: { here customText } { video name } (Hey look this video \"Highlander in the paradise\").</div></div></div></div></uib-tab><uib-tab heading=\"CDNS\"><button class=\"accordion\">CDNS</button><div class=\"panel\" style=\"display: block; padding: 10px; max-height: 290px;\"><form><div class=\"form-group\"><label>Peer5 ID</label> <input type=\"text\" class=\"form-control\" readonly=\"\" id=\"peer_five_id\" placeholder=\"Insert ID for peer5\"></div></form></div></uib-tab><uib-tab heading=\"Advertising\"><button class=\"accordion\">Advertising Settings</button><div class=\"panel\" style=\"display: block; padding: 10px; max-height: 100%;\"><form><div class=\"form-group\"><label for=\"input03\">Tag URL (<a href=\"https://developers.google.com/interactive-media-ads/docs/sdks/html5/vastinspector\" target=\"_blank\">Video Suite Inspector</a>)</label> <input type=\"text\" class=\"form-control\" id=\"add-tag-url\" placeholder=\"Insert ads vast server url\"></div><div class=\"form-group\"><label for=\"input03\">Timestamp key (optional)</label> <input type=\"text\" class=\"form-control\" id=\"vast-ts-key\" placeholder=\"Insert key for timestamp (Example: correlator)\"></div><div class=\"form-group\"><label for=\"input03\">Skip Ads (optional)</label> <input type=\"text\" class=\"form-control\" id=\"vast-skip\" placeholder=\"Insert time in seconds to skip ads (Example: 5)\"></div><div class=\"form-group\"><label for=\"input03\">Skip Countdown (optional)</label> <input type=\"text\" class=\"form-control\" id=\"countdown_ads\" placeholder=\"Insert Custom text for skip countdown button\"></div><div class=\"form-group\"><label for=\"input03\">Skip Ads Button Custom Text (optional)</label> <input type=\"text\" class=\"form-control\" id=\"vast-custom-text\" placeholder=\"Insert Custom text for skipAd button\"></div></form></div></uib-tab><uib-tab heading=\"Analytics\"><button class=\"accordion\">Analytics Settings</button><div class=\"panel\" style=\"display: block; padding: 10px; max-height: 100%;\"><form><div class=\"col-lg-6\"><div class=\"form-group\"><label for=\"input03\">Google Analytics Tag</label> <input type=\"text\" class=\"form-control\" id=\"ga\" ng-model=\"vm.ga_id\" ng-change=\"vm.changeGA()\" placeholder=\"Insert Google Analytics Tag\"></div></div><div class=\"col-lg-6\"><div class=\"form-group\"><label for=\"input03\">Google Analytics hostname</label> <input type=\"text\" class=\"form-control\" id=\"ga_hostname\" placeholder=\"Optional\"></div></div><div class=\"col-lg-12 form-group gaEvents\"><label for=\"input03\">Google Analytics events</label><div class=\"row\"><div class=\"col-lg-3\"><input type=\"checkbox\" id=\"ga_play\" name=\"play\" class=\"ga_events\"> Plays</div><div class=\"col-lg-3\"><input type=\"checkbox\" id=\"ga_loaded\" name=\"loaded\" class=\"ga_events\"> Loaded</div><div class=\"col-lg-3\"><input type=\"checkbox\" id=\"ga_percentsPlayed\" name=\"percentsPlayed\" class=\"ga_events\"> PercentsPlayed</div><div class=\"col-lg-3\"><input type=\"checkbox\" id=\"ga_start\" name=\"start\" class=\"ga_events\"> Start</div></div><div class=\"row\"><div class=\"col-lg-3\"><input type=\"checkbox\" id=\"ga_end\" name=\"end\" class=\"ga_events\"> End</div><div class=\"col-lg-3\"><input type=\"checkbox\" id=\"ga_seek\" name=\"seek\" class=\"ga_events\"> Seek</div><div class=\"col-lg-3\"><input type=\"checkbox\" id=\"ga_pause\" name=\"pause\" class=\"ga_events\"> Pause</div><div class=\"col-lg-3\"><input type=\"checkbox\" id=\"ga_resize\" name=\"resize\" class=\"ga_events\"> Resize</div></div><div class=\"row\"><div class=\"col-lg-3\"><input type=\"checkbox\" id=\"ga_volumeChange\" name=\"volumeChange\" class=\"ga_events\"> VolumeChange</div><div class=\"col-lg-3\"><input type=\"checkbox\" id=\"ga_error\" name=\"error\" class=\"ga_events\"> Error</div><div class=\"col-lg-3\"><input type=\"checkbox\" id=\"ga_fullscreen\" name=\"fullscreen\" class=\"ga_events\"> Fullscreen</div></div></div><div class=\"col-lg-12 form-group\"><label for=\"input03\">Comscore Site</label> <input type=\"text\" class=\"form-control\" id=\"comscore\" placeholder=\"Insert Comscore site..\"></div><div class=\"col-lg-12 form-group\"><label for=\"input03\">Comscore default C3 (unless it is configured in the content)</label> <input type=\"text\" class=\"form-control\" id=\"comscore_c3\" placeholder=\"Insert C3 label value\"></div><div class=\"col-lg-12 form-group\"><label for=\"input03\">Cxense <span style=\"background: yellow\">Deprecated on v3</span></label> <input type=\"text\" class=\"form-control\" id=\"cxense\" placeholder=\"Insert Cxense id..\"></div></form></div></uib-tab><uib-tab heading=\"Relation\"><button class=\"accordion\">Relation</button><div class=\"panel\" style=\"display: block; padding: 10px; max-height: 204px;\"><form><div class=\"col-lg-6\"><div class=\"form-group\"><label for=\"input03\">Related Delay</label> <input type=\"number\" min=\"0\" max=\"8000\" class=\"form-control\" id=\"related_delay\" placeholder=\"Delay for related autoplay\"></div></div><div class=\"col-lg-6\"><div class=\"form-group\" style=\"position: absolute;top: 25px\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"autoplay_relation\" value=\"\"> <span>Autoplay Relation</span></label></div></div></form></div></uib-tab></uib-tabset><div ng-if=\"vm.type == \'create\'\" class=\"row\"><div class=\"pull-right preview-btn\"><button class=\"action btn btn-primary\" ng-click=\"vm.NewPlayer(\'preview\')\">Preview</button></div></div><div ng-if=\"vm.type == \'edit\'\" class=\"row\"><div class=\"pull-right preview-btn\"><button class=\"action btn btn-primary\" ng-click=\"vm.NewEdit(\'preview\')\">Preview</button></div></div></div><div class=\"col-lg-7 text-center\"><div class=\"row\"><center><div id=\"player-box\"><div id=\"custom_player\"></div></div></center></div></div><div ng-if=\"vm.type == \'create\'\" class=\"botonera pull-right\"><button ui-sref=\"player-list\" class=\"action btn btn-danger btn-action\">Cancel</button> <button class=\"action btn btn-primary btn-action\" ng-click=\"vm.NewPlayer(\'create\')\">Save</button></div><div ng-if=\"vm.type == \'edit\'\" class=\"botonera pull-right\"><button ui-sref=\"player-list\" class=\"action btn btn-danger btn-action\">Cancel</button> <button class=\"action btn btn-primary btn-action\" ng-click=\"vm.NewEdit(\'edit\')\">Save</button></div></div></div></div>");
$templateCache.put("app/pages/playlists/playlistModify.html","<style type=\"text/css\">\n	.rule-item{\n		border: 1px solid #F0F3F4;\n	}\n	.drop-order{\n		position: relative;\n		top: 18px;\n	}\n	.control-label{\n		top: 16px;\n	}\n	.chosen-container {\n	    top: 9px;\n	    padding-right: 10px;\n	}\n	.quantity{\n    	position: relative;\n    	top: 6px;\n	}\n	.rule_choosen{\n    	position: relative;\n    	top: 7px;\n	}\n	#action-btn{\n		position: relative;\n		top: 7px;\n	}\n	#botonera{\n		margin-top: 60px;\n	}\n	li{\n		list-style: none;\n\n	}\n	.alert{\n		padding: 5px;\n	}\n	.alert.bg-danger {\n	    position: absolute;\n	    right: 18px;\n	    top: 3px;\n	}\n</style><div ng-controller=\"PlaylistModifyCtrl as vm\"><div class=\"col-lg-12\"><div ba-panel=\"\" ba-panel-class=\"playlist-page\"><div class=\"panel-content\"><h3 class=\"with-line\">Playlist Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">* Name</label><div class=\"col-sm-9\"><div id=\"name-msg\" class=\"alert bg-danger\" style=\"display: none\">Please insert a name to continue...</div><input type=\"text\" class=\"form-control\" id=\"playlist_name\" placeholder=\"Playlist name...\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Description</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"playlist_description\" placeholder=\"Playlist description...\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\"><span class=\"required\">*</span> Publishers</label><div class=\"col-sm-7\"><select id=\"publishers_select\" ng-model=\"vm.publisher_selected\" ng-change=\"vm.hidePublisherError()\" style=\"margin-top: 13px;\"><option value=\"\">Select a publisher</option><option ng-repeat=\"pub in vm.publishers\" value=\"{{pub.id}}\">{{pub.value}}</option></select><span id=\"no_publisher_message\" class=\"help-block sub-little-text\" style=\"color:red; display:none\">please select a publisher</span></div></div></div></div></div><div class=\"panel-content\"><h3 class=\"with-line\">Rules</h3><a ng-if=\"vm.rule_items.length == 0\" ng-click=\"vm.addRow(0)\" class=\"add-no-content\"><button class=\"btn btn-primary\">Add rules <i class=\"fa fa-plus\" aria-hidden=\"true\" style=\"color: white; font-size: 16px\"></i></button></a><ul ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.rule_items\" ng-if=\"vm.rule_items.length > 0\"><li id=\"rule-{{$index}}\" class=\"rule-item row\" ng-repeat=\"rule in vm.rule_items | orderBy:\'position\' track by $index\"><div class=\"col-md-1 text-center\"><a class=\"drop-order\"><i class=\"fa fa-ellipsis-v\" aria-hidden=\"true\" style=\"color: grey; font-size: 16px\"></i></a></div><div class=\"col-md-3\"><div class=\"form-group row clearfix\"><select id=\"categories-$index\" data-placeholder=\"Choose a category...\" multiple=\"\" width=\"100%\" class=\"categories categories-{{$index}} form-control chosen-select\"></select></div></div><div class=\"col-md-3\"><div class=\"form-group row clearfix\"><select id=\"tags-$index\" data-placeholder=\"Choose tags...\" multiple=\"\" width=\"100%\" class=\"form-control tags tags-{{$index}} chosen-select\"></select></div></div><div class=\"col-md-2\"><div class=\"form-group row clearfix\"><div class=\"col-sm-9\"><select class=\"rule_choosen ruleSelect-{{$index}}\"><option selected=\"\" value=\"most_recent\">Most Recent</option><option value=\"most_played\">Most Played</option></select></div></div></div><div class=\"col-md-1\"><div class=\"form-group row clearfix\"><div class=\"col-sm-12\"><input type=\"text\" class=\"form-control quantity quantity-{{$index}}\" name=\"quantity\" placeholder=\"limit\" value=\"\"></div></div></div><div id=\"action-btn\" class=\"col-md-2 text-center\"><a class=\"remove\" ng-click=\"vm.removeItem($index)\"><button class=\"btn btn-danger\"><i class=\"fa fa-trash-o\" aria-hidden=\"true\" style=\"color: white; font-size: 16px\"></i></button></a> <a ng-if=\"$index == (vm.rule_items.length - 1)\" ng-click=\"vm.addRow($index + 1)\" class=\"add\"><button class=\"btn btn-primary\"><i class=\"fa fa-plus\" aria-hidden=\"true\" style=\"color: white; font-size: 16px\"></i></button></a></div></li></ul><div class=\"row pull-right\"><div id=\"botonera\" class=\"col-lg-12\"><div class=\"col-md-6\"><button ui-sref=\"playlists\" type=\"button\" id=\"cancel\" class=\"btn btn-danger pull-right\">Cancel</button></div><div class=\"col-md-5\"><div ng-if=\"!vm.edit\"><button type=\"button\" id=\"save\" ng-click=\"vm.validate(0)\" class=\"btn btn-primary pull-right\">Save</button></div><div ng-if=\"vm.edit\"><button type=\"button\" id=\"save\" ng-click=\"vm.validate(1)\" class=\"btn btn-primary pull-right\">Save</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/playlists/playlists.html","<style type=\"text/css\">\n  .table_footer{\n    margin-top: 25px;\n    position: relative;\n    right: -16px;\n    top: 30px;\n    padding-bottom: 10px; \n  }\n  #loading{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #selectPartnerText{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #paginator{\n    position: relative;\n    right: 52px;\n    top:0px;\n  }\n  .inner-addon { \n    position: relative; \n  }\n\n  /* style icon */\n  .inner-addon .glyphicon {\n    position: absolute;\n    padding: 10px;\n    pointer-events: none;\n  }\n\n  /* align icon */\n  .left-addon .glyphicon  { left:  0px;}\n  .right-addon .glyphicon { right: 0px;}\n\n  /* add padding  */\n  .left-addon input  { padding-left:  30px; }\n  .right-addon input { padding-right: 30px; }\n  .table-header{padding-bottom: 15px;}\n  .player_button{\n    padding-right: 30px;\n  }\n  .fa{\n    color: grey;\n    cursor: pointer;\n  }\n  tr{\n    padding: 5px;\n  }\n  .action-icon{\n    padding-right: 5px;\n    padding-left: 5px;\n  }\n  .select_action{\n    padding-top: 5px;\n  }\n  .table{\n    background: white;\n  }\n  #no-content{\n    margin: 70px auto;\n    background: white;\n    width: 100%;\n    border: 1px solid grey;\n    padding: 100px;\n  }\n  .json-sidebar{\n    background: white none repeat scroll 0 0;\n      border: 1px solid grey;\n      height: 100%;\n      position: fixed;\n      right: 0px;\n      top: 70px;\n      width: 80%;\n      z-index: 999999999;\n      display: none;\n  }\n  .close-icon{\n    color: grey;\n  }\n  .json-title{\n    color: black;\n    font-size: 16px;\n    position: absolute;\n    font-family: \"helvetica\";\n    padding: 5px;\n  }\n  .json-content{\n    position: relative;\n    overflow-y:auto;\n    overflow-x:auto;\n    height: 85%;\n    margin-top: 60px;\n    padding: 5px;\n    color: red;\n  }\n  .json-request{\n    position: absolute;\n    font-family: \"helvetica\";\n    padding: 5px;\n    margin-top: 35px;\n  }\n</style><div ng-controller=\"PlaylistsCtrl as vm\"><div class=\"row table-header playlist_btn\"><div class=\"col-lg-2 pull-right\"><div class=\"form-group\"><button ng-if=\"vm.permissions.create\" ui-sref=\"newPlaylist\" class=\"btn btn-primary\" id=\"new_playlist\" name=\"new_playlist\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Create new playlist\">Create Playlist</button></div></div></div><div><div class=\"row col-lg-12\" style=\"height: 700px;overflow-y:auto;overflow-x:none;\"><div class=\"horizontal-scroll custom-table\"><table class=\"table table-bordered\" ng-if=\"vm.playlists.length != 0\"><thead><tr><th class=\"table-id text-center\">#id</th><th class=\"text-center\">Name</th><th class=\"text-center\">Publisher</th><th class=\"text-center\">Creation Date</th><th class=\"text-center\">Actions</th></tr></thead><tbody><div ng-if=\"vm.loading\" id=\"loading\" class=\"text-center\"><h2>Loading, please wait...</h2><br><img height=\"60px\" src=\"assets/img/app/loading.gif\"></div><div id=\"no-content\" ng-if=\"((vm.playlists.length == 0) && !vm.loading)\" class=\"text-center\"><h1>No playlists found.</h1></div><tr ng-repeat=\"playlist in vm.playlists\"><td class=\"text-center\"><strong>{{playlist.id}}</strong></td><td class=\"text-center\"><strong>{{playlist.name}}</strong></td><td class=\"text-center\"><strong>{{playlist.publisher}}</strong></td><td class=\"text-center\"><strong>{{playlist.created_at}}</strong></td><td class=\"text-center\"><div class=\"select_action\"><a ng-if=\"vm.permissions.edit && playlist.edit\" ui-sref=\"editPlaylist({\'id\': playlist.id})\" class=\"edit action-icon\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Edit playlist\"><i class=\"fa fa-2x fa-pencil\" aria-hidden=\"true\"></i></a> <span ng-if=\"!vm.permissions.edit || !playlist.edit\" style=\"margin-right: 36px\"></span> <a ng-if=\"vm.permissions.delete\" ng-click=\"vm.deletePlaylist(playlist.id)\" class=\"delete action-icon\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Delete Playlist\"><i class=\"fa fa-2x fa-trash-o\" aria-hidden=\"true\"></i></a> <a class=\"btn-json\"><span ng-click=\"vm.showJson(playlist.id)\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Show Items\"><i class=\"fa fa-2x fa fa-code\" aria-hidden=\"true\"></i></span></a></div></td></tr></tbody></table></div></div></div><div class=\"json-sidebar\"><div class=\"json-header\"><div class=\"json-title\"><strong>Playlist JSON</strong></div><div class=\"json-request\"></div><div class=\"close\" ng-click=\"vm.hideJson()\"><i class=\"close-icon fa fa-times\" aria-hidden=\"true\"></i></div></div><pre class=\"json-content\"></pre></div></div>");
$templateCache.put("app/pages/profile/profile.html","<div ng-controller=\"ProfilePageCtrl as vm\"><div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">First Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"\" value=\"{{vm.user_conf.name}}\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputLastName\" class=\"col-sm-3 control-label\">Last Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputLastName\" placeholder=\"\" value=\"{{vm.user_conf.last_name}}\"></div></div></div></div><h3 class=\"with-line\">Change Password</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\">Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputPassword\" ng-model=\"vm.pass1\" placeholder=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputConfirmPassword\" class=\"col-sm-3 control-label\">Confirm Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputConfirmPassword\" ng-model=\"vm.pass2\" placeholder=\"\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><p>* Your password must have at least one number</p><p>* Your password must have at least one capital letter</p><p>* Your password lenght must be 8 characters (numbers and letters only)</p></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputEmail3\" class=\"col-sm-3 control-label\" disabled=\"\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" id=\"inputEmail3\" ng-disabled=\"true\" placeholder=\"\" value=\"{{vm.user_conf.email}}\"></div></div></div></div><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile pull-right\" ng-click=\"vm.saveData()\"><i class=\"ion-android-checkmark-circle\"></i>Save Changes</button></div></div></div>");
$templateCache.put("app/pages/realtime/realtime.html","<section ng-controller=\"RealtimeCtrl as vm\"><div class=\"row\"><div id=\"realtime-filters\" class=\"col-lg-12\"><label>Choose a Publisher:</label><select id=\"select-publisher\" ng-model=\"vm.selected_publishers\" ng-change=\"vm.refreshPublisher()\" ng-options=\"pub.id as pub.name for pub in vm.publishers\"></select></div></div><div class=\"row\"><div id=\"realtime-container\" class=\"col-lg-12 pull-center\"><iframe id=\"rt-Iframe\" ng-src=\"{{vm.source}}\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></div></section><style type=\"text/css\">\n	#realtime-filters {\n		margin-top: 30px;\n	}\n	#select-publisher {\n		outline: none;\n	}\n	#rt-Iframe {\n		position: absolute;\n    	width: 100%;\n    	height: 800px;\n    	overflow-y: auto;\n	}\n	.content-top {\n		display: none;\n	}\n	#comingsoon {\n		position: fixed;\n		width: 200px;\n		margin: 101px 21%;\n	}\n</style>");
$templateCache.put("app/pages/scheduler/scheduler.html","<style type=\"text/css\">\n  	.btn-scheduler{\n  		position: relative;\n		right: 39px;\n	}\n	.frame{\n		padding: 20px;\n	}\n</style><div ng-controller=\"SchedulerCtrl as vm\"><div class=\"row\"><div class=\"frame col-lg-12\"><div ba-panel=\"\" ba-panel-title=\"Schedulers\" ba-panel-class=\"xmedium-panel feed-comply-panel with-scroll calendar-panel\"><dashboard-calendar></dashboard-calendar></div></div></div></div>");
$templateCache.put("app/pages/scheduler/schedulerModal.html","<style type=\"text/css\">\n    .repeat-row{\n      padding-left: 20px;\n    }\n    .repeat{\n      margin-left: 4px !important;\n      position: relative;\n    }\n</style><div ng-controller=\"SchedulerModalCtrl as vm\" class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h2 class=\"modal-title\" id=\"modal-title\">Scheduler</h2></div><div class=\"modal-body\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Event Type</label><div class=\"col-sm-9\"><select id=\"schedulerType\"><option>Facebook Live</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"scheduleName\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Publisher</label><div class=\"col-sm-9\"><select id=\"schedulePublisher\"><option>TN</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Channel</label><div class=\"col-sm-9\"><select id=\"schedulePublisher\"><option>channel1</option></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Start</label><div class=\"col-sm-3\"><input id=\"scheduleDateRangeStart\" date-range-picker=\"\" class=\"form-control date-picker\" type=\"text\" name=\"start\" ng-model=\"vm.date.start\" options=\"vm.opts\"></div><div class=\"col-sm-3\"><div class=\"input-group bootstrap-timepicker timepicker\"><input id=\"startPicker\" type=\"text\" class=\"timepickerElement form-control input-small\"> <span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-time\"></i></span></div></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">End</label><div class=\"col-sm-3\"><input id=\"scheduleDateRangeEnd\" date-range-picker=\"\" class=\"form-control date-picker\" type=\"text\" name=\"end\" ng-model=\"vm.date.end\" options=\"vm.opts\" format=\"DD/MM/YYYY\"></div><div class=\"col-sm-3\"><div class=\"input-group bootstrap-timepicker timepicker\"><input id=\"endPicker\" type=\"text\" class=\"timepickerElement form-control input-small\"> <span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-time\"></i></span></div></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Repeat At</label><div class=\"col-sm-9\">Lun Mar Mie Jue Vie Sab Dom<div class=\"repeat-row row\"><input id=\"lun\" class=\"repeat\" value=\"lun\" type=\"checkbox\"> <input id=\"mar\" class=\"repeat\" value=\"mar\" type=\"checkbox\"> <input id=\"mie\" class=\"repeat\" value=\"mie\" type=\"checkbox\"> <input id=\"jue\" class=\"repeat\" value=\"jue\" type=\"checkbox\"> <input id=\"vie\" class=\"repeat\" value=\"vie\" type=\"checkbox\"> <input id=\"sab\" class=\"repeat\" value=\"sab\" type=\"checkbox\"> <input id=\"dom\" class=\"repeat\" value=\"dom\" type=\"checkbox\"></div></div></div></div></div></div></div><div class=\"modal-footer\"><button id=\"close-modal\" type=\"button\" class=\"btn btn-danger\" ng-disabled=\"loading\" ng-click=\"$dismiss()\">Cancel</button> <span ng-controller=\"DashboardCalendarCtrl\"><button id=\"scheduleBtn\" class=\"btn btn-primary\" ng-click=\"addEvent();\">Save</button></span></div></div>");
$templateCache.put("app/pages/administration/credentials/credentials.html","<style type=\"text/css\">\n  .mr{\n      display: inline-block;\n      margin-bottom: 0;\n      font-weight: 400;\n      text-align: center;\n      touch-action: manipulation;\n      cursor: pointer;\n      border: 1px solid transparent;\n      white-space: nowrap;\n      padding: 8px 24px;\n      font-size: 13px;\n      line-height: 1.52857143;\n      border-radius: 3px;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n  }\n</style><div ng-controller=\"CredentialsCtrl as vm\"><div ng-if=\"vm.credentials.length > 0\" class=\"col-lg-12\"><div class=\"table-responsive\"><table class=\"table\"><thead><tr><th>Client ID</th><th>Secret ID</th></tr></thead><tbody><tr ng-repeat=\"credential in vm.credentials\"><td>{{credential.client_id}}</td><td>{{credential.secret_id}}</td></tr></tbody></table></div></div><div ba-panel=\"\" ng-if=\"vm.credentials.length == 0\" class=\"col-lg-12\"><div id=\"noContent\"><div id=\"noContent\" class=\"text-center\"><h2>Generate Credential</h2><button type=\"button\" ripple=\"\" class=\"mr mb-sm btn btn-default\" ng-click=\"vm.generateCredential()\">Generate<span class=\"ripple\"><span class=\"angular-ripple\" style=\"width: 89px; height: 89px; left: 0.015625px; top: -23.5px;\"></span></span></button></div></div></div></div>");
$templateCache.put("app/pages/administration/profiles/profileGroup.html","<style type=\"text/css\">\n  .title-right{\n    padding-left: 21%;\n  }\n</style><div ng-controller=\"ProfileGroupCtrl as vm\"><div ng-if=\"!vm.treeCatStatus\" ba-panel=\"\" ba-panel-class=\"group-page\"><div class=\"panel-content\"><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">Profile Group Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"\" value=\"{{(vm.action == \'group-edit\')? vm.group.name : \'\'}}\" ng-disabled=\"vm.action == \'group-edit\'\"></div></div></div></div><div class=\"row\"><div class=\"form-group clearfix\"><label class=\"col-sm-3 control-label\">Categories</label></div><div class=\"col-md-12\"><div ba-panel-class=\"with-scroll tree-panel\" style=\"max-height: 400px; overflow-y: auto\"><div id=\"tree_categories\" data-tree-id=\"tree_categories\"></div></div></div></div><div class=\"row\" ng-if=\"vm.action == \'group-create\'\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Select Publisher/s</label><div class=\"col-sm-9\"><div class=\"form-group\"><select class=\"form-control publisher-selector\" title=\"Select Publishers for this group\" multiple=\"\" selectpicker=\"\" ng-model=\"vm.publisherSelected\" ng-options=\"publisher as publisher.label for publisher in vm.publisher\"></select></div></div></div></div></div><h3 class=\"with-line\">Permissions</h3><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">Dashboard & Realtime</label><div class=\"col-xs-4\"><switch color=\"primary\" id=\"dashboard\" ng-model=\"vm.group.dashboard\"></switch></div></div></div><div class=\"col-md-3\"><div class=\"form-group row clearfix\"><label class=\"col-xs-2\">Download</label><div class=\"col-xs-4\"><switch color=\"primary\" id=\"content_download\" ng-model=\"vm.group.content_download\"></switch></div></div></div></div><h3 class=\"with-line\">Categories <span class=\"title-right\">Player</span><span class=\"title-right\">Playlist</span></h3><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group row clearfix\"><label class=\"col-xs-2\">Create</label><div class=\"col-xs-4\"><switch color=\"primary\" id=\"cat_create\" ng-model=\"vm.group.cat.create\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-2\">Delete</label><div class=\"col-xs-4\"><switch color=\"primary\" id=\"cat_delete\" ng-model=\"vm.group.cat.delete\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-2\">Edit</label><div class=\"col-xs-4\"><switch color=\"primary\" id=\"cat_edit\" ng-model=\"vm.group.cat.edit\"></switch></div></div></div><div class=\"col-md-3\"><div class=\"form-group row clearfix\"><label class=\"col-xs-2\">Create</label><div class=\"col-xs-4\"><switch color=\"primary\" id=\"player_create\" ng-model=\"vm.group.player.create\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-2\">Delete</label><div class=\"col-xs-4\"><switch color=\"primary\" id=\"player_delete\" ng-model=\"vm.group.player.delete\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-2\">Edit</label><div class=\"col-xs-4\"><switch color=\"primary\" id=\"player_edit\" ng-model=\"vm.group.player.edit\"></switch></div></div></div><div class=\"col-md-3\"><div class=\"form-group row clearfix\"><label class=\"col-xs-2\">Create</label><div class=\"col-xs-4\"><switch color=\"primary\" id=\"playlist_create\" ng-model=\"vm.group.playlist.create\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-2\">Delete</label><div class=\"col-xs-4\"><switch color=\"primary\" id=\"playlist_delete\" ng-model=\"vm.group.playlist.delete\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-2\">Edit</label><div class=\"col-xs-4\"><switch color=\"primary\" id=\"playlist_edit\" ng-model=\"vm.group.playlist.edit\"></switch></div></div></div></div><div class=\"row col-md-offset-5\"><div class=\"col-lg-2 pull-right\"><button type=\"button\" ng-click=\"vm.saveProfile()\" class=\"btn btn-primary btn-with-icon save-changes\"><i class=\"ion-android-checkmark-circle\"></i><span ng-bind=\"vm.btn_action\"></span></button></div></div></div></div></div>");
$templateCache.put("app/pages/administration/profiles/profile_groups_list.html","<style type=\"text/css\">\n  .table_footer{\n    margin-top: 25px;\n    position: relative;\n    right: -16px;\n    top: 30px;\n    padding-bottom: 10px; \n  }\n  #loading{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #selectPartnerText{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #paginator{\n    position: relative;\n    right: 52px;\n    top:0px;\n  }\n  .inner-addon { \n    position: relative; \n  }\n\n  /* style icon */\n  .inner-addon .glyphicon {\n    position: absolute;\n    padding: 10px;\n    pointer-events: none;\n  }\n\n  /* align icon */\n  .left-addon .glyphicon  { left:  0px;}\n  .right-addon .glyphicon { right: 0px;}\n\n  /* add padding  */\n  .left-addon input  { padding-left:  30px; }\n  .right-addon input { padding-right: 30px; }\n  .table-header{padding-bottom: 15px;}\n  .fa{\n    color: grey;\n    cursor: pointer;\n  }\n  .table{\n    background: white;\n  }\n</style><div ng-controller=\"ProfileGroupsListCtrl as vm\"><div class=\"row table-header\" ng-show=\"!vm.loading\"><div class=\"col-lg-2\"></div><div class=\"col-lg-2 pull-right\"><button type=\"button\" ui-sref=\"profiles-create\" class=\"btn btn-primary btn-with-icon\">Create Profile Group</button></div></div><div class=\"row col-lg-12\" style=\"height: 700px;overflow-y:auto;overflow-x:none;\"><div class=\"horizontal-scroll custom-table\"><table class=\"table table-bordered\" style=\"overflow: hidden;\"><thead><tr><th class=\"table-id\">#</th><th>Name</th><th>Actions</th></tr></thead><tbody><div ng-if=\"vm.loading\" ng-change=\"vm.loading\" ng-model=\"vm.loading\" id=\"loading\" class=\"text-center\"><h2>Loading, please wait...</h2><br><img height=\"60px\" src=\"assets/img/app/loading.gif\"></div><tr ng-if=\"!vm.loading\" ng-repeat=\"group in vm.groups\"><td class=\"table-id\">{{group.id}}</td><td>{{group.name}}</td><td><span ng-if=\"group.name != \'admin\' && group.name != \'content uploader\' && group.name != \'editor\'\"><a type=\"button\" ui-sref=\"profiles-edit({group: {id: group.id, name: group.name}})\" class=\"btn\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Edit Profile\"><i class=\"fa fa-pencil\"></i></a> <a type=\"button\" ng-click=\"vm.removeProfile(group.id)\" class=\"btn\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Delete Profile\"><i class=\"fa fa-trash-o\"></i></a></span> <span ng-if=\"group.name == \'admin\' || group.name == \'content uploader\' || group.name == \'editor\'\"><a ng-click=\"vm.lockedError()\" type=\"button\" class=\"btn\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"This group cannot be edited\"><i class=\"fa fa-lock\"></i></a></span></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/pages/administration/publishers/abm_publishers_list.html","<style type=\"text/css\">\n  *:focus {\n    outline: none;\n  }\n  .table_footer{\n    margin-top: 25px;\n    position: relative;\n    right: -16px;\n    top: 30px;\n    padding-bottom: 10px; \n  }\n  #loading{\n    left: auto;\n    position: absolute;\n    right: 47%;\n    top: 80%;\n  }\n  #selectPartnerText{\n    left: auto;\n    position: absolute;\n    right: 45%;\n    top: 97px;\n  }\n  #paginator{\n    position: relative;\n    right: 52px;\n    top:0px;\n  }\n  .inner-addon { \n    position: relative; \n  }\n\n  /* style icon */\n  .inner-addon .glyphicon {\n    position: absolute;\n    padding: 10px;\n    pointer-events: none;\n  }\n\n  /* align icon */\n  .left-addon .glyphicon  { left:  0px;}\n  .right-addon .glyphicon { right: 0px;}\n\n  /* add padding  */\n  .left-addon input  { padding-left:  30px; }\n  .right-addon input { padding-right: 30px; }\n  .table-header{padding-bottom: 15px;}\n  .fa{\n    color: grey;\n    cursor: pointer;\n  }\n  .table{\n    background: white;\n  }\n  mark{\n    background-color: yellow;\n  }\n  #noContent{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  .add-row-editable-table {\n    float: right;\n    padding-right: 48px;\n  }\n  .une {\n    border: 1px solid #e5e5e5;\n    border-radius: 5px;\n    height: 32px;\n    padding: 8px;\n    width: 100%;\n  }\n  .trxe {\n    border: 1px solid #e5e5e5;\n    border-radius: 5px;\n    height: 32px;\n    padding: 8px;\n    width: 100%;\n  }\n  .action{\n    padding-left: 10px;\n  }\n</style><div ng-controller=\"ABMPublishersListCtrl as vm\"><div class=\"row col-lg-12\"><div ng-if=\"vm.loading\" ng-change=\"vm.loading\" ng-model=\"vm.loading\" id=\"loading\" class=\"text-center\"><img height=\"60px\" src=\"assets/img/app/loading.gif\"></div><table class=\"table table-bordered table-hover table-condensed\"><tr><td>Publisher ID</td><td>Publisher</td><td>UNE (Upload Notification Endpoint)</td><td>TRX-E (Transcoder Endpoint)</td></tr><tr ng-repeat=\"publisher in vm.publishers\"><td><span>{{publisher.id}}</span></td><td><span>{{publisher.value}}</span></td><td><input class=\"une\" id=\"une-{{publisher.id}}\" type=\"text\" name=\"une\" placeholder=\"Upload Endpoint Notification URL...\" value=\"{{publisher.une}}\"></td><td><input class=\"trxe\" id=\"trxe-{{publisher.id}}\" type=\"text\" name=\"trxe\" placeholder=\"Transcoder Endpoint...\" value=\"{{publisher.trxe}}\"></td></tr></table><br></div><div class=\"row pull-right\" ng-show=\"!loading\"><div class=\"add-row-editable-table\"><md-button id=\"saveChanges\" class=\"md-raised md-primary\" ng-click=\"vm.saveChanges()\">Apply</md-button></div></div></div>");
$templateCache.put("app/pages/administration/publishers/publishers_list.html","<style type=\"text/css\">\n  .table_footer{\n    margin-top: 25px;\n    position: relative;\n    right: -16px;\n    top: 30px;\n    padding-bottom: 10px; \n  }\n  #loading{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #selectPartnerText{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #paginator{\n    position: relative;\n    right: 52px;\n    top:0px;\n  }\n  .inner-addon { \n    position: relative; \n  }\n\n  /* style icon */\n  .inner-addon .glyphicon {\n    position: absolute;\n    padding: 10px;\n    pointer-events: none;\n  }\n\n  /* align icon */\n  .left-addon .glyphicon  { left:  0px;}\n  .right-addon .glyphicon { right: 0px;}\n\n  /* add padding  */\n  .left-addon input  { padding-left:  30px; }\n  .right-addon input { padding-right: 30px; }\n  .table-header{padding-bottom: 15px;}\n  .fa{\n    color: grey;\n    cursor: pointer;\n  }\n  .table{\n    background: white;\n  }\n  mark{\n    background-color: yellow;\n  }\n  #noContent{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  .add-row-editable-table {\n    float: right;\n    padding-right: 48px;\n  }\n</style><div ng-controller=\"PublishersListCtrl as vm\"><div class=\"row table-header\" ng-show=\"!loading\"><div class=\"add-row-editable-table\"><button class=\"btn btn-primary\" ng-click=\"vm.addPublisher()\">Add Row</button> <button class=\"btn btn-primary\" ng-click=\"vm.saveRows()\">Save Changes</button></div></div><div class=\"row col-lg-12\" style=\"height: 700px;overflow-y:auto;overflow-x:none;\"><div ng-if=\"vm.loading\" ng-change=\"vm.loading\" ng-model=\"vm.loading\" id=\"loading\" class=\"text-center\"><h2>Loading, please wait...</h2><br><img height=\"60px\" src=\"assets/img/app/loading.gif\"></div><table class=\"table table-bordered table-hover table-condensed\"><tr><td>Group ID</td><td>Group</td><td>Publisher ID</td><td>Publisher</td><td>Actions</td></tr><tr ng-repeat=\"publisher in vm.publishers\" class=\"editable-row\"><td><span>{{ publisher.group_id || \'empty\' }}</span></td><td><span editable-text=\"publisher.group\" e-name=\"group\" e-form=\"rowform\" e-required=\"\">{{ publisher.group || \'empty\' }}</span></td><td><span>{{ publisher.id || \'empty\' }}</span></td><td><span editable-text=\"publisher.value\" e-name=\"value\" e-form=\"rowform\" e-required=\"\">{{ publisher.value || \'empty\' }}</span></td><td><form editable-form=\"\" name=\"rowform\" ng-show=\"rowform.$visible\" class=\"form-buttons form-inline\" shown=\"inserted == publisher\"><button type=\"submit\" ng-disabled=\"rowform.$waiting\" class=\"btn btn-primary editable-table-button btn-xs\">Save</button> <button type=\"button\" ng-disabled=\"rowform.$waiting\" ng-click=\"rowform.$cancel()\" class=\"btn btn-default editable-table-button btn-xs\">Cancel</button></form><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"rowform.$show()\">Edit</button></div></td></tr></table></div><div ng-if=\"!vm.loading\" class=\"row\"><div class=\"table_footer\"><div class=\"col-lg-10 pull-left\">Total: <span ng-bind=\"vm.publishers.length\"></span></div></div></div></div>");
$templateCache.put("app/pages/administration/schema/schema-list.html","<style type=\"text/css\">\n  .table_footer{\n    margin-top: 25px;\n    position: relative;\n    right: -16px;\n    top: 30px;\n    padding-bottom: 10px; \n  }\n  #loading{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #selectPartnerText{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #paginator{\n    position: relative;\n    right: 52px;\n    top:0px;\n  }\n  .inner-addon { \n    position: relative; \n  }\n\n  /* style icon */\n  .inner-addon .glyphicon {\n    position: absolute;\n    padding: 10px;\n    pointer-events: none;\n  }\n\n  /* align icon */\n  .left-addon .glyphicon  { left:  0px;}\n  .right-addon .glyphicon { right: 0px;}\n\n  /* add padding  */\n  .left-addon input  { padding-left:  30px; }\n  .right-addon input { padding-right: 30px; }\n  .table-header{padding-bottom: 15px;}\n  .fa{\n    color: grey;\n    cursor: pointer;\n  }\n  .table{\n    background: white;\n    overflow: hidden;\n  }\n  mark{\n    background-color: yellow;\n  }\n  #noContent{\n    background: white none repeat scroll 0 0;\n    border: 1px dashed black;\n    height: 154px;\n    margin-top: 100px;\n    padding-top: 65px;\n    position: absolute;\n    right: 35px;\n    width: 96%;\n  }\n</style><div ng-controller=\"SchemaListCtrl as vm\"><div class=\"row table-header\" ng-show=\"!loading\"><div class=\"col-lg-2\"></div><div class=\"col-lg-2 pull-right\"><button type=\"button\" ui-sref=\"administration.schemasNew({schema: schema.id, type: \'create\'})\" class=\"btn btn-primary btn-with-icon\">Create Schema</button></div></div><div ng-if=\"vm.noContent\" ng-model=\"vm.noContent\" ng-change=\"vm.noContent\" id=\"noContent\" class=\"text-center\"><h2>No Schema found :(</h2></div><div class=\"row col-lg-12\" style=\"height: 700px;overflow-y:auto;overflow-x:none;\"><div class=\"horizontal-scroll custom-table\" ng-if=\"vm.schemasList.length > 0\"><table class=\"table table-bordered\"><thead><tr><th class=\"table-id\">#</th><th>Name</th><th>Publisher</th><th>Created At</th><th>Action</th></tr></thead><tbody><div ng-if=\"vm.loading\" ng-change=\"vm.loading\" ng-model=\"vm.loading\" id=\"loading\" class=\"text-center\"><h2>Loading, please wait...</h2><br><img height=\"60px\" src=\"assets/img/app/loading.gif\"></div><tr ng-if=\"!vm.loading\" ng-repeat=\"schema in vm.schemasList\"><td class=\"table-id\">{{schema.id}}</td><td>{{schema.name}}</td><td>{{schema.publisher}}</td><td>{{schema.created_at}}</td><td ui-sref=\"administration.schemasEdit({schema: {id: schema.id, name: schema.name, pid: schema.pid}, type: \'edit\'})\"><a class=\"btn\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Edit Schema\"><i class=\"fa fa-pencil\"></i></a></td></tr></tbody></table></div></div><div ng-if=\"!vm.loading\" class=\"row\"><div class=\"table_footer\"><div class=\"col-lg-10 pull-left\">Total: <span ng-bind=\"vm.schemasList.length\"></span></div></div></div></div>");
$templateCache.put("app/pages/administration/schema/schema.html","<style type=\"text/css\">\n  .table_footer{\n    margin-top: 25px;\n    position: relative;\n    right: -16px;\n    top: 30px;\n    padding-bottom: 10px; \n  }\n  #loading{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #selectPartnerText{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #paginator{\n    position: relative;\n    right: 52px;\n    top:0px;\n  }\n  .inner-addon { \n    position: relative; \n  }\n\n  /* style icon */\n  .inner-addon .glyphicon {\n    position: absolute;\n    padding: 10px;\n    pointer-events: none;\n  }\n\n  /* align icon */\n  .left-addon .glyphicon  { left:  0px;}\n  .right-addon .glyphicon { right: 0px;}\n\n  /* add padding  */\n  .left-addon input  { padding-left:  30px; }\n  .right-addon input { padding-right: 30px; }\n  .table-header{padding-bottom: 15px;}\n  .fa{\n    color: grey;\n    cursor: pointer;\n  }\n  .table{\n    background: white;\n  }\n  mark{\n    background-color: yellow;\n  }\n   #schemas-noContent {\n      background: white none repeat scroll 0 0;\n      border: 1px dashed black;\n      height: 154px;\n      margin-top: 100px;\n      padding-top: 65px;\n      position: absolute;\n      right: 23px;\n      width: 96%;\n  }\n  .add-row-editable-table {\n    float: right;\n    padding-right: 48px;\n  }\n  #saveChange{\n    padding-right: 48px;\n  }\n</style><div ng-controller=\"SchemaCtrl as vm\"><div class=\"row table-header\" ng-show=\"!loading\"><div class=\"col-md-6\"><div class=\"publisher-selection\"><select id=\"select-publisher\"><option disabled=\"\" checked=\"\" value=\"\">Select Publisher</option><option ng-repeat=\"publisher in vm.publishers\" value=\"{{publisher.id}}\">{{publisher.value}}</option></select></div></div><div class=\"col-md-6\"><div class=\"add-row-editable-table\"><button ng-if=\"vm.schemas.length == 0\" class=\"btn btn-primary\" ng-click=\"vm.addProperty()\">Add Property</button></div></div></div><div class=\"row col-lg-12\" style=\"height: 700px;overflow-y:auto;overflow-x:none;\"><div ng-if=\"vm.loading\" ng-change=\"vm.loading\" ng-model=\"vm.loading\" id=\"loading\" class=\"text-center\"><h2>Loading, please wait...</h2><br><img height=\"60px\" src=\"assets/img/app/loading.gif\"></div><div ng-if=\"!vm.loading && vm.schemas.length == 0\" ng-change=\"vm.schemas\" ng-model=\"vm.schemas\" id=\"schemas-noContent\" class=\"text-center\"><h2>No properties found for this schema...</h2><br></div><div><h2><span editable-text=\"vm.schemas.name\" e-name=\"name\" e-form=\"rowform2\" ng-click=\"rowform2.$show()\" e-required=\"\" style=\"cursor: pointer\">{{ vm.schemas.name || \'Click here to change name\' }}</span></h2></div><table class=\"table table-bordered table-hover table-condensed\" ng-if=\"vm.schemas.length != 0\" \"=\"\"><tr><td>#id</td><td>Property</td></tr><tr ng-repeat=\"schemas in vm.schemas\" class=\"editable-row\"><td><span>{{ schemas.id || \'empty\' }}</span></td><td><span editable-text=\"schemas.value\" e-name=\"value\" e-form=\"rowform\" e-required=\"\" ng-click=\"rowform.$show()\">{{ schemas.value || \'empty\' }}</span> <span class=\"buttons\" ng-show=\"!rowform.$visible\" style=\"float:right;\"><a class=\"btn btn-danger editable-table-button btn-xs\" ng-click=\"vm.RemoveProperty($index)\">Delete</a> <a class=\"btn btn-success editable-table-button btn-xs\" ng-if=\"vm.schemas.length - 1 == $index\" ng-click=\"vm.addProperty()\">new</a></span></td></tr></table></div><div id=\"saveChange\" class=\"row pull-right\" ng-if=\"vm.schemas.length != 0\"><div class=\"col-lg-12\"><button class=\"btn btn-primary\" ng-click=\"vm.saveRows()\">Save Changes</button></div></div></div>");
$templateCache.put("app/pages/administration/transcoder/transcoder_options.html","<style type=\"text/css\">\n  .table_footer{\n    margin-top: 25px;\n    position: relative;\n    right: -16px;\n    top: 30px;\n    padding-bottom: 10px;\n  }\n  #loading{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #selectPartnerText{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #paginator{\n    position: relative;\n    right: 52px;\n    top:0px;\n  }\n  .inner-addon {\n    position: relative;\n  }\n\n  /* style icon */\n  .inner-addon .glyphicon {\n    position: absolute;\n    padding: 10px;\n    pointer-events: none;\n  }\n\n  /* align icon */\n  .left-addon .glyphicon  { left:  0px;}\n  .right-addon .glyphicon { right: 0px;}\n\n  /* add padding  */\n  .left-addon input  { padding-left:  30px; }\n  .right-addon input { padding-right: 30px; }\n  .table-header{padding-bottom: 15px;}\n  .fa{\n    color: grey;\n    cursor: pointer;\n  }\n  .table{\n    background: white;\n  }\n  mark{\n    background-color: yellow;\n  }\n  #noContent{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  .add-row-editable-table {\n    float: right;\n    padding-right: 48px;\n  }\n  .apply-btn {\n    position: relative;\n    right: 12px;\n  }\n</style><div ng-controller=\"TranscoderOptionsCtrl as vm\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"col-lg-6\"><div ng-if=\"vm.loading\" ng-change=\"vm.loading\" ng-model=\"vm.loading\" id=\"loading\" class=\"text-center\"><h2>Loading, please wait...</h2><br><img height=\"60px\" src=\"assets/img/app/loading.gif\"></div><h4 class=\"text-center\">Cloud Transcoder</h4><table class=\"table table-bordered\"><tr><td>Publisher</td><td>240P</td><td>360P</td><td>480P</td><td>720P</td><td>1080P</td></tr><tr ng-repeat=\"publisher in vm.publishers\"><td><span>{{ publisher.name}}</span></td><td><md-switch id=\"resolution_240_{{publisher.id}}\" md-no-ink=\"\" aria-label=\"Enable/Disable Quality\" ng-model=\"vm.models[\'resolution_240_\' + publisher.id].enabled\" ng-disabled=\"true\"></md-switch></td><td><md-switch id=\"resolution_360_{{publisher.id}}\" class=\"md-primary\" md-no-ink=\"\" aria-label=\"Enable/Disable Quality\" ng-model=\"vm.models[\'resolution_360_\' + publisher.id].enabled\"></md-switch></td><td><md-switch id=\"resolution_480_{{publisher.id}}\" class=\"md-primary\" md-no-ink=\"\" aria-label=\"Enable/Disable Quality\" ng-model=\"vm.models[\'resolution_480_\' + publisher.id].enabled\"></md-switch></td><td><md-switch id=\"resolution_720_{{publisher.id}}\" class=\"md-primary\" md-no-ink=\"\" aria-label=\"Enable/Disable Quality\" ng-model=\"vm.models[\'resolution_720_\' + publisher.id].enabled\"></md-switch></td><td><md-switch id=\"resolution_1080_{{publisher.id}}\" class=\"md-primary\" md-no-ink=\"\" aria-label=\"Enable/Disable Quality\" ng-model=\"vm.models[\'resolution_1080_\' + publisher.id].enabled\"></md-switch></td></tr></table></div><div class=\"col-lg-6\"><div ng-if=\"vm.loading\" ng-change=\"vm.loading\" ng-model=\"vm.loading\" id=\"loading\" class=\"text-center\"><h2>Loading, please wait...</h2><br><img height=\"60px\" src=\"assets/img/app/loading.gif\"></div><h4 class=\"text-center\">Genoa Transcoder</h4><table class=\"table table-bordered\"><tr><td></td><td>240P</td><td>360P</td><td>480P</td><td>720P</td><td>1080P</td></tr><tr ng-repeat=\"publisher in vm.publishers\"><td><span></span></td><td><md-switch id=\"genoa_resolution_240_{{publisher.id}}\" md-no-ink=\"\" aria-label=\"Enable/Disable Quality\" ng-model=\"vm.models[\'resolution_240_\' + publisher.id].gt_enabled\" ng-disabled=\"true\"></md-switch></td><td><md-switch id=\"genoa_resolution_360_{{publisher.id}}\" class=\"md-primary\" md-no-ink=\"\" aria-label=\"Enable/Disable Quality\" ng-model=\"vm.models[\'resolution_360_\' + publisher.id].gt_enabled\"></md-switch></td><td><md-switch id=\"genoa_resolution_480_{{publisher.id}}\" class=\"md-primary\" md-no-ink=\"\" aria-label=\"Enable/Disable Quality\" ng-model=\"vm.models[\'resolution_480_\' + publisher.id].gt_enabled\"></md-switch></td><td><md-switch id=\"genoa_resolution_720_{{publisher.id}}\" class=\"md-primary\" md-no-ink=\"\" aria-label=\"Enable/Disable Quality\" ng-model=\"vm.models[\'resolution_720_\' + publisher.id].gt_enabled\"></md-switch></td><td><md-switch id=\"genoa_resolution_1080_{{publisher.id}}\" class=\"md-primary\" md-no-ink=\"\" aria-label=\"Enable/Disable Quality\" ng-model=\"vm.models[\'resolution_1080_\' + publisher.id].gt_enabled\"></md-switch></td></tr></table></div></div></div><br><div class=\"row\"><div class=\"col-lg-12\"><table class=\"table table-bordered\"><tr><td>Publisher</td><td>Default Quality / (Desktop, Only Player V2)</td><td>Show Qualities (Desktop)</td><td>Default Quality / (Mobile, Only Player V2)</td><td>Show Qualities (Mobile)</td><td>Default Transcoder</td><td>Transcoder Preview</td></tr><tr ng-repeat=\"publisher in vm.publishers\"><td><span>{{publisher.name}}</span></td><td><select id=\"default_desktop_{{publisher.id}}\" ng-model=\"vm.models[\'defaultDesktop_\' + publisher.id]\"><option value=\"\">Default</option><option value=\"1080P\">1080P</option><option value=\"720P\">720P</option><option value=\"480P\">480P</option><option value=\"360P\">360P</option><option value=\"240P\">240P</option></select></td><td><input type=\"checkbox\" id=\"desktop_240P_{{publisher.id}}\" name=\"desktop_240P\" ng-model=\"vm.models[\'desktop_240P_\' + publisher.id]\" disabled=\"\"> <label for=\"240P\">240P</label> <input type=\"checkbox\" id=\"desktop_360P_{{publisher.id}}\" name=\"desktop_360P\" ng-model=\"vm.models[\'desktop_360P_\' + publisher.id]\"> <label for=\"360P\">360P</label> <input type=\"checkbox\" id=\"desktop_480P_{{publisher.id}}\" name=\"desktop_480P\" ng-model=\"vm.models[\'desktop_480P_\' + publisher.id]\"> <label for=\"480P\">480P</label> <input type=\"checkbox\" id=\"desktop_720P_{{publisher.id}}\" name=\"desktop_720P\" ng-model=\"vm.models[\'desktop_720P_\' + publisher.id]\"> <label for=\"720P\">720P</label> <input type=\"checkbox\" id=\"desktop_1080P_{{publisher.id}}\" name=\"desktop_1080P\" ng-model=\"vm.models[\'desktop_1080P_\' + publisher.id]\"> <label for=\"1080P\">1080P</label></td><td><select id=\"default_mobile_{{publisher.id}}\" ng-model=\"vm.models[\'defaultMobile_\' + publisher.id]\"><option value=\"\">Default</option><option value=\"1080P\">1080P</option><option value=\"720P\">720P</option><option value=\"480P\">480P</option><option value=\"360P\">360P</option><option value=\"240P\">240P</option></select></td><td><input type=\"checkbox\" id=\"mobile_240P_{{publisher.id}}\" name=\"mobile_240P\" ng-model=\"vm.models[\'mobile_240P_\' + publisher.id]\" disabled=\"\"> <label for=\"240P\">240P</label> <input type=\"checkbox\" id=\"mobile_360P_{{publisher.id}}\" name=\"mobile_360P\" ng-model=\"vm.models[\'mobile_360P_\' + publisher.id]\"> <label for=\"360P\">360P</label> <input type=\"checkbox\" id=\"mobile_480P_{{publisher.id}}\" name=\"mobile_480P\" ng-model=\"vm.models[\'mobile_480P_\' + publisher.id]\"> <label for=\"480P\">480P</label> <input type=\"checkbox\" id=\"mobile_720P_{{publisher.id}}\" name=\"mobile_720P\" ng-model=\"vm.models[\'mobile_720P_\' + publisher.id]\"> <label for=\"720P\">720P</label> <input type=\"checkbox\" id=\"mobile_1080P_{{publisher.id}}\" name=\"mobile_1080P\" ng-model=\"vm.models[\'mobile_1080P_\' + publisher.id]\"> <label for=\"1080P\">1080P</label></td><td><select id=\"default_transcoder\" ng-model=\"vm.models[\'defaultTranscoder_\' + publisher.id]\" \"=\"\"><option value=\"aws\">Cloud Transcoder</option><option value=\"genoa\">Genoa Transcoder</option></select></td><td><input type=\"checkbox\" id=\"preview\" name=\"preview\" ng-model=\"vm.models[\'preview_\' + publisher.id]\"> <label for=\"preview\">Enabled</label></td></tr></table></div></div><div class=\"row pull-right\"><div class=\"apply-btn\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.applyChanges()\">Apply</md-button></div></div></div>");
$templateCache.put("app/pages/administration/users/user.html","<style type=\"text/css\">\n  .status-btn{\n      position: absolute;\n      top: 50px;\n      right: 29px;\n  }\n</style><div ng-controller=\"UserCtrl as vm\"><div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"status-btn\"><div ng-if=\"vm.action == \'edit\'\"><switch id=\"status-switch\" color=\"primary\" ng-model=\"vm.status\"></switch></div></div><div class=\"panel-content\"><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">* First Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"\" value=\"{{(vm.action == \'edit\')? vm.user_conf.name : \'\'}}\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputLastName\" class=\"col-sm-3 control-label\">* Last Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputLastName\" placeholder=\"\" value=\"{{(vm.action == \'edit\')? vm.user_conf.last_name : \'\'}}\"></div></div></div></div><h3 class=\"with-line\">Change Password</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\">Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputPassword\" placeholder=\"\" ng-disabled=\"true\" value=\"{{(vm.action == \'create\')? vm.hash : \'12345678\'}}\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputConfirmPassword\" class=\"col-sm-3 control-label\">Confirm Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputConfirmPassword\" placeholder=\"\" ng-disabled=\"true\" value=\"{{(vm.action == \'create\')? vm.hash : \'12345678\'}}\"></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputEmail3\" class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" id=\"inputEmail3\" ng-disabled=\"vm.action == \'edit\'\" placeholder=\"\" value=\"{{(vm.action == \'edit\')? vm.user_conf.email : \'\'}}\"></div></div></div></div><h3 class=\"with-line\">Profile Group</h3><div class=\"notification row clearfix\"><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-3\">* Profile</label><div class=\"col-xs-4\"><select id=\"user_profile\"><option value=\"\" disabled=\"\" selected=\"\">Select profile</option><option ng-repeat=\"profile in vm.profiles\" value=\"{{profile.id}}\">{{profile.name}}</option></select></div></div></div></div><div class=\"row col-md-offset-2\"><div class=\"col-lg-2 pull-right\"><button ng-click=\"vm.saveData()\" type=\"button\" class=\"btn btn-primary btn-with-icon save-changes\"><i class=\"ion-android-checkmark-circle\"></i><span ng-bind=\"vm.btn_action\"></span></button></div><div class=\"col-lg-1 pull-right\"><a ui-sref=\"administration.users\" class=\"btn btn-danger btn-with-icon cancel\"><i class=\"ion-android-checkmark-circle\"></i> Cancel</a></div></div></div></div></div>");
$templateCache.put("app/pages/administration/users/users_list.html","<style type=\"text/css\">\n  .table_footer{\n    margin-top: 20px; \n  }\n  #loading{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #selectPartnerText{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n  #paginator{\n    position: relative;\n    right: 52px;\n    top:0px;\n  }\n  .inner-addon { \n    position: relative; \n  }\n\n  /* style icon */\n  .inner-addon .glyphicon {\n    position: absolute;\n    padding: 10px;\n    pointer-events: none;\n  }\n\n  /* align icon */\n  .left-addon .glyphicon  { left:  0px;}\n  .right-addon .glyphicon { right: 0px;}\n\n  /* add padding  */\n  .left-addon input  { padding-left:  30px; }\n  .right-addon input { padding-right: 30px; }\n  .table-header{padding-bottom: 15px;}\n  .fa{\n    color: grey;\n    cursor: pointer;\n  }\n  .table{\n    background: white;\n    overflow: hidden;\n  }\n  mark{\n    background-color: yellow;\n  }\n  #noContent{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n</style><div ng-controller=\"UsersListCtrl as vm\"><div class=\"row table-header\" ng-show=\"!loading\"><div class=\"col-lg-2\"><div class=\"inner-addon left-addon\"><i class=\"glyphicon glyphicon-search\"></i> <input ng-model=\"vm.search_user\" ng-change=\"vm.searchUser()\" type=\"text\" class=\"form-control\" id=\"search_user\" name=\"search_user\" placeholder=\"Search by id, name, email\"></div></div><div class=\"col-lg-1 pull-right\"><button type=\"button\" ui-sref=\"create\" class=\"btn btn-primary btn-with-icon\">Create User</button></div></div><div class=\"row col-lg-12\" style=\"height: 700px;overflow-y:auto;overflow-x:none;\"><div class=\"horizontal-scroll custom-table\"><table class=\"table table-bordered\"><thead><tr><th><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"inlineCheckbox01\" value=\"\"> <span></span></label></th><th class=\"table-id\">#</th><th>Name</th><th>Last Name</th><th>E-Mail</th><th>Status</th><th>Group</th><th>Profile Group</th><th>Actions</th></tr></thead><tbody><div ng-if=\"vm.loading\" ng-change=\"vm.loading\" ng-model=\"vm.loading\" id=\"loading\" class=\"text-center\"><h2>Loading, please wait...</h2><br><img height=\"60px\" src=\"assets/img/app/loading.gif\"></div><div ng-if=\"vm.noContent\" ng-model=\"vm.noContent\" ng-change=\"vm.noContent\" id=\"noContent\" class=\"text-center\"><h2>No User found :(</h2></div><tr ng-if=\"!vm.loading\" ng-repeat=\"user in vm.users.users\"><td><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"inlineCheckbox01\" value=\"\"> <span></span></label></td><td class=\"table-id markeable\">{{user.id}}</td><td class=\"markeable\">{{user.name}}</td><td class=\"markeable\">{{user.last_name}}</td><td class=\"markeable\">{{user.email}}</td><td ng-style=\"user.status == \'enabled\' ? {\'color\': \'green\'} : {\'color\' : \'red\'}\">{{user.status}}</td><td>{{user.group_name}}</td><td>{{user.user_profile_name}}</td><td><a type=\"button\" ui-sref=\"edit({user: user.id})\" class=\"btn\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Edit User\"><i class=\"fa fa-pencil\"></i></a></td></tr></tbody></table></div><div ng-if=\"!vm.loading\" class=\"row\"><div class=\"table_footer\"><div class=\"col-lg-10 pull-left\">Total: <span ng-bind=\"vm.users.total\"></span></div></div></div></div></div>");
$templateCache.put("app/pages/components/mail/mail.html","<div class=\"row mail-client-container transparent\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"xmedium-panel mail-panel\"><div class=\"letter-layout\"><div class=\"mail-navigation-container\" ng-class=\"{\'expanded\' : !tabCtrl.navigationCollapsed}\"><div class=\"text-center\"><button type=\"button\" class=\"btn btn-default compose-button\" ng-click=\"tabCtrl.showCompose(\'\',\'\',\'\')\">Compose</button></div><div ng-repeat=\"t in tabCtrl.tabs\" ui-sref-active=\"active\" class=\"mail-navigation\" ui-sref=\"components.mail.label({label: t.label})\" ng-click=\"selectTab(t.label)\">{{t.name}}<span class=\"new-mails\" ng-show=\"t.newMails\">{{t.newMails}}</span></div><div class=\"labels\"><div class=\"labels-title\"></div><div class=\"labels-container\"><div class=\"label-item\"><span class=\"tag label work\">Work</span></div><div class=\"label-item\"><span class=\"tag label family\">Family</span></div><div class=\"label-item\"><span class=\"tag label friend\">Friend</span></div><div class=\"label-item\"><span class=\"tag label study\">Study</span></div></div></div><div class=\"add-label-container\"><i class=\"ion-plus-round\"></i><span class=\"label-input-stub\">Add new label</span></div></div><ui-view></ui-view></div></div></div></div>");
$templateCache.put("app/pages/components/tree/tree.html","<div class=\"row\" ng-controller=\"treeCtrl\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Basic Action\" ba-panel-class=\"with-scroll tree-panel\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"control-side text-center\"><div><button class=\"btn btn-primary\" ng-click=\"addNewNode()\">Add</button></div><div><button class=\"btn btn-primary\" ng-click=\"collapse()\">Collapse All</button></div><div><button class=\"btn btn-primary\" ng-click=\"expand()\">Expand All</button></div><div><button class=\"btn btn-primary\" ng-click=\"refresh()\">Refresh</button></div></div></div><div class=\"col-sm-8\"><div js-tree=\"basicConfig\" ng-model=\"treeData\" should-apply=\"applyModelChanges()\" tree=\"basicTree\" tree-events=\"ready:readyCB\"></div></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Drag & Drop\" ba-panel-class=\"with-scroll tree-panel\"><div js-tree=\"dragConfig\" ng-model=\"dragData\"></div></div></div></div>");
$templateCache.put("app/pages/components/timeline/timeline.html","<div ba-panel=\"\"><section id=\"cd-timeline\" class=\"cd-container cssanimations\" ng-controller=\"TimelineCtrl\"><div class=\"cd-timeline-block\"><div class=\"cd-timeline-img\"><div class=\"kameleon-icon with-round-bg warning\"><img ng-src=\"{{::( \'Euro-Coin\' | kameleonImg )}}\"></div></div><div class=\"cd-timeline-content warning\"><h5>Title of section 1</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto, optio, dolorum provident rerum aut hic quasi placeat iure tempora laudantium ipsa ad debitis unde? Iste voluptatibus minus veritatis qui ut.</p><span class=\"cd-date\">Jan 14</span></div></div><div class=\"cd-timeline-block\"><div class=\"cd-timeline-img\"><div class=\"kameleon-icon with-round-bg danger\"><img ng-src=\"{{::( \'Laptop-Signal\' | kameleonImg )}}\"></div></div><div class=\"cd-timeline-content danger\"><h5>Title of section 2</h5><p>Donec dapibus at leo eget volutpat. Praesent dolor tellus, ultricies venenatis molestie eu, luctus eget nibh. Curabitur ullamcorper eleifend nisl.</p><span class=\"cd-date\">Jan 18</span></div></div><div class=\"cd-timeline-block\"><div class=\"cd-timeline-img\"><div class=\"kameleon-icon with-round-bg primary\"><img ng-src=\"{{::( \'Checklist\' | kameleonImg )}}\"></div></div><div class=\"cd-timeline-content primary\"><h5>Title of section 3</h5><p>Phasellus auctor tellus eget lacinia condimentum. Cum sociis natoque penatibus et magnis dis parturient montes.</p><span class=\"cd-date\">Feb 18</span></div></div><div class=\"cd-timeline-block\"><div class=\"cd-timeline-img\"><div class=\"kameleon-icon with-round-bg warning\"><img ng-src=\"{{::( \'Boss-3\' | kameleonImg )}}\"></div></div><div class=\"cd-timeline-content warning\"><h5>Title of section 4</h5><p>Morbi fringilla in massa ac posuere. Fusce non sagittis massa, id accumsan odio. Nullam eget tempor est. Etiam eu felis eu purus aliquam tristique id quis nisl. Nam eros nibh, consequat sed pulvinar eu, ultrices ornare ligula. Aenean interdum sed nunc sed hendrerit.</p><span class=\"cd-date\">Feb 20</span></div></div><div class=\"cd-timeline-block\"><div class=\"cd-timeline-img\"><div class=\"kameleon-icon with-round-bg danger\"><img ng-src=\"{{::( \'Online-Shopping\' | kameleonImg )}}\"></div></div><div class=\"cd-timeline-content danger\"><h5>Title of section 5</h5><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur eget mattis metus. Nullam egestas eros metus, quis fringilla urna accumsan sed. Aliquam ultrices at arcu vitae tincidunt.</p><span class=\"cd-date\">Feb 21</span></div></div><div class=\"cd-timeline-block\"><div class=\"cd-timeline-img\"><div class=\"kameleon-icon with-round-bg primary\"><img ng-src=\"{{::( \'Money-Increase\' | kameleonImg )}}\"></div></div><div class=\"cd-timeline-content primary\"><h5>Title of section 6</h5><p>Praesent bibendum ante mattis augue consectetur, ut commodo turpis consequat. Donec ligula eros, porta in iaculis vel, semper ac sem. Integer at mauris lorem.</p><span class=\"cd-date\">Feb 23</span></div></div><div class=\"cd-timeline-block\"><div class=\"cd-timeline-img\"><div class=\"kameleon-icon with-round-bg warning\"><img ng-src=\"{{::( \'Vector\' | kameleonImg )}}\"></div></div><div class=\"cd-timeline-content warning\"><h5>Title of section 7</h5><p>Vivamus ut laoreet erat, vitae eleifend eros. Sed varius id tellus non lobortis. Sed dolor ante, cursus non scelerisque sed, euismod id eros.</p><span class=\"cd-date\">Feb 24</span></div></div></section></div>");
$templateCache.put("app/pages/content/categories/categories.html","<style type=\"text/css\">\n	.add-category{\n		cursor: pointer;\n	    position: absolute;\n	    right: 22px;\n	    top: 20px;\n	}\n	.delete-category{\n		cursor: pointer;\n	    position: absolute;\n	    right: 82px;\n	    top: 20px;\n	}\n	.edit-category{\n		cursor: pointer;\n	    position: absolute;\n	    top: 20px;\n	    right: 52px;\n	}\n	select{\n		width: 100%;\n	}\n	option {\n    	border-bottom: 1px solid gainsboro;\n    	padding: 8px;\n	}\n	.fa{\n		color: grey;\n	}\n	.fa:hover{\n		text-shadow: 1px 1px 1px #209E91;\n	}\n	#botonera{\n		padding: 20px;\n	}\n	hr{\n		color: black;\n	}\n</style><div ng-controller=\"CategoriesCtrl as vm\"><div class=\"row\"><div class=\"col-lg-4\"><select id=\"publisher-select\" ng-model=\"vm.selected_pub\" ng-change=\"vm.initialize()\" name=\"publisher-select\"><option value=\"\" disabled=\"\" selected=\"\">Select Publisher</option><option ng-repeat=\"publisher in vm.publishers track by $index\" value=\"{{publisher.id}}\">{{publisher.value}}</option></select></div></div><div class=\"publisher-categories\"><hr><div class=\"row\"><div class=\"col-lg-4\"><div class=\"cat1-select\" style=\"display: none;\">First Category: <input type=\"text\" class=\"form-control input-category\" id=\"cat1\" placeholder=\"Name the new first category..\" value=\"{{vm.name1}}\" ng-model=\"vm.name1\"> <a ng-if=\"vm.permissions.cat_create\" class=\"add-category\" ng-click=\"vm.addCategory(1)\"><i class=\"fa fa-2x fa-plus-circle\" aria-hidden=\"true\"></i></a> <a ng-if=\"vm.permissions.cat_delete\" class=\"delete-category\" ng-click=\"vm.deleteCategory(1)\"><i class=\"fa fa-2x fa-trash-o\" aria-hidden=\"true\"></i></a> <a ng-if=\"vm.permissions.cat_edit\" class=\"edit-category\" ng-click=\"vm.editCategory(1)\"><i class=\"fa fa-2x fa-pencil\" aria-hidden=\"true\"></i></a></div></div><div class=\"col-lg-4\"><div class=\"cat2-select\" style=\"display: none;\">Second Category: <input type=\"text\" class=\"form-control input-category\" id=\"cat2\" placeholder=\"Name the new second category..\" value=\"{{vm.name2}}\" ng-model=\"vm.name2\"> <a ng-if=\"vm.permissions.cat_create\" class=\"add-category\" ng-click=\"vm.addCategory(2)\"><i class=\"fa fa-2x fa-plus-circle\" aria-hidden=\"true\"></i></a> <a ng-if=\"vm.permissions.cat_delete\" class=\"delete-category\" ng-click=\"vm.deleteCategory(2)\"><i class=\"fa fa-2x fa-trash-o\" aria-hidden=\"true\"></i></a> <a ng-if=\"vm.permissions.cat_edit\" class=\"edit-category\" ng-click=\"vm.editCategory(2)\"><i class=\"fa fa-2x fa-pencil\" aria-hidden=\"true\"></i></a></div></div><div class=\"col-lg-4\"><div class=\"cat3-select\" style=\"display: none;\">Third Category: <input type=\"text\" class=\"form-control input-category\" id=\"cat3\" placeholder=\"Name the new third category..\" value=\"{{vm.name3}}\" ng-model=\"vm.name3\"> <a ng-if=\"vm.permissions.cat_create\" class=\"add-category\" ng-click=\"vm.addCategory(3)\"><i class=\"fa fa-2x fa-plus-circle\" aria-hidden=\"true\"></i></a> <a ng-if=\"vm.permissions.cat_delete\" class=\"delete-category\" ng-click=\"vm.deleteCategory(3)\"><i class=\"fa fa-2x fa-trash-o\" aria-hidden=\"true\"></i></a> <a ng-if=\"vm.permissions.cat_edit\" class=\"edit-category\" ng-click=\"vm.editCategory(3)\"><i class=\"fa fa-2x fa-pencil\" aria-hidden=\"true\"></i></a></div></div></div><div class=\"row\"><div class=\"col-lg-4\"><select id=\"cat1-select\" class=\"cat1-select\" name=\"cat1\" style=\"display: none;\"><option value=\"\" disabled=\"\" selected=\"\">Select Category</option><option ng-repeat=\"category in vm.cat1 track by $index\" value=\"{{category.id}}\">{{category.value}}</option></select></div><div class=\"col-lg-4\"><select id=\"cat2-select\" class=\"cat2-select\" name=\"cat2\" style=\"display: none;\"><option value=\"\" disabled=\"\" selected=\"\">Select Category</option><option ng-repeat=\"category in vm.cat2 track by $index\" value=\"{{category.id}}\">{{category.value}}</option></select></div><div class=\"col-lg-4\"><select id=\"cat3-select\" class=\"cat3-select\" name=\"cat3\" style=\"display: none;\"><option value=\"\" disabled=\"\" selected=\"\">Select Category</option><option ng-repeat=\"category in vm.cat3 track by $index\" value=\"{{category.id}}\">{{category.value}}</option></select></div></div></div></div>");
$templateCache.put("app/pages/content/content-graphs/contentGraph.html","<style type=\"text/css\">\n  .modal-content-graph{\n    margin-top: 60px;\n  }\n  .md-label {\n      color: black !important;\n  }\n  .spinner {\n      margin: 25% 45% !important;\n  }\n  .no-content{\n    display: none;\n    position: absolute;\n    z-index: 99999;\n    top: -100px;\n    text-align: center;\n    font-size: 26px;\n    color: grey;\n  }\n  .modal .modal-dialog .modal-body p, .modal .modal-dialog .modal-body div, .modal .modal-dialog .modal-body span{\n    color: white;\n  }\n  .md-datepicker-calendar-pane {\n      z-index: 1200;\n  }\n  .md-button{\n    min-height: 30px;\n    line-height: 32px;\n  }\n</style><div ng-controller=\"ContentGraphModalCtrl\" class=\"modal-content-graph\"><div class=\"modal-header\"><h4 class=\"modal-title\">Content Analytics</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"custom col-lg-12\" ng-if=\"loading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div></div><div class=\"row\" ng-if=\"showDates\"><div class=\"input-group\" id=\"daterange\"><md-datepicker ng-model=\"date.startDate\" ng-change=\"updateDate()\" md-placeholder=\"Start date\"></md-datepicker><md-datepicker ng-model=\"date.endDate\" ng-change=\"updateDate()\" md-placeholder=\"End date\"></md-datepicker></div></div><div layout=\"row\" layout-align=\"center\"><md-radio-group layout=\"row\" ng-model=\"graphSelected\" ng-change=\"updateDate()\"><md-radio-button value=\"analytics\" flex=\"\">Analytics</md-radio-button><md-radio-button value=\"percentage\" flex=\"\">Percentage</md-radio-button></md-radio-group></div><br><div class=\"row\"><div class=\"custom col-lg-12\"><div id=\"container\" style=\"min-width: 310px; height: 400px; margin: 0 auto\"></div></div></div><div class=\"row\"><div class=\"custom col-lg-12\"><h4 class=\"no-content\"><strong>This content has not beign played between those dates!</strong></h4></div></div></div><div class=\"modal-footer\"><md-button ng-click=\"$dismiss()\" class=\"md-raised md-primary\">Close</md-button></div></div>");
$templateCache.put("app/pages/content/mediaContent/ClippingModal.html","<div ng-controller=\"ClippingModalCtrl\"><iframe ng-src=\"{{clippingSrc}}\" frameborder=\"no\" scrolling=\"no\" style=\"width:100%; height:90vh;\"></iframe></div>");
$templateCache.put("app/pages/content/mediaContent/contentEdit.html","<style type=\"text/css\">\n    .clipping-modal .modal-lg {\n\n        width: 90%;\n        height: 100%;\n    }\n    .bootstrap-tagsinput > input {\n        border: none;\n    }\n\n    .btn-thumb{\n        list-style-type: none;\n        margin: 0;\n        padding: 0;\n        overflow: hidden;\n    }\n    .list{\n        float: left;\n        display: block;\n        text-align: center;\n        text-decoration: none;\n        padding-left: 20px;\n    }\n\n\n    button.accordion {\n        background-color: #eee;\n        color: #ff832c;\n        cursor: pointer;\n        padding: 18px;\n        width: 100%;\n        text-align: left;\n        border: none;\n        outline: none;\n        transition: 0.4s;\n    }\n\n    button.accordion.active, button.accordion:hover {\n        background-color: #ddd;\n    }\n\n    div.barra.show {\n        display: block;\n    }\n    button.accordion:after {\n        content: \'\\02795\'; /* Unicode character for \"plus\" sign (+) */\n        font-size: 13px;\n        color: #ff832c;\n        float: right;\n        margin-left: 5px;\n    }\n\n    button.accordion.active:after {\n        content: \"\\2796\"; /* Unicode character for \"minus\" sign (-) */\n    }\n    div.barra {\n        padding: 0px;\n        background-color: white;\n        max-height: 0;\n        overflow: hidden;\n        transition: max-height 0.2s ease-out;\n        display: block;\n        z-index: 50;\n    }\n    #cd-timeline{\n        height: 400px;\n        overflow-y: auto;\n    }\n    #loading{\n        width: 88%;\n        position: absolute;\n        margin: 34% 29%;\n        z-index: 9999999999 !important;\n    }\n    #ErrorCancel{\n        position: absolute;\n        bottom: 20px;\n        right: 20px;\n    }\n    .error{\n        width: 100%;\n        margin: 20px auto;\n    }\n    .content-top.clearfix{\n        display: none;\n    }\n    #panel-edit{\n        margin-top: 20px;\n    }\n\n    .spinner {\n        animation: rotator 1.4s linear infinite;\n    }\n    @keyframes rotator {\n        0% {\n            transform: rotate(0deg);\n        }\n        100% {\n            transform: rotate(270deg);\n        }\n    }\n    .path {\n        stroke-dasharray: 187;\n        stroke-dashoffset: 0;\n        transform-origin: center;\n        animation: dash 1.4s ease-in-out infinite, colors 5.6s ease-in-out infinite;\n    }\n    @keyframes colors {\n        0% {\n            stroke: #4285f4;\n        }\n        25% {\n            stroke: #de3e35;\n        }\n        50% {\n            stroke: #f7c223;\n        }\n        75% {\n            stroke: #1b9a59;\n        }\n        100% {\n            stroke: #4285f4;\n        }\n    }\n    @keyframes dash {\n        0% {\n            stroke-dashoffset: 187;\n        }\n        50% {\n            stroke-dashoffset: 46.75;\n            transform: rotate(135deg);\n        }\n        100% {\n            stroke-dashoffset: 187;\n            transform: rotate(450deg);\n        }\n    }\n</style><div ng-controller=\"ContentEditCtrl as vm\"><div ng-if=\"vm.error\" ng-model=\"vm.error\" class=\"error alert alert-danger\"><h4>{{vm.error}}</h4></div><div id=\"panel-edit\" ba-panel=\"\" ba-panel-class=\"content-page\" ng-if=\"!vm.error\" ng-model=\"vm.error\"><div ng-show=\"vm.loading\" id=\"loading\" class=\"text-center\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"panel-content\"><h3 class=\"with-line\" ng-if=\"vm.info.content_type != \'live\'\">Content Info</h3><h3 class=\"with-line\" ng-if=\"vm.info.content_type == \'live\'\">Content Info - Live</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"media-name\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Description</label><div class=\"col-sm-9\"><textarea class=\"form-control\" id=\"media-description\" placeholder=\"\" value=\"\"></textarea></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Status</label><div class=\"col-sm-9\"><select id=\"media-status\" ng-model=\"vm.status\" ng-change=\"vm.refreshIframe()\"><option value=\"enabled\">enable</option><option value=\"disabled\">disable</option></select>&nbsp; <label id=\"message_status\" class=\"alert alert-warning\" style=\"display: none;\">(don`t forget to save changes)</label></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tags</label><div class=\"col-sm-9\"><input id=\"tags\" type=\"text\" value=\"\" data-role=\"tagsinput\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Categories</label><div class=\"col-sm-9\"><select id=\"categories\" ng-model=\"vm.categories_selected\" data-placeholder=\"Choose a category...\" multiple=\"\" width=\"100%\" class=\"form-control chosen-select\"></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Media ID</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" disabled=\"\" id=\"media-genoa_id\" ng-model=\"vm.mediaGenoaId\" value=\"{{vm.mediaGenoaId}}\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Reference Id</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" disabled=\"\" id=\"media-ReferenceId\" ng-model=\"vm.mediaReferenceId\" value=\"{{vm.mediaReferenceId}}\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Created At</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"media-created_at\" placeholder=\"\" value=\"\" readonly=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Created By</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"media-created_by\" placeholder=\"\" value=\"\" readonly=\"\"></div></div><div class=\"form-group row clearfix\" ng-if=\"vm.info.content_type != \'live\'\"><label class=\"col-sm-3 control-label\">Kaltura ID</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"media-kalturaId\" placeholder=\"\" value=\"\" readonly=\"\"></div></div><div class=\"form-group row clearfix\" ng-if=\"vm.info.content_type == \'live\'\"><label class=\"col-sm-3 control-label\">URL</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"live_url\" placeholder=\"\" value=\"{{vm.live_url}}\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Sharing URL</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"sharing-url\" placeholder=\"\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Referrer</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"referrer\" readonly=\"\" placeholder=\"\" value=\"{{vm.content_referrer}}\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Geoblocking</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"geoblock\" placeholder=\"Countries Code allowed (optional), example AR,US\" value=\"{{vm.geoblock}}\"></div></div></div><div class=\"col-md-6\"><div class=\"row clearfix\"><i class=\"fa fa-scissors fa-2x\" aria-hidden=\"true\" ng-click=\"vm.openClippingModal()\" style=\"right: 70px; position: absolute; top: 10px; color: white;\"></i><iframe id=\"iframe-content\" src=\"\" frameborder=\"0\" allowfullscreen=\"\" width=\"100%\" height=\"390px\" scrolling=\"no\"></iframe></div><div class=\"form-group row clearfix\" style=\"font-weight: bold;\"><div class=\"col-sm-6\"><i class=\"fa fa-eye fa-2x\" aria-hidden=\"true\"></i>&nbsp&nbsp{{impressions}}&nbsp&nbsp&nbsp&nbsp <i class=\"fa fa-play-circle-o fa-2x\" aria-hidden=\"true\"></i>&nbsp&nbsp{{plays}}&nbsp&nbsp&nbsp&nbsp &nbsp;&nbsp;<br><br><strong>Advertising</strong><br><br><strong>Preroll</strong>: {{preroll}}<br><strong>Midroll</strong>: {{midroll}}<br><strong>Postroll</strong>: {{postroll}}</div><div class=\"col-sm-3 pull-right\"><md-select ng-model=\"vm.selected_download_link\" ng-change=\"vm.downloadUrl()\" ng-if=\"vm.info.content_type != \'youtube\' && vm.info.content_type != \'live\' && vm.info.download_url && vm.info.status != \'disabled\'\" placeholder=\"Download Links\"><md-option ng-repeat=\"download in vm.info.download_url\" value=\"{{download.link}}\">{{download.quality}}</md-option></md-select></div></div></div></div></div><div class=\"panel-content\" style=\"min-height: 100px;\"><h3 class=\"with-line\">More</h3><div><div class=\"row\"><div class=\"col-lg-6 pull-right\"><button class=\"accordion\">History</button><div class=\"barra\"><section id=\"cd-timeline\" class=\"cd-container cssanimations\"><div class=\"cd-timeline-block\" ng-repeat=\"history in vm.historial\"><div class=\"cd-timeline-img\"><i class=\"{{history.icon}}\" aria-hidden=\"true\"></i></div><div class=\"cd-timeline-content primary\"><h5>{{history.title}}</h5><p>{{history.description}}</p><span class=\"cd-date\">{{history.date}}</span></div></div><center><button id=\"more-results\" class=\"btn btn-invert\" style=\"position:relative;z-index: 99999;!important\" ng-click=\"vm.bringMoreHistory()\">Load More</button></center></section></div></div><div class=\"col-lg-6\"><button class=\"accordion\">Comscore</button><div class=\"barra\"><form><div ng-repeat=\"item in vm.comscore\"><div class=\"form-group row clearfix\"><div class=\"col-sm-12\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">{{item.key}}</label><div class=\"col-sm-6\"><input id=\"{{item.key}}\" type=\"text\" class=\"form-control comscore-values\" value=\"{{item.value}}\"></div><label class=\"col-sm-3 control-label\" ng-if=\"item.description != \'\'\">({{item.description}})</label></div></div></div></div></form></div></div></div></div></div></div><div id=\"botonera\" ng-if=\"!vm.error\"><button type=\"button\" id=\"delete-item\" class=\"btn btn-danger pull-left btn-with-icon delete-content pull-right\"><i class=\"ion-android-checkmark-circle\"></i>Delete</button> <button type=\"button\" id=\"save-changes\" class=\"btn btn-primary btn-with-icon save-content pull-right\"><i class=\"ion-android-checkmark-circle\"></i>Save Changes</button> <a type=\"button\" id=\"cancel\" class=\"btn btn-danger pull-right cancel\" style=\"margin-right: 12px\">Cancel</a></div><div ng-if=\"vm.error\"><a id=\"ErrorCancel\" type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.back()\">Cancel</a></div></div>");
$templateCache.put("app/pages/content/mediaContent/manualPlaylistModal.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Playlist Name</h4></div><div class=\"modal-body\" style=\"min-height: 150px;\"><div class=\"col-lg-12\"><input type=\"text\" name=\"playlistManual-name\" ng-model=\"playlistName\" class=\"form-control\" placeholder=\"Insert a name for this playlist\"></div><div class=\"col-lg-12\"><select id=\"publishers_select\" ng-model=\"publisher_selected\" style=\"margin-top: 13px;\"><option value=\"\">Select a publisher</option><option ng-repeat=\"pub in publishers\" value=\"{{pub.id}}\">{{pub.value}}</option></select><span id=\"no_publisher_message\" class=\"help-block sub-little-text\" style=\"color:red; display:none\">please select a publisher</span></div></div><div class=\"modal-footer\"><button id=\"close-modal-playlist\" type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancel</button> <button id=\"submit\" class=\"btn btn-primary\" ng-click=\"createPlaylist(playlistName);\">Submit</button></div>");
$templateCache.put("app/pages/content/mediaContent/mediaContent.html","<style type=\"text/css\">\n  .table_footer{\n    top: 0px;\n    position: relative;\n    right: -16px;\n  }\n  #loading{\n    left: auto;\n    position: absolute;\n    right: 52%;\n    top: 200px;\n  }\n  #select-category{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 119px;\n  }\n  #ErrorCategory{\n    left: auto;\n    position: absolute;\n    right: 34%;\n    top: 189px;\n  }\n  #selectPartnerText{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 97px;\n  }\n\n  .inner-addon {\n    position: relative;\n  }\n\n  /* style icon */\n  .inner-addon .glyphicon {\n    position: absolute;\n    padding: 10px;\n    pointer-events: none;\n  }\n  .table{\n    background: white;\n  }\n  /* align icon */\n  .left-addon .glyphicon  { left:  0px;}\n  .right-addon .glyphicon { right: 0px;}\n\n  /* add padding  */\n  .left-addon input  { padding-left:  30px; }\n  .right-addon input { padding-right: 30px; }\n  .table-header{padding-bottom: 15px;}\n  .action{\n    cursor: pointer;\n  }\n  .play-ico{\n    cursor: pointer;\n  }\n  #console{\n    margin-top: 10px;\n    height: 70px;\n    overflow-x: auto;\n    padding: 8px;\n    position: relative;\n    font-size: 16px;\n    font-family:Courier;\n    color: #CCCCCC;\n    background: #000000;\n    border: 3px double #CCCCCC;\n    padding: 10px;\n    top: 0px;\n  }\n  mark{\n    background-color: #96DDD6;\n  }\n  #noContent{\n    left: auto;\n    position: absolute;\n    right: 42%;\n    top: 189px;\n  }\n  img{\n    padding: 5px;\n  }\n  .size { position:relative }\n  .size .field {\n      font-family: inherit;\n      font-size: 1em;\n      transition: all 0.4s ease-in-out 0s;\n      width: 143px;\n      z-index: 999999999;\n  }\n  .size>ul.list {\n    background: #fff none repeat scroll 0 0;\n    border-radius: 5px;\n    box-shadow: 0 0 5px #999;\n    color: #333;\n    display: none;\n    list-style: outside none none;\n    margin: 0;\n    padding: 5px;\n    position: absolute;\n    left: 8%;\n    top: 31px;\n    width: 250px;\n    z-index: 99999 !important;\n  }\n  .size>ul.list li {\n    padding:10px;\n    border-bottom: solid 1px #ccc;\n    font-family: helvetica;\n    cursor: pointer;\n  }\n  .size>ul.list li:hover {\n    background:cadetblue; color:#fff;\n  }\n  .size>ul.list li:last-child { border:none }\n  .menu{\n    background: cadetblue;\n    border: 1px solid #dcdcdc;\n    height: 43px;\n    padding: 4px 0px;\n  }\n  .someSpace{\n    padding: 8px;\n  }\n  .custom-buttom{\n      text-shadow: 1px 1px 1px grey;\n      padding: 8px;\n      cursor: pointer;\n      color: white;\n  }\n  .custom-buttom:hover{\n    color: white;\n  }\n  @media (min-width: 641px) {\n    span.icon {display:none}\n    span.text {display:inline-block}\n  }\n  @media (max-width: 1600px) {\n      span.icon {display:inline-block}\n      span.text {display:none}\n      .magic-padding{\n         margin-right: 27px !important;\n      }\n  }\n  .playlist-sidebar{\n    background: white none repeat scroll 0 0;\n    border: 1px solid grey;\n    display: none;\n    height: 89%;\n    position: absolute;\n    right: -10px;\n    top: -70px;\n    width: 29%;\n    z-index: 99999999999;\n  }\n  .close-icon{\n    color: grey;\n  }\n  .close{\n    position: absolute;\n    right: 5px;\n    top: 5px;\n  }\n  .playlist-title{\n    color: #777777;\n    font-size: 16px;\n    position: absolute;\n    font-family: \"helvetica\";\n    padding: 9px 9px;\n  }\n  .playlist-content{\n      color: black;\n      height: 480px;\n      margin-top: 60px;\n      overflow-y: auto;\n      overflow-x: hidden;\n      padding: 5px;\n      position: relative;\n      top: 21px;\n      background: white;\n      border-radius: 15px;\n      margin-bottom: 11px;\n  }\n  .playlist-form{\n    position: absolute;\n    font-family: \"helvetica\";\n    padding: 26px;\n    margin-top: 35px;\n  }\n  .save-btn{\n     margin-right: 15px;\n  }\n  .playlist-header{\n    cursor: move;\n  }\n  .list-item{\n    list-style-type: none;\n    padding: 10px 0px;\n    left: 0px;\n    border-bottom: 1px solid rgba(128, 128, 128, 0.1);\n  }\n  .total-items{\n    left: 15px;\n    top: 9px;\n    position: relative;\n  }\n  .select_manual{\n    position: absolute;\n    left: 72px;\n    top: 6px;\n  }\n  .truncate {\n    display:inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #209e91;\n    font-size: 14px;\n    font-family: Roboto, sans-serif;\n  }\n  @media screen and (min-width: 1360px) {\n    .truncate {\n      width: 100px;\n    }\n  }\n  @media screen and (min-width: 1440px) {\n    .truncate {\n      width: 200px;\n    }\n  }\n  .tree-panel{\n    margin-bottom: 10px;\n    z-index: 999999;\n    height: 600px !important;\n    overflow-y: auto;\n    background: #fff;\n    padding: 15px;\n    border: 1px solid #cecccc;\n  }\n  .table{\n    position: relative;\n    left: 0px;\n    top: 0px;\n    overflow-y: auto;\n  }\n  #table-panel{\n    position: absolute;\n    height: 670px;\n    width: 100%;\n    left: 0px;\n  }\n\n  .spinner {\n      position: absolute;\n      z-index: 9999999999;\n      margin: 25% 50%;\n      animation: rotator 1.4s linear infinite;\n  }\n  @keyframes rotator {\n      0% {\n          transform: rotate(0deg);\n      }\n      100% {\n          transform: rotate(270deg);\n      }\n  }\n  .path {\n      stroke-dasharray: 187;\n      stroke-dashoffset: 0;\n      transform-origin: center;\n      animation: dash 1.4s ease-in-out infinite, colors 5.6s ease-in-out infinite;\n  }\n  @keyframes colors {\n      0% {\n          stroke: #4285f4;\n      }\n      25% {\n          stroke: #de3e35;\n      }\n      50% {\n          stroke: #f7c223;\n      }\n      75% {\n          stroke: #1b9a59;\n      }\n      100% {\n          stroke: #4285f4;\n      }\n  }\n  @keyframes dash {\n      0% {\n          stroke-dashoffset: 187;\n      }\n      50% {\n          stroke-dashoffset: 46.75;\n          transform: rotate(135deg);\n      }\n      100% {\n          stroke-dashoffset: 187;\n          transform: rotate(450deg);\n      }\n  }\n  .play-ico:focus{\n    outline: none;\n  }\n  .view-active{\n    border: 3px solid white;\n    padding: 2px;\n  }\n  .play-small-video{\n    font-size: 32px;\n    opacity: 0.80;\n    color: rgb(250, 250, 250);\n    left: -8px;\n    position: relative;\n  }\n  .circle-border{\n    cursor: pointer;\n    position: absolute;\n    opacity: 0.80;\n    color: rgba(250, 250, 250);\n    display: inline-block;\n    width: 20px;\n    border-radius: 60px;\n    box-shadow: 0px 0px 2px #888;\n    padding: 0.5em 1.6em;\n    border: 1px solid white;\n    top: 27px;\n    left: 80px;\n  }\n  div .panel.with-scroll.animated.zoomIn{\n    height: 690px;\n  }\n</style><div class=\"row\"><div class=\"menu\" style=\"margin-bottom: 20px;\"><div class=\"col-lg-3\"><div id=\"search\"><div class=\"inner-addon left-addon\"><i class=\"glyphicon glyphicon-search\"></i> <input id=\"search_media\" ng-model=\"search_media\" ng-change=\"searchItems()\" type=\"text\" class=\"form-control\" name=\"search_media\" placeholder=\"Search by id, name\"></div></div></div><div class=\"col-lg-1 someSpace\"><a ng-disabled=\"category_selected == 0\" id=\"refresh-content\" ng-click=\"loadFeeds(\'refresh\')\" class=\"custom-buttom\"><span class=\"text\"><i class=\"fa fa-refresh\" aria-hidden=\"true\"></i>&nbsp; Refresh</span> <span class=\"icon\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Refresh content\"><i class=\"fa fa-refresh\" aria-hidden=\"true\"></i></span></a></div><div class=\"col-lg-1 someSpace\"><div class=\"size\"><a class=\"field custom-buttom\"><span class=\"text\"><i class=\"fa fa-upload\" aria-hidden=\"true\"></i>&nbsp; Upload</span> <span class=\"icon\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Upload content\"><i class=\"fa fa-upload\" aria-hidden=\"true\"></i></span></a><ul class=\"list\"><li id=\"uploadVideo\" ng-click=\"upload(\'video\')\"><i class=\"ion-ios-videocam\"></i> &nbsp; Video</li><li id=\"uploadAudio\" ng-click=\"upload(\'audio\')\"><i class=\"fa fa-music\" aria-hidden=\"true\"></i> &nbsp; Audio</li><li id=\"uploadVideoYoutube\" ng-click=\"upload(\'youtube\')\"><i class=\"fa fa-youtube\" aria-hidden=\"true\"></i> &nbsp; Youtube Video</li><li id=\"uploadLive\" ng-click=\"upload(\'live\')\"><i class=\"fa fa-play\" aria-hidden=\"true\"></i> &nbsp; Live</li></ul></div></div><div class=\"col-lg-1 someSpace\"><a id=\"trash-category\" ng-click=\"deletedItems()\" class=\"custom-buttom\"><span class=\"text\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i> Trash</span> <span class=\"icon\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Show deleted content\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></span></a></div><div class=\"col-lg-1 someSpace\"><div class=\"size\"><a class=\"field custom-buttom\"><span class=\"text\"><i class=\"fa fa-bars\" aria-hidden=\"true\"></i>&nbsp; More &nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></span> <span class=\"icon\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"More Options\"><i class=\"fa fa-bars\" aria-hidden=\"true\"></i>&nbsp;&nbsp;<i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></span></a><ul class=\"list\"><li id=\"showManualPlaylist\" ng-if=\"addItemsPlaylist\" ng-click=\"showPlaylistSidebar()\"><i class=\"fa fa fa-eye\"></i> &nbsp; View playlist</li><li id=\"createPlaylist\" ng-if=\"createPlaylist\" ng-click=\"createPlaylist()\"><i class=\"fa fa-file-text-o\"></i> &nbsp; Create manual playlist</li><li id=\"editPlaylist\" ng-click=\"editPlaylist()\"><i class=\"fa fa-pencil\"></i> &nbsp; Edit manual playlist</li><li id=\"add2Playlist\" ng-if=\"addItemsPlaylist\" ng-click=\"addItems()\"><i class=\"fa fa-plus\"></i> &nbsp; Add items to playlist</li></ul></div></div><div class=\"col-lg-1 someSpace pull-right\"><a ng-click=\"changeView(\'box\')\" class=\"field custom-buttom\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Show in boxes\"><i id=\"list-box\" class=\"fa fa-th\"></i></a> <a ng-click=\"changeView(\'list\')\" class=\"field custom-buttom\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Show in lists\"><i id=\"list-view\" class=\"view-active fa fa-list-ul\"></i></a></div><div ng-if=\"playlists.length > 0\" class=\"magic-padding col-lg-2 pull-right\" style=\"top: 5px\"><select id=\"playlist_select\" ng-model=\"playListFilter\" ng-change=\"playlistFilter()\"><option ng-repeat=\"playlist in playlists\" selected=\"\" value=\"{{playlist.id}}\">{{playlist.name}}</option></select></div></div><div class=\"col-lg-3\"><div class=\"tree-panel\"><div id=\"treeCategories\" data-tree-id=\"treeCategories\" js-tree=\"dragConfig\" ng-model=\"dragData\" ng-click=\"selectNode($event)\"></div></div></div><div class=\"col-lg-9\"><div class=\"media-container\"><div class=\"row col-lg-12\" style=\"height: 600px;overflow-y:hidden;overflow-x:hidden;z-index: 999\"><div ng-if=\"loading\" ng-change=\"loading\" ng-model=\"loading\" id=\"loading\" class=\"text-center\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"custom-table\"><div ng-if=\"cssView == \'box\'\" id=\"table-panel\" class=\"tree-panel col-lg-9\" style=\"overflow-y: auto;\"><div ng-if=\"selectCategory && !loading && !search\" ng-model=\"selectCategory\" ng-change=\"selectCategory\" id=\"select-category\" class=\"text-center\"><h2>Please select a category...</h2></div><div ng-if=\"errorCategory\" ng-model=\"errorCategory\" ng-change=\"errorCategory\" id=\"ErrorCategory\" class=\"text-center\"><h2 ng-bind=\"errorCategory\"></h2></div><div ng-if=\"noContent\" ng-model=\"noContent\" ng-change=\"noContent\" id=\"noContent\" class=\"text-center\"><h2>No content found :(</h2></div><div ng-if=\"!loading\" ng-repeat=\"feed in feeds.feeds\"><div class=\"col-lg-3 col-xlg-2\"><div id=\"small-{{feed.entry_id}}\"></div><a class=\"markeable action\" ui-sref=\"content-edit({content_id: feed.entry_id, name: feed.name})\" title=\"{{feed.name}}\" style=\"text-decoration: none; cursor: pointer; color: #949494;\"><div id=\"small-image-{{feed.entry_id}}\" style=\"background: url({{feed.thumbnail}}) no-repeat center center; background-color: white; background-size: 100% 100%; margin-right: 15px; border: 1px solid black; height: 100px; width: 100%;\"><label style=\"width: 100%; padding: 2px; background: #0000005e; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color:white\"><strong>{{feed.entry_id}} - {{feed.name}}</strong></label></div></a><div id=\"play-small-video-{{feed.entry_id}}\" ng-click=\"showSmallVideo(feed.entry_id)\" class=\"circle-border\"><i class=\"play-small-video fa fa-play fa-3x\" aria-hidden=\"true\"></i></div><div id=\"information-{{feed.entry_id}}\" class=\"information\" style=\"margin-bottom: 15px; background: white; padding: 5px; border: 1px solid lightgrey;\"><a class=\"markeable action\" ui-sref=\"content-edit({content_id: feed.entry_id, name: feed.name})\" title=\"{{feed.name}}\" style=\"text-decoration: none; cursor: pointer; color: #949494;\"><span style=\"width: 11em;\">{{feed.created_at}}</span> Plays: {{feed.plays}}<br>Status: <span ng-style=\"feed.status == \'enabled\' ? {\'color\': \'green\'} : {\'color\' : \'red\'}\">{{feed.status}}</span><br>Duration: {{feed.duration}}</a><div class=\"select_action\" style=\"display: block;font-size: 1.5em;width: 2.9em;\"><i class=\"play-ico fa fa-line-chart\" aria-hidden=\"true\" ng-click=\"openModalContentGraph(feed.entry_id)\"></i> <i class=\"play-ico fa fa-play-circle-o\" aria-hidden=\"true\" ng-click=\"getVideoUrl(feed.entry_id)\"></i></div></div></div></div></div><div ng-if=\"cssView == \'list\'\"><div id=\"table-panel\" class=\"col-lg-9 tree-panel\"><table class=\"table table-bordered\"><thead ng-if=\"!loading\"><tr><th><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"select-all\" value=\"\"> <span></span></label></th><th class=\"table-id\">Media ID</th><th><center>Thumbnail</center></th><th>Name</th><th>Plays</th><th>Duration</th><th>Status</th><th><center>Type</center></th><th>Created At</th><th>Actions</th></tr></thead><tbody><div ng-if=\"selectCategory && !loading && !search\" ng-model=\"selectCategory\" ng-change=\"selectCategory\" id=\"select-category\" class=\"text-center\"><h2>Please select a category...</h2></div><div ng-if=\"errorCategory\" ng-model=\"errorCategory\" ng-change=\"errorCategory\" id=\"ErrorCategory\" class=\"text-center\"><h2 ng-bind=\"errorCategory\"></h2></div><div ng-if=\"noContent\" ng-model=\"noContent\" ng-change=\"noContent\" id=\"noContent\" class=\"text-center\"><h2>No content found :(</h2></div><tr ng-if=\"!loading\" ng-repeat=\"feed in feeds.feeds\"><td><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"checkbox-{{feed.entry_id}}\" class=\"content-item\" data-item=\"{{feed.entry_id}}&{{feed.name}}&{{feed.thumbnail}}\" value=\"\"> <span></span></label></td><td class=\"markeable table-id\">{{feed.entry_id}}</td><td ng-if=\"feed.thumbnail != S3ButcketThumbs + \'/audio.png\'\"><center><img ng-src=\"{{feed.thumbnail}}\" height=\"40px\" width=\"70px\"></center></td><td ng-if=\"feed.thumbnail == S3ButcketThumbs + \'/audio.png\'\"><center><img ng-src=\"{{feed.thumbnail}}\" height=\"40px\" width=\"47px\"></center></td><td><a class=\"markeable action\" ui-sref=\"content-edit({content_id: feed.entry_id, name: feed.name})\" title=\"{{feed.name}}\"><span class=\"truncate\">{{feed.name}}</span></a></td><td>{{feed.plays}}</td><td>{{feed.duration}}</td><td ng-style=\"feed.status == \'enabled\' ? {\'color\': \'green\'} : {\'color\' : \'red\'}\">{{feed.status}}</td><td><center><span ng-if=\"feed.content_type == \'video\'\"><i class=\"fa fa-video-camera\" aria-hidden=\"true\"></i></span> <span ng-if=\"feed.content_type == \'audio\'\"><i class=\"fa fa-music\" aria-hidden=\"true\"></i></span> <span ng-if=\"feed.content_type == \'youtube\'\"><i class=\"fa fa-youtube-play\" aria-hidden=\"true\"></i></span> <span ng-if=\"feed.content_type == \'live\'\"><i class=\"fa fa-play\" aria-hidden=\"true\"></i></span></center></td><td><span style=\"width: 11em;\">{{feed.created_at}}</span></td><td><div class=\"select_action\" style=\"display: block;font-size: 1.5em;width: 3.9em;margin-left: 0.6em;\"><i class=\"play-ico fa fa-line-chart\" aria-hidden=\"true\" ng-click=\"openModalContentGraph(feed.entry_id)\"></i> <i class=\"play-ico fa fa-cloud-download\" aria-hidden=\"true\" ng-click=\"downloadByApi(feed.entry_id)\"></i> <i class=\"play-ico fa fa-play-circle-o\" aria-hidden=\"true\" ng-click=\"getVideoUrl(feed.entry_id)\"></i></div></td></tr></tbody></table></div></div></div></div></div></div><div class=\"row pull-right\"><div ng-if=\"!loading && feeds.total > 0\" class=\"col-lg-3\"></div><div ng-if=\"!loading && feeds.total > 0\" class=\"col-lg-9 table_footer\"><div class=\"col-lg-9 pull-left\">Total Rows: {{feeds.total}} - Page: <span ng-bind=\"page\">{{page}}</span> of {{paginator}}</div><div class=\"col-lg-2 text-right\"><div id=\"paginator\"><div class=\"input-group number-spinner\"><span class=\"input-group-btn data-dwn\"><button class=\"btn btn-default\" ng-click=\"down()\"><span class=\"glyphicon glyphicon-minus\"></span></button></span> <input type=\"text\" class=\"form-control text-center\" ng-model=\"page\" value=\"{{page}}\" min=\"1\" max=\"{{paginator}}\" width=\"60px\" readonly=\"\" style=\"color:grey;\"> <span class=\"input-group-btn data-up\"><button class=\"btn btn-default\" ng-click=\"up()\"><span class=\"glyphicon glyphicon-plus\"></span></button></span></div></div></div></div></div></div><div id=\"playlist-window\" class=\"playlist-sidebar\"><div class=\"playlist-header\"><div class=\"playlist-title\"><strong>Playlist</strong></div><span class=\"select_manual\" ng-if=\"manual_playListFilter.length > 0 && editManual\"><select id=\"manual_playlist_select\" ng-model=\"pl_manual_filter\" ng-change=\"ManualPlaylistFilter()\"><option ng-repeat=\"playlist in manual_playListFilter\" selected=\"\" value=\"{{playlist.id}}\">{{playlist.name}}</option></select></span><div class=\"playlist-form\"><div class=\"form-group row clearfix\"><div class=\"col-lg-6\"><input type=\"text\" class=\"form-control\" id=\"playlist-name\" placeholder=\"Playlist Name\" ng-model=\"playlist_name\" ng-change=\"updateName()\" value=\"{{playlist_name}}\"></div><div class=\"col-lg-6\"><input type=\"text\" class=\"form-control\" ng-model=\"playlist_description\" ng-change=\"updateDesc()\" id=\"playlist-description\" placeholder=\"Playlist description\" value=\"\"></div></div></div><br><div class=\"close\" ng-click=\"hidePlaylistSidebar()\"><i class=\"close-icon fa fa-times\" aria-hidden=\"true\"></i></div></div><br><div id=\"dxy\" class=\"playlist-content\"><div class=\"items-container\" ng-if=\"manual_playlist.items.length > 0\"><br><br><div class=\"items row\"><ul ng-model=\"manual_playlist.items\" ui-sortable=\"sortableOptions\"><li class=\"list-item row\" ng-repeat=\"item in manual_playlist.items\" data-id=\"{{item.id}}\"><span class=\"col-lg-3\"><img ng-src=\"{{item.thumbnail}}\" height=\"40px\" width=\"70px\"></span> <span class=\"col-lg-6\" style=\"top:9px\"><i>{{item.name}}</i></span> <span class=\"col-lg-3\" style=\"top:9px\"><a ng-click=\"removeItem({{item.id}})\" style=\"cursor: pointer;\"><i class=\"fa fa-eraser\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Remove Item\" style=\"color: grey\"></i></a></span></li></ul></div></div></div><br><span class=\"total-items\">Total: <label ng-bind=\"manual_playlist.items.length\"></label></span> <button class=\"save-btn btn btn-primary pull-right\" ng-click=\"savePlaylist()\" ng-if=\"!editManual\"><i class=\"fa fa-check-circle-o\" aria-hidden=\"true\"></i>&nbsp;Save</button> <button class=\"save-btn btn btn-primary pull-right\" ng-click=\"editPlaylistSave()\" ng-if=\"editManual\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>&nbsp;Save</button> <button class=\"save-btn btn btn-danger pull-right\" ng-click=\"hidePlaylistSidebar()\"><i class=\"fa fa-times-circle-o\" aria-hidden=\"true\"></i>&nbsp;Close</button> <button class=\"save-btn btn btn-info pull-right\" ng-click=\"addItems()\" ng-if=\"addItemsPlaylist\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i>&nbsp;Add</button></div><div class=\"col-lg-12\"><div id=\"console\">Console: Waiting for upload..</div></div><script type=\"text/javascript\">\n    $( function() {\n      $( \"#playlist-window\" ).draggable();\n    });\n</script><div class=\"modal fade\" id=\"ManualPlaylist\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">Manual Playlist Name</h4></div><div class=\"modal-body\"><input type=\"text\" name=\"playlist-manual-title\" class=\"form-control\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button> <button type=\"button\" class=\"btn btn-primary\">Save changes</button></div></div></div></div>");
$templateCache.put("app/pages/content/mediaContent/videoModal.html","<style type=\"text/css\">\n  .loading {\n      position: relative;\n      top: 42px;\n  }\n  #video_player{\n    padding-bottom: 26px;\n  }\n  .clipboard-btn{\n    position: absolute;\n    right: 41px;\n    top: -5px;\n  }\n  .modal-content {\n    margin-top: 60px;\n  }\n  .modal-body{\n    padding: 0px !important;\n  }\n  .btn-custom {\n    background: rgb(32, 158, 145) none repeat scroll 0 0;\n    border: 1px solid rgb(32, 158, 145);\n    border-radius: 5px;\n    color: white;\n    font-family: helvetica;\n    padding: 8px;\n    width: 147px;\n  }\n  .btn-custom:hover{\n     background: rgb(16,79,72);\n  }\n  .custom {\n    left: 5%;\n    margin-top: 25px;\n  }\n  .screen{\n    background: black;\n  }\n  pre code{\n    left: -144px !important;\n    position: relative;\n  }\n  .md-button{\n    min-height: 30px;\n    line-height: 32px;\n  }\n  .md-select-menu-container {\n    z-index: 9999;\n  }\n  #contentIframe {\n    width: 100%;\n    height: 499px;\n  }\n</style><div ng-controller=\"ContentModalCtrl\" class=\"modal-content\"><div class=\"modal-body\"><span hidden=\"\" id=\"entryId\"></span> <span hidden=\"\" id=\"partnerId\"></span> <span hidden=\"\" id=\"title-video\"></span><div class=\"screen col-lg-12\"><center><iframe id=\"contentIframe\" ng-model=\"contentUri\" ng-change=\"contentUri\" src=\"\" frameborder=\"0\" allowfullscreen=\"\" scrolling=\"no\" style=\"margin-top: 10px;\"></iframe></center></div><div ng-show=\"loading\" class=\"loading row\"><center><img height=\"60px\" src=\"assets/img/app/loading.gif\"></center></div><hr><br><br><div class=\"row\"><div class=\"custom col-lg-11\"><div class=\"row head-container\"><div class=\"col-lg-11 pull-left\"><h2>Code Embed<h2></h2></h2></div><div class=\"clipboard-btn col-lg-1 pull-right\"><md-button id=\"clipboard-copy\" ng-model=\"html\" data-clipboard-text=\"{{html}}\" aria-label=\"clipboard\" class=\"md-raised md-primary\" style=\"right: 16px\"><span style=\"color: white;\">Copy code</span></md-button></div></div><br><div class=\"row\"><div class=\"col-lg-12\"><md-switch id=\"switch\" aria-label=\"Widescreen/Vertical\" ng-model=\"widescreen\" ng-change=\"switchAspect()\">Widescreen / Vertical</md-switch></div><div class=\"col-lg-12\"><div class=\"code-html\"><pre>\n                    <code class=\"html-embebed language-javascript\"></code>\n                  </pre></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-lg-3 pull-left\" style=\"text-align: left; margin-left: 20px;\"><label>Select Player</label><md-select ng-model=\"selectedPlayer\" id=\"players-choise\" ng-change=\"renderCustomPlayer()\" aria-label=\"player-selection\"><md-option ng-repeat=\"player in players\" value=\"{{player.id}}\">{{player.name}}</md-option></md-select></div><md-button ng-disabled=\"loading\" ng-click=\"generatePageView()\" class=\"md-raised md-primary\" style=\"top: 34px; right: 10px;\" aria-label=\"page-view\"><span style=\"color: white;\">Page View</span></md-button></div></div>");
$templateCache.put("app/pages/content/upload/upload.html","<style type=\"text/css\">\n  .bootstrap-tagsinput > input {\n    border: none;\n  }\n  #save-changes{\n    bottom: -54px;\n    position: absolute;\n    right: 1px;\n  }\n  .btn-thumb{\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n  }\n  .list{\n    float: left;\n    display: block;\n    text-align: center;\n    text-decoration: none;\n    padding-left: 20px;\n  }\n  .botonera{\n    position: relative;\n    bottom: 0px;\n  }\n  .close {\n    position: absolute !important;\n    right: 22px !important;\n    top: 17px !important;\n  }\n  #content-display{\n    width: auto;\n    height: 300px;\n  }\n  .md-label {\n      color: black !important;\n  }\n  .transcoder-options {\n    position: relative;\n    width: 432px;\n    padding-top: 23px;\n    left: 230px;\n  }\n  #uploader {\n    top: 14px;\n    position: relative;\n    left: 12px;\n  }\n</style><div ng-controller=\"UploadCtrl as vm\" class=\"modal-content\"><div ng-if=\"upload_type == \'video\'\"><style type=\"text/css\">\n        .modal-content{\n            margin-top: 60px;\n        }\n        .progress-bar {\n            position: relative;\n            background-color: #1a1a1a;\n            height: 30px;\n            padding: 5px;\n            width: 100%;\n            margin: 50px 0;         \n            border-radius: 5px;\n            box-shadow: 0 1px 5px #000 inset, 0 1px 0 #444;\n            bottom: 0px;\n        }\n\n        .progress-bar span {\n            display: inline-block;\n            height: 100%;\n            border-radius: 3px;\n            box-shadow: 0 1px 0 rgba(255, 255, 255, .5) inset;\n            transition: width .4s ease-in-out;    \n        }\n        .blue span {\n            background-color: #34c2e3;   \n        }\n        .stripes span {\n            background-size: 30px 30px;\n            background-image: linear-gradient(135deg, rgba(255, 255, 255, .15) 25%, transparent 25%,\n                                transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%,\n                                transparent 75%, transparent);            \n            \n            animation: animate-stripes 3s linear infinite;             \n        }\n\n        @keyframes animate-stripes {\n            0% {background-position: 0 0;} 100% {background-position: 60px 0;}\n        }\n      </style><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"cancel()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Upload your files</h4></div><div class=\"modal-body\" style=\"min-height: 400px;\"><div class=\"col-lg-12\"><div class=\"alert alert-warning\"><strong>Warning!</strong> Please do not close this modal till the upload finished!</div></div><div class=\"col-lg-12\"><table class=\"table table-bordered\" style=\"overflow: hidden;\"><thead><tr><th>File</th><th>Size</th><th>Type</th></tr></thead><tbody><tr ng-repeat=\"file in vm.files\"><td>{{file.name}}</td><td>{{(file.size / 1000000).toFixed(1)}} MB</td><td>{{file.type}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><div class=\"progress-bar blue stripes\" ng-model=\"vm.progress\" ng-if=\"vm.progress\"><span id=\"progress-line\">0%</span></div><form id=\"files-form\" class=\"botonera pull-left\"><input id=\"uploader\" type=\"file\" onchange=\"angular.element(this).scope().updateFiles()\" accept=\"video/*\"></form><md-button id=\"close-modal\" ng-disabled=\"loading\" class=\"botonera md-raised md-warn\" ng-click=\"cancel()\">Cancel</md-button><md-button id=\"uploadBtn\" ng-disabled=\"loading\" class=\"botonera md-raised md-primary\" ng-click=\"uploadFiles()\">Upload</md-button></div></div><div ng-if=\"upload_type == \'youtube\'\"><style type=\"text/css\">\n        .modal{\n          margin-top: 83px;\n        }\n        #tags{\n          color: white;\n        }\n        .label-info {\n          color: white !important;\n        }\n    </style><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button></div><div class=\"modal-body\"><div class=\"col-lg-12\"><div><div><h3 class=\"with-line\">Create Youtube Content</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"media-name\" placeholder=\"Please insert a name...\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Description</label><div class=\"col-sm-9\"><textarea class=\"form-control\" id=\"media-description\" placeholder=\"Please insert a description...\" value=\"\"></textarea></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tags</label><div class=\"col-sm-9\"><input id=\"tags\" type=\"text\" value=\"\" data-role=\"tagsinput\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Owner Categories</label><div class=\"col-sm-9\"><select id=\"categories\" ng-model=\"vm.categories_selected\" data-placeholder=\"Choose a category...\" width=\"100%\" class=\"form-control chosen-select\"></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Youtube URL</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"media-mediaUrl\" ng-model=\"vm.mediaUrl\" ng-change=\"vm.checkYoutubeVideo()\" placeholder=\"Youtube Url\"></div></div></div><div id=\"yt-display\" class=\"videojsIntance row col-md-6\"></div></div></div><div class=\"panel-content\"></div><div class=\"pull-right\"><button id=\"close-modal\" type=\"button\" class=\"btn btn-danger\" ng-disabled=\"loading\" ng-click=\"$dismiss()\">Cancel</button> <button id=\"createYoutube\" class=\"btn btn-primary\" ng-click=\"vm.validateData(\'youtube\')\">Create</button></div></div></div></div><div class=\"modal-footer\"></div></div><div ng-if=\"upload_type == \'live\'\"><style type=\"text/css\">\n        .modal{\n          margin-top: 83px;\n        }\n        #tags{\n          color: white;\n        }\n        .label-info {\n          color: white !important;\n        }\n    </style><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button></div><div class=\"modal-body\"><div class=\"col-lg-12\"><div class=\"panel-content\"><h3 class=\"with-line\">Live Stream</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"media-name\" placeholder=\"Please insert a name...\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Description</label><div class=\"col-sm-9\"><textarea class=\"form-control\" id=\"media-description\" placeholder=\"Please insert a description...\" value=\"\"></textarea></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tags</label><div class=\"col-sm-9\"><input id=\"tags\" type=\"text\" value=\"\" data-role=\"tagsinput\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Owner Categories</label><div class=\"col-sm-9\"><select id=\"categories\" ng-model=\"vm.categories_selected\" data-placeholder=\"Choose a category...\" width=\"100%\" class=\"form-control chosen-select\"></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Manifest</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"media-mediaUrl\" ng-model=\"vm.mediaUrl\" ng-change=\"vm.checkM3u8()\" placeholder=\"Example: https://<url>/playlist.m3u8\" value=\"\"></div></div></div><div class=\"videojsIntance col-md-6\"><video id=\"content-display\" class=\"video-js vjs-default-skin\" controls=\"\" data-setup=\'{ \"techOrder\": [\"html5\"]}\' style=\"display: none\"></video></div></div></div><div class=\"panel-content\"></div><div class=\"pull-right\"><button id=\"close-modal\" type=\"button\" class=\"btn btn-danger\" ng-disabled=\"loading\" ng-click=\"$dismiss()\">Cancel</button> <button id=\"createLive\" class=\"btn btn-primary\" ng-click=\"vm.validateData(\'live\')\">Create</button></div></div></div><div class=\"modal-footer\"></div></div><div ng-if=\"upload_type == \'audio\'\"><style type=\"text/css\">\n        .modal{\n          margin-top: 83px;\n        }\n        #tags{\n          color: white;\n        }\n        .label-info {\n          color: white !important;\n        }\n    </style><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"cancel()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button></div><div class=\"modal-body\"><div class=\"col-lg-12\"><div ba-panel=\"\" ba-panel-class=\"content-page\"><div class=\"panel-content\"><h3 class=\"with-line\">Upload Audio Content</h3><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"media-name\" placeholder=\"Please insert a name...\" value=\"\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Description</label><div class=\"col-sm-9\"><textarea class=\"form-control\" id=\"media-description\" placeholder=\"Please insert a description...\" value=\"\"></textarea></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Tags</label><div class=\"col-sm-9\"><input id=\"tags\" type=\"text\" value=\"\" data-role=\"tagsinput\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Owner Categories</label><div class=\"col-sm-9\"><select id=\"categories\" ng-model=\"vm.categories_selected\" data-placeholder=\"Choose a category...\" width=\"100%\" class=\"form-control chosen-select\"></select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Upload</label><div class=\"col-sm-6\"><form id=\"audio-form\"><center><input id=\"uploaderAudio\" type=\"file\" accept=\"audio/*\"></center></form></div></div></div><div class=\"col-md-4\"><div ng-show=\"loading\" class=\"loading row\" style=\"margin-top: 89px\"><center><img height=\"60px\" src=\"assets/img/app/loading.gif\"></center></div></div></div></div><div class=\"panel-content\"></div><div class=\"pull-right\"><button id=\"close-modal\" type=\"button\" class=\"btn btn-danger\" ng-click=\"cancel()\">Cancel</button> <button id=\"createAudio\" class=\"btn btn-primary\" ng-disabled=\"loading\" ng-click=\"uploadAudio()\">Upload</button></div></div></div></div><div class=\"modal-footer\"></div></div></div><script src=\"https://static.vodgc.net/libs/videojs5-hlsjs-source-handler/videojs5-hlsjs-source-handler.js\"></script>");
$templateCache.put("app/theme/components/backTop/backTop.html","<i class=\"fa fa-angle-up back-top\" id=\"backTop\" title=\"Back to Top\"></i>");
$templateCache.put("app/theme/components/contentTop/contentTop.html","<div class=\"content-top clearfix\"><h1 class=\"al-title\">{{ activePageTitle }}</h1></div>");
$templateCache.put("app/theme/components/baSidebar/ba-sidebar.html","<aside class=\"al-sidebar\" ng-swipe-right=\"$baSidebarService.setMenuCollapsed(false)\" ng-swipe-left=\"$baSidebarService.setMenuCollapsed(true)\" ng-mouseleave=\"hoverElemTop=selectElemTop\"><ul class=\"al-sidebar-list\" slimscroll=\"{height: \'{{menuHeight}}px\'}\" slimscroll-watch=\"menuHeight\"><li ng-repeat=\"item in ::menuItems\" class=\"al-sidebar-list-item\" ng-class=\"::{\'with-sub-menu\': item.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"item\"><a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"item.stateRef || \'\'\" ng-href=\"{{::(item.fixedHref ? item.fixedHref: \'\')}}\" ng-if=\"::!item.subMenu\" class=\"al-sidebar-list-link\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::item.subMenu\" class=\"al-sidebar-list-link\" ba-ui-sref-toggler=\"\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span> <b class=\"fa fa-angle-down\" ui-sref-active=\"fa-angle-up\" ng-if=\"::item.subMenu\"></b></a><ul ng-if=\"::item.subMenu\" class=\"al-sidebar-sublist\" ng-class=\"{\'slide-right\': item.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-repeat=\"subitem in ::item.subMenu\" ng-class=\"::{\'with-sub-menu\': subitem.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"subitem\" class=\"ba-sidebar-sublist-item\"><a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::subitem.subMenu\" ba-ui-sref-toggler=\"\" class=\"al-sidebar-list-link subitem-submenu-link\"><span>{{ ::subitem.title }}</span> <b class=\"fa\" ng-class=\"{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}\" ng-if=\"::subitem.subMenu\"></b></a><ul ng-if=\"::subitem.subMenu\" class=\"al-sidebar-sublist subitem-submenu-list\" ng-class=\"{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-mouseenter=\"hoverItem($event, item)\" ng-repeat=\"subSubitem in ::subitem.subMenu\" ui-sref-active=\"selected\"><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::subSubitem.disabled\" class=\"al-sidebar-list-link\">{{ ::subSubitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"subSubitem.stateRef || \'\'\" ng-if=\"::!subSubitem.disabled\" ng-href=\"{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}\">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::(!subitem.subMenu && subitem.disabled)\" class=\"al-sidebar-list-link\">{{ ::subitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" target=\"{{::(subitem.blank ? \'_blank\' : \'_self\')}}\" ng-if=\"::(!subitem.subMenu && !subitem.disabled)\" ui-state=\"subitem.stateRef || \'\'\" ng-href=\"{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}\">{{ ::subitem.title}}</a></li></ul></li></ul><div class=\"sidebar-hover-elem\" ng-style=\"{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}\" ng-class=\"{\'show-hover-elem\': showHoverElem }\"></div></aside>");
$templateCache.put("app/theme/components/msgCenter/msgCenter.html","<ul class=\"al-msg-center clearfix hide\"><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-bell-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Notifications</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in notifications\"><div class=\"img-area\"><img ng-class=\"{\'photo-msg-item\' : !msg.image}\" ng-src=\"{{::( msg.image || (users[msg.userId].name | profilePicture) )}}\"></div><div class=\"msg-area\"><div ng-bind-html=\"getMessage(msg)\"></div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all notifications</a></div></li><li uib-dropdown=\"\"><a href=\"\" class=\"msg\" uib-dropdown-toggle=\"\"><i class=\"fa fa-envelope-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Messages</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in messages\"><div class=\"img-area\"><img class=\"photo-msg-item\" ng-src=\"{{::( users[msg.userId].name | profilePicture )}}\"></div><div class=\"msg-area\"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all messages</a></div></li></ul>");
$templateCache.put("app/theme/components/pageTop/pageTop.html","<style type=\"text/css\">\n  .top-dropdown-menu.profile-dropdown{\n    width: 300px !important;\n  }\n  .welcome-user {\n    color: white;\n    font-family: helvetica;\n    font-size: 12px;\n    padding-right: 15px;\n    position: relative;\n    top: 16px;\n  }\n  .system-hour{\n    color: white;\n    font-family: helvetica;\n    font-size: 12px;\n    padding-right: 15px;\n    position: relative;\n    top: 16px;\n    z-index: 999999999;\n  }\n  #grupos_selection{\n    position: absolute;\n    right: 293px;\n    top: 21px;\n    border: 3px solid grey;\n    border-radius: 4px;\n    padding: 3px;\n    background: orange;\n    color: white;\n    max-width: 100px;\n  }\n</style><div class=\"page-top clearfix\" scroll-position=\"scrolled\" max-height=\"50\" ng-class=\"{\'scrolled\': scrolled}\"><a href=\"#/dashboard\" class=\"al-logo clearfix\"><img src=\"assets/img/tv-logo.png\" height=\"46px\" style=\"top: -2px;position: relative\"><span style=\"color: white; font-family: helvetica\">Genoa</span></a> <a href=\"\" class=\"collapse-menu-link ion-navicon\" ba-sidebar-toggle-menu=\"\"></a><div ng-controller=\"LoginCtrl as vm\" class=\"user-profile clearfix\"><select id=\"grupos_selection\" ng-if=\"session.email == \'damo@artear.com\' || session.email == \'jbrenman@artear.com\' || session.email == \'cmiranda@artear.com\' || session.email == \'jlowenstern@artear.com\'\" ng-options=\"gp.id as gp.name for gp in vm.groups\" ng-model=\"vm.selected_group\" ng-change=\"vm.changeAccount()\" ng-selected=\"gp.id == session.group_id\"></select><a href=\"#!/profile\"><span class=\"welcome-user\">Welcome {{session.name}}</span></a> <a><span class=\"system-hour\"></span></a><div class=\"al-user-profile\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" class=\"profile-toggle-link\"><img ng-src=\"assets/img/theme/no-photo.png\"></a><ul class=\"top-dropdown-menu profile-dropdown\" uib-dropdown-menu=\"\"><li><a href=\"#!/profile\" style=\"cursor: pointer;\"><i class=\"fa fa-user\"></i> <span style=\"color:grey\">{{session.email}}</span></a></li><li><a style=\"cursor: pointer;\"><i class=\"fa fa-users\" aria-hidden=\"true\"></i> <span style=\"color:grey\">{{session.group_name}}</span></a></li><li ng-if=\"session.user_profile == 2\"><a href=\"https://doc.vodgc.net/books/api/page/api-v1\" target=\"_blank\" style=\"cursor: pointer;\"><i class=\"fa fa-book\" aria-hidden=\"true\"></i> <span style=\"color:grey\" ng-model=\"session.user_profile\">Documentation</span></a></li><li><a href=\"https://app.status.io/pages/56fc21d18dda369f03000ffb\" target=\"_blank\" style=\"cursor: pointer;\"><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i> <span style=\"color:grey\">Status</span></a></li><li><i class=\"dropdown-arr\"></i></li><li ng-click=\"vm.logout()\"><a href=\"\" class=\"signout\"><i class=\"fa fa-power-off\"></i>Sign out</a></li></ul></div><msg-center></msg-center></div></div>");
$templateCache.put("app/theme/components/widgets/widgets.html","<div class=\"widgets\"><div ng-repeat=\"widgetBlock in ngModel\" ng-class=\"{\'row\': widgetBlock.widgets.length > 1}\"><div ng-repeat=\"widgetCol in widgetBlock.widgets\" ng-class=\"{\'col-md-6\': widgetBlock.widgets.length === 2}\" ng-model=\"widgetCol\" class=\"widgets-block\"><div ba-panel=\"\" ba-panel-title=\"{{::widget.title}}\" ng-repeat=\"widget in widgetCol\" ba-panel-class=\"with-scroll {{widget.panelClass}}\"><div ng-include=\"widget.url\"></div></div></div></div></div>");
$templateCache.put("app/theme/components/baWizard/baWizard.html","<div class=\"ba-wizard\"><div class=\"ba-wizard-navigation-container\"><div ng-repeat=\"t in $baWizardController.tabs\" class=\"ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}\" ng-click=\"$baWizardController.selectTab($index)\">{{t.title}}</div></div><div class=\"progress ba-wizard-progress\"><div class=\"progress-bar progress-bar-danger active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: $baWizardController.progress + \'%\'}\"></div></div><div class=\"steps\" ng-transclude=\"\"></div><nav><ul class=\"pager ba-wizard-pager\"><li class=\"previous\"><button ng-disabled=\"$baWizardController.isFirstTab()\" ng-click=\"$baWizardController.previousTab()\" type=\"button\" class=\"btn btn-primary\"><span aria-hidden=\"true\">&larr;</span> previous</button></li><li class=\"next\"><button ng-disabled=\"$baWizardController.isLastTab()\" ng-click=\"$baWizardController.nextTab()\" type=\"button\" class=\"btn btn-primary\">next <span aria-hidden=\"true\">&rarr;</span></button></li></ul></nav></div>");
$templateCache.put("app/theme/components/baWizard/baWizardStep.html","<section ng-show=\"selected\" class=\"step\" ng-transclude=\"\"></section>");
$templateCache.put("app/pages/components/mail/composeBox/compose.html","<div class=\"compose-header\"><span>New message</span> <span class=\"header-controls\"><i class=\"ion-minus-round\"></i> <i class=\"ion-arrow-resize\"></i> <i ng-click=\"$dismiss()\" class=\"ion-close-round\"></i></span></div><div><input type=\"text\" class=\"form-control compose-input default-color\" placeholder=\"To\" ng-model=\"boxCtrl.to\"> <input type=\"text\" class=\"form-control compose-input default-color\" placeholder=\"Subject\" ng-model=\"boxCtrl.subject\"><div class=\"compose-container\"><text-angular-toolbar ta-toolbar-class=\"toolbarMain\" name=\"toolbarMain\" ta-toolbar=\"[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\']]\"></text-angular-toolbar><text-angular name=\"htmlcontent\" ta-target-toolbars=\"toolbarMain,toolbarFooter\" ng-model=\"boxCtrl.text\"></text-angular></div></div><div class=\"compose-footer clearfix\"><button type=\"button\" ng-click=\"$dismiss()\" class=\"btn btn-send\">Send</button><text-angular-toolbar ta-toolbar-class=\"toolbarFooter\" name=\"toolbarFooter\" ta-toolbar=\"[[\'insertLink\', \'insertImage\', \'html\', \'quote\',\'insertVideo\']]\"></text-angular-toolbar><div class=\"footer-controls\"><i class=\"footer-control-first compose-footer-icon ion-arrow-down-b\"></i> <i ng-click=\"$dismiss()\" class=\"compose-footer-icon ion-android-delete\"></i></div></div>");
$templateCache.put("app/pages/components/mail/detail/mailDetail.html","<div class=\"message-container\" ng-class=\"{\'expanded\': tabCtrl.navigationCollapsed}\"><div class=\"message\"><div class=\"row\"><div class=\"toggle-navigation-container detail-page\"><a href=\"\" class=\"collapse-navigation-link ion-navicon\" ng-click=\"tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed\"></a></div><button ui-sref=\"components.mail.label({label : detailCtrl.label})\" type=\"button\" class=\"back-button btn btn-default btn-with-icon\"><i class=\"ion-chevron-left\"></i>Back</button></div><div class=\"person-info row\"><div class=\"col-lg-4 col-md-12 no-padding\"><img ng-src=\"{{detailCtrl.mail.name.split(\' \')[0] | profilePicture}}\" class=\"human-picture\"><div class=\"name\"><h2 class=\"name-h\">{{detailCtrl.mail.name.split(\' \')[0]}}</h2><h2 class=\"name-h second-name\">{{detailCtrl.mail.name.split(\' \')[1]}}</h2><div><span class=\"mail-tag tag label {{detailCtrl.mail.tag}}\">{{detailCtrl.mail.tag}}</span></div></div></div><div class=\"col-lg-4 col-md-6 col-xs-12 no-padding\"><div class=\"contact-info phone-email\"><div><i class=\"ion-iphone\"></i> <span class=\"phone\">777-777-7777</span></div><div><i class=\"ion-email\"></i> <span class=\"email\">{{detailCtrl.mail.email}}</span></div></div></div><div class=\"col-lg-4 col-md-6 col-xs-12 no-padding\"><div class=\"contact-info position-address\"><div><span class=\"position\">{{detailCtrl.mail.position}}</span></div><div><span class=\"address\">12 Nezavisimosti st. Vilnius, Lithuania</span></div></div></div></div><div class=\"row\"></div><div class=\"line\"></div><div class=\"message-details\"><span class=\"subject\">{{detailCtrl.mail.subject}}</span> <span class=\"date\">• {{detailCtrl.mail.date | date : \'h:mm a MMMM d \'}}</span></div><div class=\"line\"></div><div ng-bind-html=\"detailCtrl.mail.body\" class=\"message-body\"></div><div class=\"line\"></div><div class=\"attachment\" ng-show=\"detailCtrl.mail.attachment\"><span class=\"file-links\">1 Attachment - <a href=\"\">View</a> | <a href=\"\">Download</a></span><div><i class=\"file-icon ion-document\"></i> <span class=\"file-name\">{{detailCtrl.mail.attachment}}</span></div></div><div class=\"line\" ng-show=\"detailCtrl.mail.attachment\"></div><div class=\"answer-container\"><button type=\"button\" class=\"btn btn-with-icon\" ng-click=\"tabCtrl.showCompose(detailCtrl.mail.subject,detailCtrl.mail.email,\'\')\"><i class=\"ion-reply\"></i>Reply</button> <button type=\"button\" class=\"btn btn-with-icon\" ng-click=\"tabCtrl.showCompose(detailCtrl.mail.subject,\'\',detailCtrl.mail.body)\"><i class=\"ion-forward\"></i>Forward</button> <button type=\"button\" class=\"btn btn-with-icon\"><i class=\"ion-printer\"></i>Print</button> <button type=\"button\" class=\"btn btn-with-icon\"><i class=\"ion-android-remove-circle\"></i>Spam</button> <button type=\"button\" class=\"btn btn-with-icon\"><i class=\"ion-android-delete\"></i>Delete</button></div></div><div ng-show=\"!detailCtrl.mail\"><h5 ng-class=\"text-center\">Nothing to show</h5></div></div>");
$templateCache.put("app/pages/components/mail/list/mailList.html","<div class=\"side-message-navigation\" ng-class=\"{\'expanded\': tabCtrl.navigationCollapsed}\"><div class=\"mail-messages-control side-message-navigation-item\"><div class=\"toggle-navigation-container\"><a href=\"\" class=\"collapse-navigation-link ion-navicon\" ng-click=\"tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed\"></a></div><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"inlineCheckbox01\" value=\"option1\"> <span class=\"select-all-label\">Select All</span></label> <button type=\"button\" class=\"btn btn-icon refresh-button\"><i class=\"ion-refresh\"></i></button><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn more-button\" uib-dropdown-toggle=\"\">More <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"messages\"><table><tr ng-repeat=\"m in listCtrl.messages track by m.id | orderBy:\'-date\'\" class=\"side-message-navigation-item little-human shineHover {{m.tag}}\"><td class=\"check-td\"><div class=\"mail-checkbox\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\"> <span></span></label></div></td><td class=\"photo-td\" ui-sref=\"components.mail.detail({id: m.id, label: listCtrl.label})\"><img ng-src=\"{{m.name.split(\' \')[0] | profilePicture}}\" class=\"little-human-picture\"></td><td ui-sref=\"components.mail.detail({id: m.id, label: listCtrl.label})\"><div class=\"name-container\"><div><span class=\"name\">{{m.name}}</span></div><div><span class=\"tag label label-primary {{m.tag}}\">{{m.tag}}</span></div></div></td><td ui-sref=\"components.mail.detail({id: m.id, label: listCtrl.label})\"><div class=\"additional-info\"><span class=\"subject\">{{m.subject}}</span></div></td><td ui-sref=\"components.mail.detail({id: m.id, label: listCtrl.label})\"><div class=\"mail-body-part\">{{m.body | plainText}}</div></td><td class=\"date\"><span>{{m.date | date : \'MMM d HH:mm\'}}</span></td></tr></table></div></div>");}]);